"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ral = exports.pantone = void 0;
const colorLibrary = {
  pantone: [{
    name: 'Yellow C',
    rgb: {
      r: 254,
      g: 221,
      b: 0
    }
  }, {
    name: 'Yellow 012 C',
    rgb: {
      r: 255,
      g: 215,
      b: 0
    }
  }, {
    name: 'Orange 021 C',
    rgb: {
      r: 254,
      g: 80,
      b: 0
    }
  }, {
    name: 'Warm Red C',
    rgb: {
      r: 249,
      g: 66,
      b: 58
    }
  }, {
    name: 'Red 032 C',
    rgb: {
      r: 239,
      g: 51,
      b: 64
    }
  }, {
    name: 'Rubine Red C',
    rgb: {
      r: 206,
      g: 0,
      b: 88
    }
  }, {
    name: 'Rhodamine Red C',
    rgb: {
      r: 225,
      g: 0,
      b: 152
    }
  }, {
    name: 'Purple C',
    rgb: {
      r: 187,
      g: 41,
      b: 187
    }
  }, {
    name: 'Violet C',
    rgb: {
      r: 68,
      g: 0,
      b: 153
    }
  }, {
    name: 'Blue 072 C',
    rgb: {
      r: 16,
      g: 6,
      b: 159
    }
  }, {
    name: 'Reflex Blue C',
    rgb: {
      r: 0,
      g: 20,
      b: 137
    }
  }, {
    name: 'Process Blue C',
    rgb: {
      r: 0,
      g: 133,
      b: 202
    }
  }, {
    name: 'Green C',
    rgb: {
      r: 0,
      g: 171,
      b: 132
    }
  }, {
    name: 'Black C',
    rgb: {
      r: 45,
      g: 41,
      b: 38
    }
  }, {
    name: 'Yellow 0131 C',
    rgb: {
      r: 242,
      g: 240,
      b: 161
    }
  }, {
    name: 'Red 0331 C',
    rgb: {
      r: 252,
      g: 174,
      b: 187
    }
  }, {
    name: 'Magenta 0521 C',
    rgb: {
      r: 241,
      g: 178,
      b: 220
    }
  }, {
    name: 'Violet 0631 C',
    rgb: {
      r: 191,
      g: 155,
      b: 222
    }
  }, {
    name: 'Blue 0821 C',
    rgb: {
      r: 116,
      g: 209,
      b: 234
    }
  }, {
    name: 'Green 0921 C',
    rgb: {
      r: 157,
      g: 231,
      b: 215
    }
  }, {
    name: 'Black 0961 C',
    rgb: {
      r: 158,
      g: 151,
      b: 142
    }
  }, {
    name: '801 C',
    rgb: {
      r: 0,
      g: 154,
      b: 206
    }
  }, {
    name: '802 C',
    rgb: {
      r: 68,
      g: 214,
      b: 44
    }
  }, {
    name: '803 C',
    rgb: {
      r: 255,
      g: 233,
      b: 0
    }
  }, {
    name: '804 C',
    rgb: {
      r: 255,
      g: 170,
      b: 77
    }
  }, {
    name: '805 C',
    rgb: {
      r: 255,
      g: 114,
      b: 118
    }
  }, {
    name: '806 C',
    rgb: {
      r: 255,
      g: 62,
      b: 181
    }
  }, {
    name: '807 C',
    rgb: {
      r: 234,
      g: 39,
      b: 194
    }
  }, {
    name: '871 C',
    rgb: {
      r: 132,
      g: 117,
      b: 78
    }
  }, {
    name: '872 C',
    rgb: {
      r: 133,
      g: 113,
      b: 77
    }
  }, {
    name: '873 C',
    rgb: {
      r: 134,
      g: 109,
      b: 75
    }
  }, {
    name: '874 C',
    rgb: {
      r: 139,
      g: 111,
      b: 78
    }
  }, {
    name: '875 C',
    rgb: {
      r: 135,
      g: 103,
      b: 79
    }
  }, {
    name: '876 C',
    rgb: {
      r: 139,
      g: 99,
      b: 75
    }
  }, {
    name: '877 C',
    rgb: {
      r: 138,
      g: 141,
      b: 143
    }
  }, {
    name: 'Medium Yellow C',
    rgb: {
      r: 255,
      g: 217,
      b: 0
    }
  }, {
    name: 'Bright Orange C',
    rgb: {
      r: 255,
      g: 94,
      b: 0
    }
  }, {
    name: 'Bright Red C',
    rgb: {
      r: 249,
      g: 56,
      b: 34
    }
  }, {
    name: 'Strong Red C',
    rgb: {
      r: 206,
      g: 0,
      b: 86
    }
  }, {
    name: 'Pink C',
    rgb: {
      r: 214,
      g: 37,
      b: 152
    }
  }, {
    name: 'Medium Purple C',
    rgb: {
      r: 78,
      g: 0,
      b: 142
    }
  }, {
    name: 'Dark Blue C',
    rgb: {
      r: 0,
      g: 35,
      b: 156
    }
  }, {
    name: 'Medium Blue C',
    rgb: {
      r: 0,
      g: 132,
      b: 202
    }
  }, {
    name: 'Bright Green C',
    rgb: {
      r: 0,
      g: 176,
      b: 139
    }
  }, {
    name: 'Neutral Black C',
    rgb: {
      r: 34,
      g: 34,
      b: 35
    }
  }, {
    name: '100 C',
    rgb: {
      r: 246,
      g: 235,
      b: 97
    }
  }, {
    name: '101 C',
    rgb: {
      r: 247,
      g: 234,
      b: 72
    }
  }, {
    name: '102 C',
    rgb: {
      r: 252,
      g: 227,
      b: 0
    }
  }, {
    name: '103 C',
    rgb: {
      r: 197,
      g: 169,
      b: 0
    }
  }, {
    name: '104 C',
    rgb: {
      r: 175,
      g: 152,
      b: 0
    }
  }, {
    name: '105 C',
    rgb: {
      r: 137,
      g: 122,
      b: 39
    }
  }, {
    name: '7401 C',
    rgb: {
      r: 245,
      g: 225,
      b: 164
    }
  }, {
    name: '7402 C',
    rgb: {
      r: 236,
      g: 216,
      b: 152
    }
  }, {
    name: '7403 C',
    rgb: {
      r: 238,
      g: 212,
      b: 132
    }
  }, {
    name: '7404 C',
    rgb: {
      r: 244,
      g: 218,
      b: 64
    }
  }, {
    name: '7405 C',
    rgb: {
      r: 242,
      g: 205,
      b: 0
    }
  }, {
    name: '7406 C',
    rgb: {
      r: 241,
      g: 196,
      b: 0
    }
  }, {
    name: '7407 C',
    rgb: {
      r: 203,
      g: 160,
      b: 82
    }
  }, {
    name: '106 C',
    rgb: {
      r: 249,
      g: 229,
      b: 71
    }
  }, {
    name: '107 C',
    rgb: {
      r: 251,
      g: 225,
      b: 34
    }
  }, {
    name: '108 C',
    rgb: {
      r: 254,
      g: 219,
      b: 0
    }
  }, {
    name: '109 C',
    rgb: {
      r: 255,
      g: 209,
      b: 0
    }
  }, {
    name: '110 C',
    rgb: {
      r: 218,
      g: 170,
      b: 0
    }
  }, {
    name: '111 C',
    rgb: {
      r: 170,
      g: 138,
      b: 0
    }
  }, {
    name: '112 C',
    rgb: {
      r: 156,
      g: 132,
      b: 18
    }
  }, {
    name: '113 C',
    rgb: {
      r: 250,
      g: 224,
      b: 83
    }
  }, {
    name: '114 C',
    rgb: {
      r: 251,
      g: 221,
      b: 64
    }
  }, {
    name: '115 C',
    rgb: {
      r: 253,
      g: 218,
      b: 36
    }
  }, {
    name: '116 C',
    rgb: {
      r: 255,
      g: 205,
      b: 0
    }
  }, {
    name: '117 C',
    rgb: {
      r: 201,
      g: 151,
      b: 0
    }
  }, {
    name: '118 C',
    rgb: {
      r: 172,
      g: 132,
      b: 0
    }
  }, {
    name: '119 C',
    rgb: {
      r: 137,
      g: 115,
      b: 34
    }
  }, {
    name: '127 C',
    rgb: {
      r: 243,
      g: 221,
      b: 109
    }
  }, {
    name: '128 C',
    rgb: {
      r: 243,
      g: 213,
      b: 78
    }
  }, {
    name: '129 C',
    rgb: {
      r: 243,
      g: 208,
      b: 62
    }
  }, {
    name: '130 C',
    rgb: {
      r: 242,
      g: 169,
      b: 0
    }
  }, {
    name: '131 C',
    rgb: {
      r: 204,
      g: 138,
      b: 0
    }
  }, {
    name: '132 C',
    rgb: {
      r: 160,
      g: 116,
      b: 0
    }
  }, {
    name: '133 C',
    rgb: {
      r: 108,
      g: 87,
      b: 27
    }
  }, {
    name: '1205 C',
    rgb: {
      r: 248,
      g: 224,
      b: 142
    }
  }, {
    name: '1215 C',
    rgb: {
      r: 251,
      g: 216,
      b: 114
    }
  }, {
    name: '1225 C',
    rgb: {
      r: 255,
      g: 200,
      b: 69
    }
  }, {
    name: '1235 C',
    rgb: {
      r: 255,
      g: 184,
      b: 28
    }
  }, {
    name: '1245 C',
    rgb: {
      r: 198,
      g: 146,
      b: 20
    }
  }, {
    name: '1255 C',
    rgb: {
      r: 173,
      g: 132,
      b: 31
    }
  }, {
    name: '1265 C',
    rgb: {
      r: 136,
      g: 107,
      b: 37
    }
  }, {
    name: '120 C',
    rgb: {
      r: 251,
      g: 219,
      b: 101
    }
  }, {
    name: '121 C',
    rgb: {
      r: 253,
      g: 215,
      b: 87
    }
  }, {
    name: '122 C',
    rgb: {
      r: 254,
      g: 209,
      b: 65
    }
  }, {
    name: '123 C',
    rgb: {
      r: 255,
      g: 199,
      b: 44
    }
  }, {
    name: '124 C',
    rgb: {
      r: 234,
      g: 170,
      b: 0
    }
  }, {
    name: '125 C',
    rgb: {
      r: 181,
      g: 133,
      b: 0
    }
  }, {
    name: '126 C',
    rgb: {
      r: 154,
      g: 118,
      b: 17
    }
  }, {
    name: '7548 C',
    rgb: {
      r: 255,
      g: 198,
      b: 0
    }
  }, {
    name: '7549 C',
    rgb: {
      r: 255,
      g: 181,
      b: 0
    }
  }, {
    name: '7550 C',
    rgb: {
      r: 209,
      g: 144,
      b: 0
    }
  }, {
    name: '7551 C',
    rgb: {
      r: 180,
      g: 126,
      b: 0
    }
  }, {
    name: '7552 C',
    rgb: {
      r: 115,
      g: 83,
      b: 29
    }
  }, {
    name: '7553 C',
    rgb: {
      r: 90,
      g: 69,
      b: 34
    }
  }, {
    name: '7554 C',
    rgb: {
      r: 75,
      g: 61,
      b: 42
    }
  }, {
    name: '7555 C',
    rgb: {
      r: 210,
      g: 159,
      b: 19
    }
  }, {
    name: '7556 C',
    rgb: {
      r: 183,
      g: 139,
      b: 32
    }
  }, {
    name: '7557 C',
    rgb: {
      r: 159,
      g: 125,
      b: 35
    }
  }, {
    name: '7558 C',
    rgb: {
      r: 150,
      g: 113,
      b: 38
    }
  }, {
    name: '7559 C',
    rgb: {
      r: 143,
      g: 106,
      b: 42
    }
  }, {
    name: '7560 C',
    rgb: {
      r: 125,
      g: 98,
      b: 46
    }
  }, {
    name: '7561 C',
    rgb: {
      r: 108,
      g: 93,
      b: 52
    }
  }, {
    name: '134 C',
    rgb: {
      r: 253,
      g: 210,
      b: 110
    }
  }, {
    name: '135 C',
    rgb: {
      r: 255,
      g: 198,
      b: 88
    }
  }, {
    name: '136 C',
    rgb: {
      r: 255,
      g: 191,
      b: 63
    }
  }, {
    name: '137 C',
    rgb: {
      r: 255,
      g: 163,
      b: 0
    }
  }, {
    name: '138 C',
    rgb: {
      r: 222,
      g: 124,
      b: 0
    }
  }, {
    name: '139 C',
    rgb: {
      r: 175,
      g: 109,
      b: 4
    }
  }, {
    name: '140 C',
    rgb: {
      r: 116,
      g: 83,
      b: 28
    }
  }, {
    name: '1345 C',
    rgb: {
      r: 253,
      g: 208,
      b: 134
    }
  }, {
    name: '1355 C',
    rgb: {
      r: 255,
      g: 197,
      b: 110
    }
  }, {
    name: '1365 C',
    rgb: {
      r: 255,
      g: 181,
      b: 73
    }
  }, {
    name: '1375 C',
    rgb: {
      r: 255,
      g: 158,
      b: 27
    }
  }, {
    name: '1385 C',
    rgb: {
      r: 213,
      g: 120,
      b: 0
    }
  }, {
    name: '1395 C',
    rgb: {
      r: 153,
      g: 96,
      b: 23
    }
  }, {
    name: '1405 C',
    rgb: {
      r: 110,
      g: 76,
      b: 30
    }
  }, {
    name: '141 C',
    rgb: {
      r: 242,
      g: 199,
      b: 92
    }
  }, {
    name: '142 C',
    rgb: {
      r: 241,
      g: 190,
      b: 72
    }
  }, {
    name: '143 C',
    rgb: {
      r: 241,
      g: 180,
      b: 52
    }
  }, {
    name: '144 C',
    rgb: {
      r: 237,
      g: 139,
      b: 0
    }
  }, {
    name: '145 C',
    rgb: {
      r: 207,
      g: 127,
      b: 0
    }
  }, {
    name: '146 C',
    rgb: {
      r: 167,
      g: 109,
      b: 17
    }
  }, {
    name: '147 C',
    rgb: {
      r: 113,
      g: 92,
      b: 42
    }
  }, {
    name: '7408 C',
    rgb: {
      r: 246,
      g: 190,
      b: 0
    }
  }, {
    name: '7409 C',
    rgb: {
      r: 240,
      g: 179,
      b: 35
    }
  }, {
    name: '7410 C',
    rgb: {
      r: 254,
      g: 173,
      b: 119
    }
  }, {
    name: '7411 C',
    rgb: {
      r: 230,
      g: 166,
      b: 93
    }
  }, {
    name: '7412 C',
    rgb: {
      r: 211,
      g: 130,
      b: 53
    }
  }, {
    name: '7413 C',
    rgb: {
      r: 220,
      g: 134,
      b: 51
    }
  }, {
    name: '7414 C',
    rgb: {
      r: 193,
      g: 108,
      b: 24
    }
  }, {
    name: '7562 C',
    rgb: {
      r: 189,
      g: 155,
      b: 96
    }
  }, {
    name: '7563 C',
    rgb: {
      r: 214,
      g: 154,
      b: 45
    }
  }, {
    name: '7564 C',
    rgb: {
      r: 219,
      g: 138,
      b: 6
    }
  }, {
    name: '7565 C',
    rgb: {
      r: 205,
      g: 121,
      b: 37
    }
  }, {
    name: '7566 C',
    rgb: {
      r: 173,
      g: 100,
      b: 51
    }
  }, {
    name: '7567 C',
    rgb: {
      r: 137,
      g: 83,
      b: 47
    }
  }, {
    name: '7568 C',
    rgb: {
      r: 119,
      g: 81,
      b: 53
    }
  }, {
    name: '7569 C',
    rgb: {
      r: 215,
      g: 136,
      b: 37
    }
  }, {
    name: '7570 C',
    rgb: {
      r: 211,
      g: 131,
      b: 43
    }
  }, {
    name: '7571 C',
    rgb: {
      r: 198,
      g: 125,
      b: 48
    }
  }, {
    name: '7572 C',
    rgb: {
      r: 182,
      g: 114,
      b: 51
    }
  }, {
    name: '7573 C',
    rgb: {
      r: 167,
      g: 102,
      b: 43
    }
  }, {
    name: '7574 C',
    rgb: {
      r: 158,
      g: 106,
      b: 56
    }
  }, {
    name: '7575 C',
    rgb: {
      r: 131,
      g: 93,
      b: 50
    }
  }, {
    name: '712 C',
    rgb: {
      r: 252,
      g: 200,
      b: 155
    }
  }, {
    name: '713 C',
    rgb: {
      r: 253,
      g: 190,
      b: 135
    }
  }, {
    name: '714 C',
    rgb: {
      r: 253,
      g: 170,
      b: 99
    }
  }, {
    name: '715 C',
    rgb: {
      r: 246,
      g: 141,
      b: 46
    }
  }, {
    name: '716 C',
    rgb: {
      r: 234,
      g: 118,
      b: 0
    }
  }, {
    name: '717 C',
    rgb: {
      r: 212,
      g: 93,
      b: 0
    }
  }, {
    name: '718 C',
    rgb: {
      r: 190,
      g: 77,
      b: 0
    }
  }, {
    name: '148 C',
    rgb: {
      r: 254,
      g: 203,
      b: 139
    }
  }, {
    name: '149 C',
    rgb: {
      r: 255,
      g: 194,
      b: 123
    }
  }, {
    name: '150 C',
    rgb: {
      r: 255,
      g: 178,
      b: 91
    }
  }, {
    name: '151 C',
    rgb: {
      r: 255,
      g: 130,
      b: 0
    }
  }, {
    name: '152 C',
    rgb: {
      r: 229,
      g: 114,
      b: 0
    }
  }, {
    name: '153 C',
    rgb: {
      r: 190,
      g: 106,
      b: 20
    }
  }, {
    name: '154 C',
    rgb: {
      r: 155,
      g: 90,
      b: 26
    }
  }, {
    name: '155 C',
    rgb: {
      r: 239,
      g: 209,
      b: 159
    }
  }, {
    name: '156 C',
    rgb: {
      r: 239,
      g: 190,
      b: 125
    }
  }, {
    name: '157 C',
    rgb: {
      r: 236,
      g: 161,
      b: 84
    }
  }, {
    name: '158 C',
    rgb: {
      r: 232,
      g: 119,
      b: 34
    }
  }, {
    name: '159 C',
    rgb: {
      r: 203,
      g: 96,
      b: 21
    }
  }, {
    name: '160 C',
    rgb: {
      r: 161,
      g: 86,
      b: 28
    }
  }, {
    name: '161 C',
    rgb: {
      r: 96,
      g: 61,
      b: 32
    }
  }, {
    name: '1485 C',
    rgb: {
      r: 255,
      g: 174,
      b: 98
    }
  }, {
    name: '1495 C',
    rgb: {
      r: 255,
      g: 143,
      b: 28
    }
  }, {
    name: '1505 C',
    rgb: {
      r: 255,
      g: 105,
      b: 0
    }
  }, {
    name: '1525 C',
    rgb: {
      r: 185,
      g: 71,
      b: 0
    }
  }, {
    name: '1535 C',
    rgb: {
      r: 148,
      g: 69,
      b: 11
    }
  }, {
    name: '1545 C',
    rgb: {
      r: 101,
      g: 56,
      b: 25
    }
  }, {
    name: '1555 C',
    rgb: {
      r: 255,
      g: 185,
      b: 144
    }
  }, {
    name: '1565 C',
    rgb: {
      r: 255,
      g: 160,
      b: 106
    }
  }, {
    name: '1575 C',
    rgb: {
      r: 255,
      g: 127,
      b: 50
    }
  }, {
    name: '1585 C',
    rgb: {
      r: 255,
      g: 106,
      b: 19
    }
  }, {
    name: '1595 C',
    rgb: {
      r: 216,
      g: 96,
      b: 24
    }
  }, {
    name: '1605 C',
    rgb: {
      r: 166,
      g: 85,
      b: 35
    }
  }, {
    name: '1615 C',
    rgb: {
      r: 139,
      g: 71,
      b: 32
    }
  }, {
    name: '162 C',
    rgb: {
      r: 255,
      g: 190,
      b: 159
    }
  }, {
    name: '163 C',
    rgb: {
      r: 255,
      g: 157,
      b: 110
    }
  }, {
    name: '164 C',
    rgb: {
      r: 255,
      g: 127,
      b: 65
    }
  }, {
    name: '165 C',
    rgb: {
      r: 255,
      g: 103,
      b: 31
    }
  }, {
    name: '166 C',
    rgb: {
      r: 227,
      g: 82,
      b: 5
    }
  }, {
    name: '167 C',
    rgb: {
      r: 190,
      g: 83,
      b: 28
    }
  }, {
    name: '168 C',
    rgb: {
      r: 115,
      g: 56,
      b: 29
    }
  }, {
    name: '7576 C',
    rgb: {
      r: 219,
      g: 134,
      b: 78
    }
  }, {
    name: '7577 C',
    rgb: {
      r: 224,
      g: 126,
      b: 60
    }
  }, {
    name: '7578 C',
    rgb: {
      r: 220,
      g: 107,
      b: 47
    }
  }, {
    name: '7579 C',
    rgb: {
      r: 220,
      g: 88,
      b: 42
    }
  }, {
    name: '7580 C',
    rgb: {
      r: 192,
      g: 81,
      b: 49
    }
  }, {
    name: '7581 C',
    rgb: {
      r: 134,
      g: 74,
      b: 51
    }
  }, {
    name: '7582 C',
    rgb: {
      r: 103,
      g: 71,
      b: 54
    }
  }, {
    name: '1625 C',
    rgb: {
      r: 255,
      g: 163,
      b: 139
    }
  }, {
    name: '1635 C',
    rgb: {
      r: 255,
      g: 141,
      b: 109
    }
  }, {
    name: '1645 C',
    rgb: {
      r: 255,
      g: 106,
      b: 57
    }
  }, {
    name: '1655 C',
    rgb: {
      r: 252,
      g: 76,
      b: 2
    }
  }, {
    name: '1665 C',
    rgb: {
      r: 220,
      g: 68,
      b: 5
    }
  }, {
    name: '1675 C',
    rgb: {
      r: 169,
      g: 67,
      b: 30
    }
  }, {
    name: '1685 C',
    rgb: {
      r: 131,
      g: 57,
      b: 33
    }
  }, {
    name: '169 C',
    rgb: {
      r: 255,
      g: 179,
      b: 171
    }
  }, {
    name: '170 C',
    rgb: {
      r: 255,
      g: 134,
      b: 116
    }
  }, {
    name: '171 C',
    rgb: {
      r: 255,
      g: 92,
      b: 57
    }
  }, {
    name: '172 C',
    rgb: {
      r: 250,
      g: 70,
      b: 22
    }
  }, {
    name: '173 C',
    rgb: {
      r: 207,
      g: 69,
      b: 32
    }
  }, {
    name: '174 C',
    rgb: {
      r: 150,
      g: 56,
      b: 33
    }
  }, {
    name: '175 C',
    rgb: {
      r: 107,
      g: 53,
      b: 41
    }
  }, {
    name: '7583 C',
    rgb: {
      r: 196,
      g: 98,
      b: 45
    }
  }, {
    name: '7584 C',
    rgb: {
      r: 186,
      g: 88,
      b: 38
    }
  }, {
    name: '7585 C',
    rgb: {
      r: 175,
      g: 92,
      b: 55
    }
  }, {
    name: '7586 C',
    rgb: {
      r: 158,
      g: 83,
      b: 48
    }
  }, {
    name: '7587 C',
    rgb: {
      r: 146,
      g: 76,
      b: 46
    }
  }, {
    name: '7588 C',
    rgb: {
      r: 123,
      g: 77,
      b: 53
    }
  }, {
    name: '7589 C',
    rgb: {
      r: 92,
      g: 71,
      b: 56
    }
  }, {
    name: '7590 C',
    rgb: {
      r: 212,
      g: 181,
      b: 158
    }
  }, {
    name: '7591 C',
    rgb: {
      r: 192,
      g: 125,
      b: 89
    }
  }, {
    name: '7592 C',
    rgb: {
      r: 177,
      g: 85,
      b: 51
    }
  }, {
    name: '7593 C',
    rgb: {
      r: 157,
      g: 67,
      b: 44
    }
  }, {
    name: '7594 C',
    rgb: {
      r: 124,
      g: 58,
      b: 45
    }
  }, {
    name: '7595 C',
    rgb: {
      r: 107,
      g: 61,
      b: 46
    }
  }, {
    name: '7596 C',
    rgb: {
      r: 92,
      g: 61,
      b: 49
    }
  }, {
    name: '7597 C',
    rgb: {
      r: 209,
      g: 65,
      b: 36
    }
  }, {
    name: '7598 C',
    rgb: {
      r: 189,
      g: 71,
      b: 42
    }
  }, {
    name: '7599 C',
    rgb: {
      r: 179,
      g: 61,
      b: 38
    }
  }, {
    name: '7600 C',
    rgb: {
      r: 141,
      g: 63,
      b: 43
    }
  }, {
    name: '7601 C',
    rgb: {
      r: 131,
      g: 65,
      b: 44
    }
  }, {
    name: '7602 C',
    rgb: {
      r: 123,
      g: 73,
      b: 49
    }
  }, {
    name: '7603 C',
    rgb: {
      r: 103,
      g: 66,
      b: 48
    }
  }, {
    name: '7604 C',
    rgb: {
      r: 228,
      g: 213,
      b: 211
    }
  }, {
    name: '7605 C',
    rgb: {
      r: 225,
      g: 187,
      b: 180
    }
  }, {
    name: '7606 C',
    rgb: {
      r: 214,
      g: 147,
      b: 138
    }
  }, {
    name: '7607 C',
    rgb: {
      r: 194,
      g: 110,
      b: 96
    }
  }, {
    name: '7608 C',
    rgb: {
      r: 164,
      g: 73,
      b: 61
    }
  }, {
    name: '7609 C',
    rgb: {
      r: 130,
      g: 59,
      b: 52
    }
  }, {
    name: '7610 C',
    rgb: {
      r: 104,
      g: 52,
      b: 49
    }
  }, {
    name: '7611 C',
    rgb: {
      r: 221,
      g: 188,
      b: 176
    }
  }, {
    name: '7612 C',
    rgb: {
      r: 202,
      g: 154,
      b: 142
    }
  }, {
    name: '7613 C',
    rgb: {
      r: 188,
      g: 138,
      b: 126
    }
  }, {
    name: '7614 C',
    rgb: {
      r: 163,
      g: 127,
      b: 116
    }
  }, {
    name: '7615 C',
    rgb: {
      r: 134,
      g: 103,
      b: 97
    }
  }, {
    name: '7616 C',
    rgb: {
      r: 107,
      g: 76,
      b: 76
    }
  }, {
    name: '7617 C',
    rgb: {
      r: 88,
      g: 61,
      b: 62
    }
  }, {
    name: '7520 C',
    rgb: {
      r: 234,
      g: 190,
      b: 176
    }
  }, {
    name: '7521 C',
    rgb: {
      r: 192,
      g: 156,
      b: 131
    }
  }, {
    name: '7522 C',
    rgb: {
      r: 180,
      g: 106,
      b: 85
    }
  }, {
    name: '7523 C',
    rgb: {
      r: 171,
      g: 92,
      b: 87
    }
  }, {
    name: '7524 C',
    rgb: {
      r: 164,
      g: 82,
      b: 72
    }
  }, {
    name: '7525 C',
    rgb: {
      r: 154,
      g: 106,
      b: 79
    }
  }, {
    name: '7526 C',
    rgb: {
      r: 138,
      g: 57,
      b: 27
    }
  }, {
    name: '489 C',
    rgb: {
      r: 236,
      g: 195,
      b: 178
    }
  }, {
    name: '488 C',
    rgb: {
      r: 236,
      g: 186,
      b: 168
    }
  }, {
    name: '487 C',
    rgb: {
      r: 234,
      g: 167,
      b: 148
    }
  }, {
    name: '486 C',
    rgb: {
      r: 232,
      g: 146,
      b: 124
    }
  }, {
    name: '485 C',
    rgb: {
      r: 218,
      g: 41,
      b: 28
    }
  }, {
    name: '484 C',
    rgb: {
      r: 154,
      g: 51,
      b: 36
    }
  }, {
    name: '483 C',
    rgb: {
      r: 101,
      g: 48,
      b: 36
    }
  }, {
    name: '176 C',
    rgb: {
      r: 255,
      g: 177,
      b: 187
    }
  }, {
    name: '177 C',
    rgb: {
      r: 255,
      g: 128,
      b: 139
    }
  }, {
    name: '178 C',
    rgb: {
      r: 255,
      g: 88,
      b: 93
    }
  }, {
    name: '179 C',
    rgb: {
      r: 224,
      g: 60,
      b: 49
    }
  }, {
    name: '180 C',
    rgb: {
      r: 190,
      g: 58,
      b: 52
    }
  }, {
    name: '181 C',
    rgb: {
      r: 129,
      g: 49,
      b: 47
    }
  }, {
    name: '1765 C',
    rgb: {
      r: 255,
      g: 163,
      b: 181
    }
  }, {
    name: '1775 C',
    rgb: {
      r: 255,
      g: 141,
      b: 161
    }
  }, {
    name: '1785 C',
    rgb: {
      r: 248,
      g: 72,
      b: 94
    }
  }, {
    name: '1788 C',
    rgb: {
      r: 238,
      g: 39,
      b: 55
    }
  }, {
    name: '1795 C',
    rgb: {
      r: 210,
      g: 38,
      b: 48
    }
  }, {
    name: '1805 C',
    rgb: {
      r: 175,
      g: 39,
      b: 47
    }
  }, {
    name: '1815 C',
    rgb: {
      r: 124,
      g: 37,
      b: 41
    }
  }, {
    name: '1767 C',
    rgb: {
      r: 252,
      g: 175,
      b: 192
    }
  }, {
    name: '1777 C',
    rgb: {
      r: 251,
      g: 99,
      b: 126
    }
  }, {
    name: '1787 C',
    rgb: {
      r: 244,
      g: 54,
      b: 76
    }
  }, {
    name: '1797 C',
    rgb: {
      r: 203,
      g: 51,
      b: 59
    }
  }, {
    name: '1807 C',
    rgb: {
      r: 164,
      g: 52,
      b: 58
    }
  }, {
    name: '1817 C',
    rgb: {
      r: 100,
      g: 51,
      b: 53
    }
  }, {
    name: '7618 C',
    rgb: {
      r: 198,
      g: 110,
      b: 78
    }
  }, {
    name: '7619 C',
    rgb: {
      r: 192,
      g: 76,
      b: 54
    }
  }, {
    name: '7620 C',
    rgb: {
      r: 183,
      g: 49,
      b: 44
    }
  }, {
    name: '7621 C',
    rgb: {
      r: 171,
      g: 35,
      b: 40
    }
  }, {
    name: '7622 C',
    rgb: {
      r: 147,
      g: 39,
      b: 44
    }
  }, {
    name: '7623 C',
    rgb: {
      r: 138,
      g: 42,
      b: 43
    }
  }, {
    name: '7624 C',
    rgb: {
      r: 128,
      g: 47,
      b: 45
    }
  }, {
    name: '7625 C',
    rgb: {
      r: 225,
      g: 82,
      b: 61
    }
  }, {
    name: '7626 C',
    rgb: {
      r: 198,
      g: 53,
      b: 39
    }
  }, {
    name: '7627 C',
    rgb: {
      r: 167,
      g: 43,
      b: 42
    }
  }, {
    name: '7628 C',
    rgb: {
      r: 158,
      g: 42,
      b: 43
    }
  }, {
    name: '7629 C',
    rgb: {
      r: 109,
      g: 51,
      b: 50
    }
  }, {
    name: '7630 C',
    rgb: {
      r: 99,
      g: 50,
      b: 49
    }
  }, {
    name: '7631 C',
    rgb: {
      r: 87,
      g: 45,
      b: 45
    }
  }, {
    name: '7415 C',
    rgb: {
      r: 230,
      g: 186,
      b: 168
    }
  }, {
    name: '7416 C',
    rgb: {
      r: 229,
      g: 106,
      b: 84
    }
  }, {
    name: '7417 C',
    rgb: {
      r: 224,
      g: 78,
      b: 57
    }
  }, {
    name: '7418 C',
    rgb: {
      r: 205,
      g: 84,
      b: 91
    }
  }, {
    name: '7419 C',
    rgb: {
      r: 176,
      g: 74,
      b: 90
    }
  }, {
    name: '7420 C',
    rgb: {
      r: 155,
      g: 34,
      b: 66
    }
  }, {
    name: '7421 C',
    rgb: {
      r: 101,
      g: 29,
      b: 50
    }
  }, {
    name: '182 C',
    rgb: {
      r: 250,
      g: 187,
      b: 203
    }
  }, {
    name: '183 C',
    rgb: {
      r: 252,
      g: 155,
      b: 179
    }
  }, {
    name: '184 C',
    rgb: {
      r: 246,
      g: 82,
      b: 117
    }
  }, {
    name: '185 C',
    rgb: {
      r: 228,
      g: 0,
      b: 43
    }
  }, {
    name: '186 C',
    rgb: {
      r: 200,
      g: 16,
      b: 46
    }
  }, {
    name: '187 C',
    rgb: {
      r: 166,
      g: 25,
      b: 46
    }
  }, {
    name: '188 C',
    rgb: {
      r: 118,
      g: 35,
      b: 47
    }
  }, {
    name: '196 C',
    rgb: {
      r: 236,
      g: 199,
      b: 205
    }
  }, {
    name: '197 C',
    rgb: {
      r: 232,
      g: 156,
      b: 174
    }
  }, {
    name: '198 C',
    rgb: {
      r: 223,
      g: 70,
      b: 97
    }
  }, {
    name: '199 C',
    rgb: {
      r: 213,
      g: 0,
      b: 50
    }
  }, {
    name: '200 C',
    rgb: {
      r: 186,
      g: 12,
      b: 47
    }
  }, {
    name: '201 C',
    rgb: {
      r: 157,
      g: 34,
      b: 53
    }
  }, {
    name: '202 C',
    rgb: {
      r: 134,
      g: 38,
      b: 51
    }
  }, {
    name: '189 C',
    rgb: {
      r: 248,
      g: 163,
      b: 188
    }
  }, {
    name: '190 C',
    rgb: {
      r: 246,
      g: 117,
      b: 153
    }
  }, {
    name: '191 C',
    rgb: {
      r: 239,
      g: 66,
      b: 111
    }
  }, {
    name: '192 C',
    rgb: {
      r: 228,
      g: 0,
      b: 70
    }
  }, {
    name: '193 C',
    rgb: {
      r: 191,
      g: 13,
      b: 62
    }
  }, {
    name: '194 C',
    rgb: {
      r: 155,
      g: 39,
      b: 67
    }
  }, {
    name: '195 C',
    rgb: {
      r: 120,
      g: 47,
      b: 64
    }
  }, {
    name: '1895 C',
    rgb: {
      r: 245,
      g: 182,
      b: 205
    }
  }, {
    name: '1905 C',
    rgb: {
      r: 245,
      g: 155,
      b: 187
    }
  }, {
    name: '1915 C',
    rgb: {
      r: 239,
      g: 74,
      b: 129
    }
  }, {
    name: '1925 C',
    rgb: {
      r: 224,
      g: 0,
      b: 77
    }
  }, {
    name: '1935 C',
    rgb: {
      r: 197,
      g: 0,
      b: 62
    }
  }, {
    name: '1945 C',
    rgb: {
      r: 166,
      g: 9,
      b: 61
    }
  }, {
    name: '1955 C',
    rgb: {
      r: 138,
      g: 21,
      b: 56
    }
  }, {
    name: '705 C',
    rgb: {
      r: 245,
      g: 218,
      b: 223
    }
  }, {
    name: '706 C',
    rgb: {
      r: 247,
      g: 206,
      b: 215
    }
  }, {
    name: '707 C',
    rgb: {
      r: 249,
      g: 181,
      b: 196
    }
  }, {
    name: '708 C',
    rgb: {
      r: 248,
      g: 144,
      b: 165
    }
  }, {
    name: '709 C',
    rgb: {
      r: 239,
      g: 96,
      b: 121
    }
  }, {
    name: '710 C',
    rgb: {
      r: 224,
      g: 62,
      b: 82
    }
  }, {
    name: '711 C',
    rgb: {
      r: 203,
      g: 44,
      b: 48
    }
  }, {
    name: '698 C',
    rgb: {
      r: 242,
      g: 212,
      b: 215
    }
  }, {
    name: '699 C',
    rgb: {
      r: 244,
      g: 195,
      b: 204
    }
  }, {
    name: '700 C',
    rgb: {
      r: 242,
      g: 172,
      b: 185
    }
  }, {
    name: '701 C',
    rgb: {
      r: 230,
      g: 134,
      b: 153
    }
  }, {
    name: '702 C',
    rgb: {
      r: 210,
      g: 91,
      b: 115
    }
  }, {
    name: '703 C',
    rgb: {
      r: 184,
      g: 58,
      b: 75
    }
  }, {
    name: '704 C',
    rgb: {
      r: 158,
      g: 42,
      b: 47
    }
  }, {
    name: '203 C',
    rgb: {
      r: 236,
      g: 179,
      b: 203
    }
  }, {
    name: '204 C',
    rgb: {
      r: 231,
      g: 130,
      b: 169
    }
  }, {
    name: '205 C',
    rgb: {
      r: 224,
      g: 69,
      b: 123
    }
  }, {
    name: '206 C',
    rgb: {
      r: 206,
      g: 0,
      b: 55
    }
  }, {
    name: '207 C',
    rgb: {
      r: 165,
      g: 0,
      b: 52
    }
  }, {
    name: '208 C',
    rgb: {
      r: 134,
      g: 31,
      b: 65
    }
  }, {
    name: '209 C',
    rgb: {
      r: 111,
      g: 38,
      b: 61
    }
  }, {
    name: '210 C',
    rgb: {
      r: 249,
      g: 159,
      b: 201
    }
  }, {
    name: '211 C',
    rgb: {
      r: 245,
      g: 126,
      b: 182
    }
  }, {
    name: '212 C',
    rgb: {
      r: 240,
      g: 78,
      b: 152
    }
  }, {
    name: '213 C',
    rgb: {
      r: 227,
      g: 28,
      b: 121
    }
  }, {
    name: '214 C',
    rgb: {
      r: 206,
      g: 15,
      b: 105
    }
  }, {
    name: '215 C',
    rgb: {
      r: 172,
      g: 20,
      b: 90
    }
  }, {
    name: '216 C',
    rgb: {
      r: 125,
      g: 34,
      b: 72
    }
  }, {
    name: '7422 C',
    rgb: {
      r: 244,
      g: 205,
      b: 212
    }
  }, {
    name: '7423 C',
    rgb: {
      r: 224,
      g: 98,
      b: 135
    }
  }, {
    name: '7424 C',
    rgb: {
      r: 226,
      g: 69,
      b: 133
    }
  }, {
    name: '7425 C',
    rgb: {
      r: 181,
      g: 37,
      b: 85
    }
  }, {
    name: '7426 C',
    rgb: {
      r: 164,
      g: 18,
      b: 63
    }
  }, {
    name: '7427 C',
    rgb: {
      r: 151,
      g: 27,
      b: 47
    }
  }, {
    name: '7428 C',
    rgb: {
      r: 106,
      g: 44,
      b: 62
    }
  }, {
    name: '7632 C',
    rgb: {
      r: 214,
      g: 201,
      b: 202
    }
  }, {
    name: '7633 C',
    rgb: {
      r: 196,
      g: 164,
      b: 167
    }
  }, {
    name: '7634 C',
    rgb: {
      r: 193,
      g: 103,
      b: 132
    }
  }, {
    name: '7635 C',
    rgb: {
      r: 198,
      g: 54,
      b: 99
    }
  }, {
    name: '7636 C',
    rgb: {
      r: 188,
      g: 32,
      b: 75
    }
  }, {
    name: '7637 C',
    rgb: {
      r: 145,
      g: 47,
      b: 70
    }
  }, {
    name: '7638 C',
    rgb: {
      r: 126,
      g: 45,
      b: 64
    }
  }, {
    name: '217 C',
    rgb: {
      r: 234,
      g: 190,
      b: 219
    }
  }, {
    name: '218 C',
    rgb: {
      r: 229,
      g: 109,
      b: 177
    }
  }, {
    name: '219 C',
    rgb: {
      r: 218,
      g: 24,
      b: 132
    }
  }, {
    name: '220 C',
    rgb: {
      r: 165,
      g: 0,
      b: 80
    }
  }, {
    name: '221 C',
    rgb: {
      r: 145,
      g: 0,
      b: 72
    }
  }, {
    name: '222 C',
    rgb: {
      r: 108,
      g: 29,
      b: 69
    }
  }, {
    name: '7639 C',
    rgb: {
      r: 147,
      g: 109,
      b: 115
    }
  }, {
    name: '7640 C',
    rgb: {
      r: 147,
      g: 64,
      b: 84
    }
  }, {
    name: '7641 C',
    rgb: {
      r: 142,
      g: 44,
      b: 72
    }
  }, {
    name: '7642 C',
    rgb: {
      r: 115,
      g: 46,
      b: 74
    }
  }, {
    name: '7643 C',
    rgb: {
      r: 103,
      g: 46,
      b: 69
    }
  }, {
    name: '7644 C',
    rgb: {
      r: 88,
      g: 45,
      b: 64
    }
  }, {
    name: '7645 C',
    rgb: {
      r: 80,
      g: 43,
      b: 58
    }
  }, {
    name: '223 C',
    rgb: {
      r: 239,
      g: 149,
      b: 207
    }
  }, {
    name: '224 C',
    rgb: {
      r: 235,
      g: 111,
      b: 189
    }
  }, {
    name: '225 C',
    rgb: {
      r: 223,
      g: 25,
      b: 149
    }
  }, {
    name: '226 C',
    rgb: {
      r: 208,
      g: 0,
      b: 111
    }
  }, {
    name: '227 C',
    rgb: {
      r: 170,
      g: 0,
      b: 97
    }
  }, {
    name: '228 C',
    rgb: {
      r: 137,
      g: 12,
      b: 88
    }
  }, {
    name: '229 C',
    rgb: {
      r: 103,
      g: 33,
      b: 70
    }
  }, {
    name: '230 C',
    rgb: {
      r: 244,
      g: 166,
      b: 215
    }
  }, {
    name: '231 C',
    rgb: {
      r: 242,
      g: 119,
      b: 198
    }
  }, {
    name: '232 C',
    rgb: {
      r: 233,
      g: 60,
      b: 172
    }
  }, {
    name: '233 C',
    rgb: {
      r: 198,
      g: 0,
      b: 126
    }
  }, {
    name: '234 C',
    rgb: {
      r: 162,
      g: 0,
      b: 103
    }
  }, {
    name: '235 C',
    rgb: {
      r: 132,
      g: 11,
      b: 85
    }
  }, {
    name: '670 C',
    rgb: {
      r: 234,
      g: 211,
      b: 226
    }
  }, {
    name: '671 C',
    rgb: {
      r: 230,
      g: 188,
      b: 216
    }
  }, {
    name: '672 C',
    rgb: {
      r: 223,
      g: 160,
      b: 201
    }
  }, {
    name: '673 C',
    rgb: {
      r: 217,
      g: 134,
      b: 186
    }
  }, {
    name: '674 C',
    rgb: {
      r: 198,
      g: 87,
      b: 154
    }
  }, {
    name: '675 C',
    rgb: {
      r: 174,
      g: 37,
      b: 115
    }
  }, {
    name: '676 C',
    rgb: {
      r: 150,
      g: 0,
      b: 81
    }
  }, {
    name: '677 C',
    rgb: {
      r: 229,
      g: 206,
      b: 219
    }
  }, {
    name: '678 C',
    rgb: {
      r: 227,
      g: 200,
      b: 216
    }
  }, {
    name: '679 C',
    rgb: {
      r: 222,
      g: 190,
      b: 210
    }
  }, {
    name: '680 C',
    rgb: {
      r: 201,
      g: 150,
      b: 182
    }
  }, {
    name: '681 C',
    rgb: {
      r: 176,
      g: 108,
      b: 150
    }
  }, {
    name: '682 C',
    rgb: {
      r: 153,
      g: 72,
      b: 120
    }
  }, {
    name: '683 C',
    rgb: {
      r: 124,
      g: 40,
      b: 85
    }
  }, {
    name: '684 C',
    rgb: {
      r: 228,
      g: 198,
      b: 212
    }
  }, {
    name: '685 C',
    rgb: {
      r: 220,
      g: 182,
      b: 201
    }
  }, {
    name: '686 C',
    rgb: {
      r: 208,
      g: 161,
      b: 186
    }
  }, {
    name: '687 C',
    rgb: {
      r: 190,
      g: 132,
      b: 163
    }
  }, {
    name: '688 C',
    rgb: {
      r: 167,
      g: 99,
      b: 137
    }
  }, {
    name: '689 C',
    rgb: {
      r: 137,
      g: 59,
      b: 103
    }
  }, {
    name: '690 C',
    rgb: {
      r: 97,
      g: 33,
      b: 65
    }
  }, {
    name: '510 C',
    rgb: {
      r: 235,
      g: 190,
      b: 203
    }
  }, {
    name: '509 C',
    rgb: {
      r: 232,
      g: 179,
      b: 195
    }
  }, {
    name: '508 C',
    rgb: {
      r: 228,
      g: 169,
      b: 187
    }
  }, {
    name: '507 C',
    rgb: {
      r: 213,
      g: 146,
      b: 170
    }
  }, {
    name: '506 C',
    rgb: {
      r: 132,
      g: 52,
      b: 78
    }
  }, {
    name: '505 C',
    rgb: {
      r: 111,
      g: 44,
      b: 63
    }
  }, {
    name: '504 C',
    rgb: {
      r: 87,
      g: 41,
      b: 50
    }
  }, {
    name: '7429 C',
    rgb: {
      r: 226,
      g: 188,
      b: 203
    }
  }, {
    name: '7430 C',
    rgb: {
      r: 220,
      g: 169,
      b: 191
    }
  }, {
    name: '7431 C',
    rgb: {
      r: 201,
      g: 128,
      b: 158
    }
  }, {
    name: '7432 C',
    rgb: {
      r: 181,
      g: 92,
      b: 128
    }
  }, {
    name: '7433 C',
    rgb: {
      r: 167,
      g: 58,
      b: 100
    }
  }, {
    name: '7434 C',
    rgb: {
      r: 155,
      g: 50,
      b: 89
    }
  }, {
    name: '7435 C',
    rgb: {
      r: 135,
      g: 38,
      b: 81
    }
  }, {
    name: '691 C',
    rgb: {
      r: 233,
      g: 205,
      b: 208
    }
  }, {
    name: '692 C',
    rgb: {
      r: 228,
      g: 190,
      b: 195
    }
  }, {
    name: '693 C',
    rgb: {
      r: 215,
      g: 163,
      b: 171
    }
  }, {
    name: '694 C',
    rgb: {
      r: 196,
      g: 132,
      b: 144
    }
  }, {
    name: '695 C',
    rgb: {
      r: 180,
      g: 107,
      b: 122
    }
  }, {
    name: '696 C',
    rgb: {
      r: 152,
      g: 72,
      b: 86
    }
  }, {
    name: '697 C',
    rgb: {
      r: 137,
      g: 60,
      b: 71
    }
  }, {
    name: '496 C',
    rgb: {
      r: 242,
      g: 198,
      b: 207
    }
  }, {
    name: '495 C',
    rgb: {
      r: 241,
      g: 189,
      b: 200
    }
  }, {
    name: '494 C',
    rgb: {
      r: 233,
      g: 162,
      b: 178
    }
  }, {
    name: '493 C',
    rgb: {
      r: 220,
      g: 134,
      b: 153
    }
  }, {
    name: '492 C',
    rgb: {
      r: 143,
      g: 50,
      b: 55
    }
  }, {
    name: '491 C',
    rgb: {
      r: 127,
      g: 48,
      b: 53
    }
  }, {
    name: '490 C',
    rgb: {
      r: 93,
      g: 42,
      b: 44
    }
  }, {
    name: '503 C',
    rgb: {
      r: 233,
      g: 196,
      b: 199
    }
  }, {
    name: '502 C',
    rgb: {
      r: 229,
      g: 186,
      b: 193
    }
  }, {
    name: '501 C',
    rgb: {
      r: 218,
      g: 165,
      b: 173
    }
  }, {
    name: '500 C',
    rgb: {
      r: 198,
      g: 133,
      b: 143
    }
  }, {
    name: '499 C',
    rgb: {
      r: 122,
      g: 62,
      b: 58
    }
  }, {
    name: '498 C',
    rgb: {
      r: 106,
      g: 55,
      b: 53
    }
  }, {
    name: '497 C',
    rgb: {
      r: 81,
      g: 47,
      b: 46
    }
  }, {
    name: '5035 C',
    rgb: {
      r: 223,
      g: 194,
      b: 195
    }
  }, {
    name: '5025 C',
    rgb: {
      r: 219,
      g: 183,
      b: 187
    }
  }, {
    name: '5015 C',
    rgb: {
      r: 204,
      g: 161,
      b: 166
    }
  }, {
    name: '5005 C',
    rgb: {
      r: 176,
      g: 124,
      b: 131
    }
  }, {
    name: '4995 C',
    rgb: {
      r: 156,
      g: 97,
      b: 105
    }
  }, {
    name: '4985 C',
    rgb: {
      r: 135,
      g: 75,
      b: 82
    }
  }, {
    name: '4975 C',
    rgb: {
      r: 63,
      g: 32,
      b: 33
    }
  }, {
    name: '236 C',
    rgb: {
      r: 241,
      g: 167,
      b: 220
    }
  }, {
    name: '237 C',
    rgb: {
      r: 236,
      g: 134,
      b: 208
    }
  }, {
    name: '238 C',
    rgb: {
      r: 228,
      g: 93,
      b: 191
    }
  }, {
    name: '239 C',
    rgb: {
      r: 219,
      g: 62,
      b: 177
    }
  }, {
    name: '240 C',
    rgb: {
      r: 197,
      g: 41,
      b: 155
    }
  }, {
    name: '241 C',
    rgb: {
      r: 175,
      g: 22,
      b: 133
    }
  }, {
    name: '242 C',
    rgb: {
      r: 128,
      g: 34,
      b: 95
    }
  }, {
    name: '2365 C',
    rgb: {
      r: 239,
      g: 186,
      b: 225
    }
  }, {
    name: '2375 C',
    rgb: {
      r: 226,
      g: 119,
      b: 205
    }
  }, {
    name: '2385 C',
    rgb: {
      r: 213,
      g: 57,
      b: 181
    }
  }, {
    name: '2395 C',
    rgb: {
      r: 200,
      g: 0,
      b: 161
    }
  }, {
    name: '2405 C',
    rgb: {
      r: 176,
      g: 0,
      b: 142
    }
  }, {
    name: '2415 C',
    rgb: {
      r: 158,
      g: 0,
      b: 126
    }
  }, {
    name: '2425 C',
    rgb: {
      r: 131,
      g: 0,
      b: 101
    }
  }, {
    name: '243 C',
    rgb: {
      r: 234,
      g: 184,
      b: 228
    }
  }, {
    name: '244 C',
    rgb: {
      r: 229,
      g: 155,
      b: 220
    }
  }, {
    name: '245 C',
    rgb: {
      r: 221,
      g: 127,
      b: 211
    }
  }, {
    name: '246 C',
    rgb: {
      r: 199,
      g: 36,
      b: 177
    }
  }, {
    name: '247 C',
    rgb: {
      r: 187,
      g: 22,
      b: 163
    }
  }, {
    name: '248 C',
    rgb: {
      r: 165,
      g: 24,
      b: 144
    }
  }, {
    name: '249 C',
    rgb: {
      r: 128,
      g: 39,
      b: 108
    }
  }, {
    name: '7646 C',
    rgb: {
      r: 165,
      g: 110,
      b: 135
    }
  }, {
    name: '7647 C',
    rgb: {
      r: 168,
      g: 61,
      b: 114
    }
  }, {
    name: '7648 C',
    rgb: {
      r: 153,
      g: 30,
      b: 102
    }
  }, {
    name: '7649 C',
    rgb: {
      r: 138,
      g: 27,
      b: 97
    }
  }, {
    name: '7650 C',
    rgb: {
      r: 114,
      g: 34,
      b: 87
    }
  }, {
    name: '7651 C',
    rgb: {
      r: 106,
      g: 42,
      b: 91
    }
  }, {
    name: '7652 C',
    rgb: {
      r: 94,
      g: 39,
      b: 81
    }
  }, {
    name: '250 C',
    rgb: {
      r: 231,
      g: 186,
      b: 228
    }
  }, {
    name: '251 C',
    rgb: {
      r: 221,
      g: 156,
      b: 223
    }
  }, {
    name: '252 C',
    rgb: {
      r: 201,
      g: 100,
      b: 207
    }
  }, {
    name: '253 C',
    rgb: {
      r: 173,
      g: 26,
      b: 172
    }
  }, {
    name: '254 C',
    rgb: {
      r: 152,
      g: 29,
      b: 151
    }
  }, {
    name: '255 C',
    rgb: {
      r: 114,
      g: 36,
      b: 108
    }
  }, {
    name: '517 C',
    rgb: {
      r: 235,
      g: 198,
      b: 223
    }
  }, {
    name: '516 C',
    rgb: {
      r: 230,
      g: 190,
      b: 221
    }
  }, {
    name: '515 C',
    rgb: {
      r: 226,
      g: 172,
      b: 215
    }
  }, {
    name: '514 C',
    rgb: {
      r: 212,
      g: 139,
      b: 200
    }
  }, {
    name: '513 C',
    rgb: {
      r: 147,
      g: 50,
      b: 142
    }
  }, {
    name: '512 C',
    rgb: {
      r: 131,
      g: 49,
      b: 119
    }
  }, {
    name: '511 C',
    rgb: {
      r: 97,
      g: 44,
      b: 81
    }
  }, {
    name: '7436 C',
    rgb: {
      r: 238,
      g: 218,
      b: 234
    }
  }, {
    name: '7437 C',
    rgb: {
      r: 204,
      g: 174,
      b: 208
    }
  }, {
    name: '7438 C',
    rgb: {
      r: 213,
      g: 158,
      b: 215
    }
  }, {
    name: '7439 C',
    rgb: {
      r: 178,
      g: 136,
      b: 185
    }
  }, {
    name: '7440 C',
    rgb: {
      r: 162,
      g: 119,
      b: 166
    }
  }, {
    name: '7441 C',
    rgb: {
      r: 159,
      g: 92,
      b: 192
    }
  }, {
    name: '7442 C',
    rgb: {
      r: 150,
      g: 60,
      b: 189
    }
  }, {
    name: '2562 C',
    rgb: {
      r: 215,
      g: 169,
      b: 227
    }
  }, {
    name: '2572 C',
    rgb: {
      r: 201,
      g: 139,
      b: 219
    }
  }, {
    name: '2582 C',
    rgb: {
      r: 172,
      g: 79,
      b: 198
    }
  }, {
    name: '2592 C',
    rgb: {
      r: 155,
      g: 38,
      b: 182
    }
  }, {
    name: '2602 C',
    rgb: {
      r: 135,
      g: 24,
      b: 157
    }
  }, {
    name: '2612 C',
    rgb: {
      r: 119,
      g: 37,
      b: 131
    }
  }, {
    name: '2622 C',
    rgb: {
      r: 101,
      g: 49,
      b: 101
    }
  }, {
    name: '7653 C',
    rgb: {
      r: 148,
      g: 135,
      b: 148
    }
  }, {
    name: '7654 C',
    rgb: {
      r: 162,
      g: 120,
      b: 156
    }
  }, {
    name: '7655 C',
    rgb: {
      r: 161,
      g: 90,
      b: 149
    }
  }, {
    name: '7656 C',
    rgb: {
      r: 142,
      g: 58,
      b: 128
    }
  }, {
    name: '7657 C',
    rgb: {
      r: 110,
      g: 43,
      b: 98
    }
  }, {
    name: '7658 C',
    rgb: {
      r: 106,
      g: 52,
      b: 96
    }
  }, {
    name: '7659 C',
    rgb: {
      r: 93,
      g: 55,
      b: 84
    }
  }, {
    name: '524 C',
    rgb: {
      r: 213,
      g: 194,
      b: 216
    }
  }, {
    name: '523 C',
    rgb: {
      r: 201,
      g: 177,
      b: 208
    }
  }, {
    name: '522 C',
    rgb: {
      r: 186,
      g: 156,
      b: 197
    }
  }, {
    name: '521 C',
    rgb: {
      r: 165,
      g: 127,
      b: 178
    }
  }, {
    name: '520 C',
    rgb: {
      r: 100,
      g: 47,
      b: 108
    }
  }, {
    name: '519 C',
    rgb: {
      r: 89,
      g: 49,
      b: 95
    }
  }, {
    name: '518 C',
    rgb: {
      r: 75,
      g: 48,
      b: 72
    }
  }, {
    name: '5245 C',
    rgb: {
      r: 219,
      g: 205,
      b: 211
    }
  }, {
    name: '5235 C',
    rgb: {
      r: 208,
      g: 190,
      b: 199
    }
  }, {
    name: '5225 C',
    rgb: {
      r: 198,
      g: 176,
      b: 188
    }
  }, {
    name: '5215 C',
    rgb: {
      r: 175,
      g: 149,
      b: 166
    }
  }, {
    name: '5205 C',
    rgb: {
      r: 134,
      g: 100,
      b: 122
    }
  }, {
    name: '5195 C',
    rgb: {
      r: 102,
      g: 67,
      b: 90
    }
  }, {
    name: '5185 C',
    rgb: {
      r: 74,
      g: 48,
      b: 65
    }
  }, {
    name: '5175 C',
    rgb: {
      r: 216,
      g: 200,
      b: 209
    }
  }, {
    name: '5165 C',
    rgb: {
      r: 211,
      g: 192,
      b: 205
    }
  }, {
    name: '5155 C',
    rgb: {
      r: 191,
      g: 165,
      b: 184
    }
  }, {
    name: '5145 C',
    rgb: {
      r: 155,
      g: 119,
      b: 147
    }
  }, {
    name: '5135 C',
    rgb: {
      r: 126,
      g: 84,
      b: 117
    }
  }, {
    name: '5125 C',
    rgb: {
      r: 105,
      g: 60,
      b: 94
    }
  }, {
    name: '5115 C',
    rgb: {
      r: 81,
      g: 42,
      b: 68
    }
  }, {
    name: '531 C',
    rgb: {
      r: 223,
      g: 200,
      b: 231
    }
  }, {
    name: '530 C',
    rgb: {
      r: 215,
      g: 185,
      b: 228
    }
  }, {
    name: '529 C',
    rgb: {
      r: 202,
      g: 162,
      b: 221
    }
  }, {
    name: '528 C',
    rgb: {
      r: 181,
      g: 128,
      b: 209
    }
  }, {
    name: '527 C',
    rgb: {
      r: 128,
      g: 49,
      b: 167
    }
  }, {
    name: '526 C',
    rgb: {
      r: 112,
      g: 47,
      b: 138
    }
  }, {
    name: '525 C',
    rgb: {
      r: 87,
      g: 44,
      b: 95
    }
  }, {
    name: '256 C',
    rgb: {
      r: 214,
      g: 191,
      b: 221
    }
  }, {
    name: '257 C',
    rgb: {
      r: 198,
      g: 161,
      b: 207
    }
  }, {
    name: '258 C',
    rgb: {
      r: 140,
      g: 71,
      b: 153
    }
  }, {
    name: '259 C',
    rgb: {
      r: 109,
      g: 32,
      b: 119
    }
  }, {
    name: '260 C',
    rgb: {
      r: 100,
      g: 38,
      b: 103
    }
  }, {
    name: '261 C',
    rgb: {
      r: 93,
      g: 40,
      b: 95
    }
  }, {
    name: '262 C',
    rgb: {
      r: 81,
      g: 40,
      b: 79
    }
  }, {
    name: '2563 C',
    rgb: {
      r: 203,
      g: 163,
      b: 216
    }
  }, {
    name: '2573 C',
    rgb: {
      r: 184,
      g: 132,
      b: 203
    }
  }, {
    name: '2583 C',
    rgb: {
      r: 160,
      g: 94,
      b: 181
    }
  }, {
    name: '2593 C',
    rgb: {
      r: 132,
      g: 50,
      b: 155
    }
  }, {
    name: '2603 C',
    rgb: {
      r: 112,
      g: 32,
      b: 130
    }
  }, {
    name: '2613 C',
    rgb: {
      r: 103,
      g: 30,
      b: 117
    }
  }, {
    name: '2623 C',
    rgb: {
      r: 95,
      g: 33,
      b: 103
    }
  }, {
    name: '7660 C',
    rgb: {
      r: 153,
      g: 145,
      b: 164
    }
  }, {
    name: '7661 C',
    rgb: {
      r: 141,
      g: 110,
      b: 151
    }
  }, {
    name: '7662 C',
    rgb: {
      r: 122,
      g: 65,
      b: 131
    }
  }, {
    name: '7663 C',
    rgb: {
      r: 107,
      g: 48,
      b: 119
    }
  }, {
    name: '7664 C',
    rgb: {
      r: 101,
      g: 50,
      b: 121
    }
  }, {
    name: '7665 C',
    rgb: {
      r: 94,
      g: 54,
      b: 110
    }
  }, {
    name: '7666 C',
    rgb: {
      r: 92,
      g: 78,
      b: 99
    }
  }, {
    name: '2567 C',
    rgb: {
      r: 193,
      g: 160,
      b: 218
    }
  }, {
    name: '2577 C',
    rgb: {
      r: 167,
      g: 123,
      b: 202
    }
  }, {
    name: '2587 C',
    rgb: {
      r: 130,
      g: 70,
      b: 175
    }
  }, {
    name: '2597 C',
    rgb: {
      r: 92,
      g: 6,
      b: 140
    }
  }, {
    name: '2607 C',
    rgb: {
      r: 80,
      g: 7,
      b: 120
    }
  }, {
    name: '2617 C',
    rgb: {
      r: 71,
      g: 10,
      b: 104
    }
  }, {
    name: '2627 C',
    rgb: {
      r: 60,
      g: 16,
      b: 83
    }
  }, {
    name: '263 C',
    rgb: {
      r: 215,
      g: 198,
      b: 230
    }
  }, {
    name: '264 C',
    rgb: {
      r: 193,
      g: 167,
      b: 226
    }
  }, {
    name: '265 C',
    rgb: {
      r: 144,
      g: 99,
      b: 205
    }
  }, {
    name: '266 C',
    rgb: {
      r: 117,
      g: 59,
      b: 189
    }
  }, {
    name: '267 C',
    rgb: {
      r: 95,
      g: 37,
      b: 159
    }
  }, {
    name: '268 C',
    rgb: {
      r: 88,
      g: 44,
      b: 131
    }
  }, {
    name: '269 C',
    rgb: {
      r: 81,
      g: 45,
      b: 109
    }
  }, {
    name: '2635 C',
    rgb: {
      r: 197,
      g: 180,
      b: 227
    }
  }, {
    name: '2645 C',
    rgb: {
      r: 173,
      g: 150,
      b: 220
    }
  }, {
    name: '2655 C',
    rgb: {
      r: 150,
      g: 120,
      b: 211
    }
  }, {
    name: '2665 C',
    rgb: {
      r: 125,
      g: 85,
      b: 199
    }
  }, {
    name: '2685 C',
    rgb: {
      r: 51,
      g: 0,
      b: 114
    }
  }, {
    name: '2695 C',
    rgb: {
      r: 46,
      g: 26,
      b: 71
    }
  }, {
    name: '270 C',
    rgb: {
      r: 180,
      g: 181,
      b: 223
    }
  }, {
    name: '271 C',
    rgb: {
      r: 149,
      g: 149,
      b: 210
    }
  }, {
    name: '272 C',
    rgb: {
      r: 116,
      g: 116,
      b: 193
    }
  }, {
    name: '273 C',
    rgb: {
      r: 36,
      g: 19,
      b: 95
    }
  }, {
    name: '274 C',
    rgb: {
      r: 33,
      g: 21,
      b: 81
    }
  }, {
    name: '275 C',
    rgb: {
      r: 32,
      g: 23,
      b: 71
    }
  }, {
    name: '276 C',
    rgb: {
      r: 34,
      g: 28,
      b: 53
    }
  }, {
    name: '2705 C',
    rgb: {
      r: 167,
      g: 164,
      b: 224
    }
  }, {
    name: '2715 C',
    rgb: {
      r: 139,
      g: 132,
      b: 215
    }
  }, {
    name: '2725 C',
    rgb: {
      r: 104,
      g: 91,
      b: 199
    }
  }, {
    name: '2735 C',
    rgb: {
      r: 46,
      g: 0,
      b: 139
    }
  }, {
    name: '2745 C',
    rgb: {
      r: 40,
      g: 0,
      b: 113
    }
  }, {
    name: '2755 C',
    rgb: {
      r: 37,
      g: 14,
      b: 98
    }
  }, {
    name: '2765 C',
    rgb: {
      r: 32,
      g: 21,
      b: 71
    }
  }, {
    name: '7667 C',
    rgb: {
      r: 110,
      g: 124,
      b: 160
    }
  }, {
    name: '7668 C',
    rgb: {
      r: 104,
      g: 110,
      b: 159
    }
  }, {
    name: '7669 C',
    rgb: {
      r: 97,
      g: 94,
      b: 155
    }
  }, {
    name: '7670 C',
    rgb: {
      r: 86,
      g: 82,
      b: 148
    }
  }, {
    name: '7671 C',
    rgb: {
      r: 81,
      g: 70,
      b: 137
    }
  }, {
    name: '7672 C',
    rgb: {
      r: 76,
      g: 65,
      b: 132
    }
  }, {
    name: '7673 C',
    rgb: {
      r: 83,
      g: 84,
      b: 134
    }
  }, {
    name: '7443 C',
    rgb: {
      r: 221,
      g: 218,
      b: 232
    }
  }, {
    name: '7444 C',
    rgb: {
      r: 182,
      g: 184,
      b: 220
    }
  }, {
    name: '7445 C',
    rgb: {
      r: 167,
      g: 162,
      b: 195
    }
  }, {
    name: '7446 C',
    rgb: {
      r: 137,
      g: 134,
      b: 202
    }
  }, {
    name: '7447 C',
    rgb: {
      r: 93,
      g: 71,
      b: 119
    }
  }, {
    name: '7448 C',
    rgb: {
      r: 75,
      g: 56,
      b: 76
    }
  }, {
    name: '7449 C',
    rgb: {
      r: 65,
      g: 39,
      b: 59
    }
  }, {
    name: '7674 C',
    rgb: {
      r: 135,
      g: 140,
      b: 180
    }
  }, {
    name: '7675 C',
    rgb: {
      r: 124,
      g: 127,
      b: 171
    }
  }, {
    name: '7676 C',
    rgb: {
      r: 117,
      g: 102,
      b: 160
    }
  }, {
    name: '7677 C',
    rgb: {
      r: 111,
      g: 80,
      b: 145
    }
  }, {
    name: '7678 C',
    rgb: {
      r: 104,
      g: 71,
      b: 141
    }
  }, {
    name: '7679 C',
    rgb: {
      r: 86,
      g: 61,
      b: 130
    }
  }, {
    name: '7680 C',
    rgb: {
      r: 82,
      g: 49,
      b: 120
    }
  }, {
    name: '663 C',
    rgb: {
      r: 229,
      g: 225,
      b: 230
    }
  }, {
    name: '664 C',
    rgb: {
      r: 224,
      g: 219,
      b: 227
    }
  }, {
    name: '665 C',
    rgb: {
      r: 198,
      g: 188,
      b: 208
    }
  }, {
    name: '666 C',
    rgb: {
      r: 161,
      g: 146,
      b: 178
    }
  }, {
    name: '667 C',
    rgb: {
      r: 124,
      g: 105,
      b: 146
    }
  }, {
    name: '668 C',
    rgb: {
      r: 97,
      g: 75,
      b: 121
    }
  }, {
    name: '669 C',
    rgb: {
      r: 63,
      g: 42,
      b: 86
    }
  }, {
    name: '5315 C',
    rgb: {
      r: 216,
      g: 215,
      b: 223
    }
  }, {
    name: '5305 C',
    rgb: {
      r: 198,
      g: 196,
      b: 210
    }
  }, {
    name: '5295 C',
    rgb: {
      r: 179,
      g: 176,
      b: 196
    }
  }, {
    name: '5285 C',
    rgb: {
      r: 141,
      g: 137,
      b: 165
    }
  }, {
    name: '5275 C',
    rgb: {
      r: 89,
      g: 84,
      b: 120
    }
  }, {
    name: '5265 C',
    rgb: {
      r: 64,
      g: 58,
      b: 96
    }
  }, {
    name: '5255 C',
    rgb: {
      r: 30,
      g: 26,
      b: 52
    }
  }, {
    name: '538 C',
    rgb: {
      r: 197,
      g: 207,
      b: 218
    }
  }, {
    name: '537 C',
    rgb: {
      r: 187,
      g: 199,
      b: 214
    }
  }, {
    name: '536 C',
    rgb: {
      r: 162,
      g: 178,
      b: 200
    }
  }, {
    name: '535 C',
    rgb: {
      r: 142,
      g: 159,
      b: 188
    }
  }, {
    name: '534 C',
    rgb: {
      r: 27,
      g: 54,
      b: 93
    }
  }, {
    name: '533 C',
    rgb: {
      r: 31,
      g: 42,
      b: 68
    }
  }, {
    name: '532 C',
    rgb: {
      r: 28,
      g: 31,
      b: 42
    }
  }, {
    name: '7541 C',
    rgb: {
      r: 217,
      g: 225,
      b: 226
    }
  }, {
    name: '7542 C',
    rgb: {
      r: 164,
      g: 188,
      b: 194
    }
  }, {
    name: '7543 C',
    rgb: {
      r: 152,
      g: 164,
      b: 174
    }
  }, {
    name: '7544 C',
    rgb: {
      r: 118,
      g: 134,
      b: 146
    }
  }, {
    name: '7545 C',
    rgb: {
      r: 66,
      g: 85,
      b: 99
    }
  }, {
    name: '7546 C',
    rgb: {
      r: 37,
      g: 55,
      b: 70
    }
  }, {
    name: '7547 C',
    rgb: {
      r: 19,
      g: 30,
      b: 41
    }
  }, {
    name: '552 C',
    rgb: {
      r: 185,
      g: 211,
      b: 220
    }
  }, {
    name: '551 C',
    rgb: {
      r: 163,
      g: 199,
      b: 210
    }
  }, {
    name: '550 C',
    rgb: {
      r: 141,
      g: 185,
      b: 202
    }
  }, {
    name: '549 C',
    rgb: {
      r: 107,
      g: 164,
      b: 184
    }
  }, {
    name: '548 C',
    rgb: {
      r: 0,
      g: 61,
      b: 76
    }
  }, {
    name: '547 C',
    rgb: {
      r: 0,
      g: 49,
      b: 60
    }
  }, {
    name: '546 C',
    rgb: {
      r: 7,
      g: 43,
      b: 49
    }
  }, {
    name: '5455 C',
    rgb: {
      r: 191,
      g: 206,
      b: 214
    }
  }, {
    name: '5445 C',
    rgb: {
      r: 183,
      g: 201,
      b: 211
    }
  }, {
    name: '5435 C',
    rgb: {
      r: 166,
      g: 187,
      b: 200
    }
  }, {
    name: '5425 C',
    rgb: {
      r: 122,
      g: 153,
      b: 172
    }
  }, {
    name: '5415 C',
    rgb: {
      r: 91,
      g: 127,
      b: 149
    }
  }, {
    name: '5405 C',
    rgb: {
      r: 79,
      g: 117,
      b: 139
    }
  }, {
    name: '5395 C',
    rgb: {
      r: 8,
      g: 31,
      b: 44
    }
  }, {
    name: '642 C',
    rgb: {
      r: 209,
      g: 221,
      b: 230
    }
  }, {
    name: '643 C',
    rgb: {
      r: 198,
      g: 214,
      b: 227
    }
  }, {
    name: '644 C',
    rgb: {
      r: 155,
      g: 184,
      b: 211
    }
  }, {
    name: '645 C',
    rgb: {
      r: 125,
      g: 161,
      b: 196
    }
  }, {
    name: '646 C',
    rgb: {
      r: 94,
      g: 138,
      b: 180
    }
  }, {
    name: '647 C',
    rgb: {
      r: 35,
      g: 97,
      b: 146
    }
  }, {
    name: '648 C',
    rgb: {
      r: 0,
      g: 46,
      b: 93
    }
  }, {
    name: '649 C',
    rgb: {
      r: 219,
      g: 226,
      b: 233
    }
  }, {
    name: '650 C',
    rgb: {
      r: 206,
      g: 217,
      b: 229
    }
  }, {
    name: '651 C',
    rgb: {
      r: 167,
      g: 188,
      b: 214
    }
  }, {
    name: '652 C',
    rgb: {
      r: 125,
      g: 155,
      b: 193
    }
  }, {
    name: '653 C',
    rgb: {
      r: 50,
      g: 98,
      b: 149
    }
  }, {
    name: '654 C',
    rgb: {
      r: 0,
      g: 58,
      b: 112
    }
  }, {
    name: '655 C',
    rgb: {
      r: 0,
      g: 37,
      b: 84
    }
  }, {
    name: '656 C',
    rgb: {
      r: 221,
      g: 229,
      b: 237
    }
  }, {
    name: '657 C',
    rgb: {
      r: 200,
      g: 216,
      b: 235
    }
  }, {
    name: '658 C',
    rgb: {
      r: 177,
      g: 201,
      b: 232
    }
  }, {
    name: '659 C',
    rgb: {
      r: 123,
      g: 164,
      b: 219
    }
  }, {
    name: '660 C',
    rgb: {
      r: 64,
      g: 126,
      b: 201
    }
  }, {
    name: '661 C',
    rgb: {
      r: 0,
      g: 53,
      b: 148
    }
  }, {
    name: '662 C',
    rgb: {
      r: 0,
      g: 26,
      b: 112
    }
  }, {
    name: '7450 C',
    rgb: {
      r: 189,
      g: 197,
      b: 219
    }
  }, {
    name: '7451 C',
    rgb: {
      r: 137,
      g: 171,
      b: 227
    }
  }, {
    name: '7452 C',
    rgb: {
      r: 128,
      g: 148,
      b: 221
    }
  }, {
    name: '7453 C',
    rgb: {
      r: 123,
      g: 166,
      b: 222
    }
  }, {
    name: '7454 C',
    rgb: {
      r: 95,
      g: 143,
      b: 180
    }
  }, {
    name: '7455 C',
    rgb: {
      r: 58,
      g: 93,
      b: 174
    }
  }, {
    name: '7456 C',
    rgb: {
      r: 96,
      g: 110,
      b: 178
    }
  }, {
    name: '2706 C',
    rgb: {
      r: 203,
      g: 211,
      b: 235
    }
  }, {
    name: '2716 C',
    rgb: {
      r: 159,
      g: 174,
      b: 229
    }
  }, {
    name: '2726 C',
    rgb: {
      r: 72,
      g: 92,
      b: 199
    }
  }, {
    name: '2736 C',
    rgb: {
      r: 30,
      g: 34,
      b: 170
    }
  }, {
    name: '2746 C',
    rgb: {
      r: 23,
      g: 28,
      b: 143
    }
  }, {
    name: '2756 C',
    rgb: {
      r: 21,
      g: 31,
      b: 109
    }
  }, {
    name: '2766 C',
    rgb: {
      r: 20,
      g: 27,
      b: 77
    }
  }, {
    name: '2708 C',
    rgb: {
      r: 184,
      g: 204,
      b: 234
    }
  }, {
    name: '2718 C',
    rgb: {
      r: 92,
      g: 136,
      b: 218
    }
  }, {
    name: '2728 C',
    rgb: {
      r: 0,
      g: 71,
      b: 187
    }
  }, {
    name: '2738 C',
    rgb: {
      r: 6,
      g: 3,
      b: 141
    }
  }, {
    name: '2748 C',
    rgb: {
      r: 0,
      g: 24,
      b: 113
    }
  }, {
    name: '2758 C',
    rgb: {
      r: 0,
      g: 30,
      b: 98
    }
  }, {
    name: '2768 C',
    rgb: {
      r: 7,
      g: 29,
      b: 73
    }
  }, {
    name: '2707 C',
    rgb: {
      r: 195,
      g: 215,
      b: 238
    }
  }, {
    name: '2717 C',
    rgb: {
      r: 167,
      g: 198,
      b: 237
    }
  }, {
    name: '2727 C',
    rgb: {
      r: 48,
      g: 127,
      b: 226
    }
  }, {
    name: '2747 C',
    rgb: {
      r: 0,
      g: 26,
      b: 114
    }
  }, {
    name: '2757 C',
    rgb: {
      r: 0,
      g: 30,
      b: 96
    }
  }, {
    name: '2767 C',
    rgb: {
      r: 19,
      g: 41,
      b: 75
    }
  }, {
    name: '277 C',
    rgb: {
      r: 171,
      g: 202,
      b: 233
    }
  }, {
    name: '278 C',
    rgb: {
      r: 139,
      g: 184,
      b: 232
    }
  }, {
    name: '279 C',
    rgb: {
      r: 65,
      g: 143,
      b: 222
    }
  }, {
    name: '280 C',
    rgb: {
      r: 1,
      g: 33,
      b: 105
    }
  }, {
    name: '281 C',
    rgb: {
      r: 0,
      g: 32,
      b: 91
    }
  }, {
    name: '282 C',
    rgb: {
      r: 4,
      g: 30,
      b: 66
    }
  }, {
    name: '283 C',
    rgb: {
      r: 146,
      g: 193,
      b: 233
    }
  }, {
    name: '284 C',
    rgb: {
      r: 108,
      g: 172,
      b: 228
    }
  }, {
    name: '285 C',
    rgb: {
      r: 0,
      g: 114,
      b: 206
    }
  }, {
    name: '286 C',
    rgb: {
      r: 0,
      g: 51,
      b: 160
    }
  }, {
    name: '287 C',
    rgb: {
      r: 0,
      g: 48,
      b: 135
    }
  }, {
    name: '288 C',
    rgb: {
      r: 0,
      g: 45,
      b: 114
    }
  }, {
    name: '289 C',
    rgb: {
      r: 12,
      g: 35,
      b: 64
    }
  }, {
    name: '7681 C',
    rgb: {
      r: 148,
      g: 169,
      b: 203
    }
  }, {
    name: '7682 C',
    rgb: {
      r: 103,
      g: 135,
      b: 183
    }
  }, {
    name: '7683 C',
    rgb: {
      r: 66,
      g: 109,
      b: 169
    }
  }, {
    name: '7684 C',
    rgb: {
      r: 56,
      g: 94,
      b: 157
    }
  }, {
    name: '7685 C',
    rgb: {
      r: 44,
      g: 86,
      b: 151
    }
  }, {
    name: '7686 C',
    rgb: {
      r: 29,
      g: 79,
      b: 145
    }
  }, {
    name: '7687 C',
    rgb: {
      r: 29,
      g: 66,
      b: 138
    }
  }, {
    name: '545 C',
    rgb: {
      r: 198,
      g: 218,
      b: 231
    }
  }, {
    name: '544 C',
    rgb: {
      r: 189,
      g: 214,
      b: 230
    }
  }, {
    name: '543 C',
    rgb: {
      r: 164,
      g: 200,
      b: 225
    }
  }, {
    name: '542 C',
    rgb: {
      r: 123,
      g: 175,
      b: 212
    }
  }, {
    name: '541 C',
    rgb: {
      r: 0,
      g: 60,
      b: 113
    }
  }, {
    name: '540 C',
    rgb: {
      r: 0,
      g: 48,
      b: 87
    }
  }, {
    name: '539 C',
    rgb: {
      r: 0,
      g: 38,
      b: 58
    }
  }, {
    name: '290 C',
    rgb: {
      r: 185,
      g: 217,
      b: 235
    }
  }, {
    name: '291 C',
    rgb: {
      r: 155,
      g: 203,
      b: 235
    }
  }, {
    name: '292 C',
    rgb: {
      r: 105,
      g: 179,
      b: 231
    }
  }, {
    name: '293 C',
    rgb: {
      r: 0,
      g: 61,
      b: 165
    }
  }, {
    name: '294 C',
    rgb: {
      r: 0,
      g: 47,
      b: 108
    }
  }, {
    name: '295 C',
    rgb: {
      r: 0,
      g: 40,
      b: 85
    }
  }, {
    name: '296 C',
    rgb: {
      r: 4,
      g: 28,
      b: 44
    }
  }, {
    name: '2905 C',
    rgb: {
      r: 141,
      g: 200,
      b: 232
    }
  }, {
    name: '2915 C',
    rgb: {
      r: 98,
      g: 181,
      b: 229
    }
  }, {
    name: '2925 C',
    rgb: {
      r: 0,
      g: 156,
      b: 222
    }
  }, {
    name: '2935 C',
    rgb: {
      r: 0,
      g: 87,
      b: 184
    }
  }, {
    name: '2945 C',
    rgb: {
      r: 0,
      g: 76,
      b: 151
    }
  }, {
    name: '2955 C',
    rgb: {
      r: 0,
      g: 56,
      b: 101
    }
  }, {
    name: '2965 C',
    rgb: {
      r: 0,
      g: 38,
      b: 62
    }
  }, {
    name: '297 C',
    rgb: {
      r: 113,
      g: 197,
      b: 232
    }
  }, {
    name: '298 C',
    rgb: {
      r: 65,
      g: 182,
      b: 230
    }
  }, {
    name: '299 C',
    rgb: {
      r: 0,
      g: 163,
      b: 224
    }
  }, {
    name: '300 C',
    rgb: {
      r: 0,
      g: 94,
      b: 184
    }
  }, {
    name: '301 C',
    rgb: {
      r: 0,
      g: 75,
      b: 135
    }
  }, {
    name: '302 C',
    rgb: {
      r: 0,
      g: 59,
      b: 92
    }
  }, {
    name: '303 C',
    rgb: {
      r: 0,
      g: 42,
      b: 58
    }
  }, {
    name: '7688 C',
    rgb: {
      r: 70,
      g: 152,
      b: 203
    }
  }, {
    name: '7689 C',
    rgb: {
      r: 41,
      g: 143,
      b: 194
    }
  }, {
    name: '7690 C',
    rgb: {
      r: 0,
      g: 118,
      b: 168
    }
  }, {
    name: '7691 C',
    rgb: {
      r: 0,
      g: 98,
      b: 152
    }
  }, {
    name: '7692 C',
    rgb: {
      r: 0,
      g: 85,
      b: 135
    }
  }, {
    name: '7693 C',
    rgb: {
      r: 0,
      g: 73,
      b: 118
    }
  }, {
    name: '7694 C',
    rgb: {
      r: 1,
      g: 66,
      b: 106
    }
  }, {
    name: '2975 C',
    rgb: {
      r: 153,
      g: 214,
      b: 234
    }
  }, {
    name: '2985 C',
    rgb: {
      r: 91,
      g: 194,
      b: 231
    }
  }, {
    name: '2995 C',
    rgb: {
      r: 0,
      g: 169,
      b: 224
    }
  }, {
    name: '3005 C',
    rgb: {
      r: 0,
      g: 119,
      b: 200
    }
  }, {
    name: '3015 C',
    rgb: {
      r: 0,
      g: 98,
      b: 155
    }
  }, {
    name: '3025 C',
    rgb: {
      r: 0,
      g: 79,
      b: 113
    }
  }, {
    name: '3035 C',
    rgb: {
      r: 0,
      g: 62,
      b: 81
    }
  }, {
    name: '7695 C',
    rgb: {
      r: 123,
      g: 167,
      b: 188
    }
  }, {
    name: '7696 C',
    rgb: {
      r: 99,
      g: 153,
      b: 174
    }
  }, {
    name: '7697 C',
    rgb: {
      r: 78,
      g: 135,
      b: 160
    }
  }, {
    name: '7698 C',
    rgb: {
      r: 65,
      g: 116,
      b: 141
    }
  }, {
    name: '7699 C',
    rgb: {
      r: 52,
      g: 101,
      b: 127
    }
  }, {
    name: '7700 C',
    rgb: {
      r: 22,
      g: 92,
      b: 125
    }
  }, {
    name: '7701 C',
    rgb: {
      r: 0,
      g: 87,
      b: 118
    }
  }, {
    name: '7457 C',
    rgb: {
      r: 187,
      g: 221,
      b: 230
    }
  }, {
    name: '7458 C',
    rgb: {
      r: 113,
      g: 178,
      b: 201
    }
  }, {
    name: '7459 C',
    rgb: {
      r: 66,
      g: 152,
      b: 181
    }
  }, {
    name: '7460 C',
    rgb: {
      r: 0,
      g: 134,
      b: 191
    }
  }, {
    name: '7461 C',
    rgb: {
      r: 0,
      g: 125,
      b: 186
    }
  }, {
    name: '7462 C',
    rgb: {
      r: 0,
      g: 85,
      b: 140
    }
  }, {
    name: '7463 C',
    rgb: {
      r: 0,
      g: 43,
      b: 73
    }
  }, {
    name: '304 C',
    rgb: {
      r: 154,
      g: 219,
      b: 232
    }
  }, {
    name: '305 C',
    rgb: {
      r: 89,
      g: 203,
      b: 232
    }
  }, {
    name: '306 C',
    rgb: {
      r: 0,
      g: 181,
      b: 226
    }
  }, {
    name: '307 C',
    rgb: {
      r: 0,
      g: 107,
      b: 166
    }
  }, {
    name: '308 C',
    rgb: {
      r: 0,
      g: 88,
      b: 124
    }
  }, {
    name: '309 C',
    rgb: {
      r: 0,
      g: 59,
      b: 73
    }
  }, {
    name: '635 C',
    rgb: {
      r: 164,
      g: 219,
      b: 232
    }
  }, {
    name: '636 C',
    rgb: {
      r: 139,
      g: 211,
      b: 230
    }
  }, {
    name: '637 C',
    rgb: {
      r: 78,
      g: 195,
      b: 224
    }
  }, {
    name: '638 C',
    rgb: {
      r: 0,
      g: 175,
      b: 215
    }
  }, {
    name: '639 C',
    rgb: {
      r: 0,
      g: 149,
      b: 200
    }
  }, {
    name: '640 C',
    rgb: {
      r: 0,
      g: 130,
      b: 186
    }
  }, {
    name: '641 C',
    rgb: {
      r: 0,
      g: 103,
      b: 160
    }
  }, {
    name: '7702 C',
    rgb: {
      r: 72,
      g: 169,
      b: 197
    }
  }, {
    name: '7703 C',
    rgb: {
      r: 0,
      g: 156,
      b: 189
    }
  }, {
    name: '7704 C',
    rgb: {
      r: 0,
      g: 133,
      b: 173
    }
  }, {
    name: '7705 C',
    rgb: {
      r: 0,
      g: 112,
      b: 150
    }
  }, {
    name: '7706 C',
    rgb: {
      r: 0,
      g: 106,
      b: 142
    }
  }, {
    name: '7707 C',
    rgb: {
      r: 0,
      g: 97,
      b: 127
    }
  }, {
    name: '7708 C',
    rgb: {
      r: 0,
      g: 86,
      b: 112
    }
  }, {
    name: '628 C',
    rgb: {
      r: 184,
      g: 221,
      b: 225
    }
  }, {
    name: '629 C',
    rgb: {
      r: 155,
      g: 211,
      b: 221
    }
  }, {
    name: '630 C',
    rgb: {
      r: 119,
      g: 197,
      b: 213
    }
  }, {
    name: '631 C',
    rgb: {
      r: 62,
      g: 177,
      b: 200
    }
  }, {
    name: '632 C',
    rgb: {
      r: 0,
      g: 147,
      b: 178
    }
  }, {
    name: '633 C',
    rgb: {
      r: 0,
      g: 115,
      b: 150
    }
  }, {
    name: '634 C',
    rgb: {
      r: 0,
      g: 95,
      b: 131
    }
  }, {
    name: '310 C',
    rgb: {
      r: 106,
      g: 209,
      b: 227
    }
  }, {
    name: '311 C',
    rgb: {
      r: 5,
      g: 195,
      b: 222
    }
  }, {
    name: '312 C',
    rgb: {
      r: 0,
      g: 169,
      b: 206
    }
  }, {
    name: '313 C',
    rgb: {
      r: 0,
      g: 146,
      b: 188
    }
  }, {
    name: '314 C',
    rgb: {
      r: 0,
      g: 127,
      b: 163
    }
  }, {
    name: '315 C',
    rgb: {
      r: 0,
      g: 103,
      b: 127
    }
  }, {
    name: '316 C',
    rgb: {
      r: 0,
      g: 72,
      b: 81
    }
  }, {
    name: '3105 C',
    rgb: {
      r: 104,
      g: 210,
      b: 223
    }
  }, {
    name: '3115 C',
    rgb: {
      r: 0,
      g: 193,
      b: 213
    }
  }, {
    name: '3125 C',
    rgb: {
      r: 0,
      g: 174,
      b: 199
    }
  }, {
    name: '3135 C',
    rgb: {
      r: 0,
      g: 142,
      b: 170
    }
  }, {
    name: '3145 C',
    rgb: {
      r: 0,
      g: 119,
      b: 139
    }
  }, {
    name: '3155 C',
    rgb: {
      r: 0,
      g: 98,
      b: 114
    }
  }, {
    name: '3165 C',
    rgb: {
      r: 0,
      g: 79,
      b: 89
    }
  }, {
    name: '7709 C',
    rgb: {
      r: 99,
      g: 177,
      b: 188
    }
  }, {
    name: '7710 C',
    rgb: {
      r: 0,
      g: 167,
      b: 181
    }
  }, {
    name: '7711 C',
    rgb: {
      r: 0,
      g: 151,
      b: 169
    }
  }, {
    name: '7712 C',
    rgb: {
      r: 0,
      g: 133,
      b: 155
    }
  }, {
    name: '7713 C',
    rgb: {
      r: 0,
      g: 125,
      b: 138
    }
  }, {
    name: '7714 C',
    rgb: {
      r: 0,
      g: 118,
      b: 128
    }
  }, {
    name: '7715 C',
    rgb: {
      r: 0,
      g: 98,
      b: 105
    }
  }, {
    name: '317 C',
    rgb: {
      r: 177,
      g: 228,
      b: 227
    }
  }, {
    name: '318 C',
    rgb: {
      r: 136,
      g: 219,
      b: 223
    }
  }, {
    name: '319 C',
    rgb: {
      r: 45,
      g: 204,
      b: 211
    }
  }, {
    name: '320 C',
    rgb: {
      r: 0,
      g: 156,
      b: 166
    }
  }, {
    name: '321 C',
    rgb: {
      r: 0,
      g: 140,
      b: 149
    }
  }, {
    name: '322 C',
    rgb: {
      r: 0,
      g: 115,
      b: 119
    }
  }, {
    name: '323 C',
    rgb: {
      r: 0,
      g: 95,
      b: 97
    }
  }, {
    name: '7464 C',
    rgb: {
      r: 160,
      g: 209,
      b: 202
    }
  }, {
    name: '7465 C',
    rgb: {
      r: 64,
      g: 193,
      b: 172
    }
  }, {
    name: '7466 C',
    rgb: {
      r: 0,
      g: 176,
      b: 185
    }
  }, {
    name: '7467 C',
    rgb: {
      r: 0,
      g: 163,
      b: 173
    }
  }, {
    name: '7468 C',
    rgb: {
      r: 0,
      g: 115,
      b: 152
    }
  }, {
    name: '7469 C',
    rgb: {
      r: 0,
      g: 95,
      b: 134
    }
  }, {
    name: '7470 C',
    rgb: {
      r: 0,
      g: 90,
      b: 112
    }
  }, {
    name: '7471 C',
    rgb: {
      r: 126,
      g: 221,
      b: 211
    }
  }, {
    name: '7472 C',
    rgb: {
      r: 92,
      g: 184,
      b: 178
    }
  }, {
    name: '7473 C',
    rgb: {
      r: 39,
      g: 153,
      b: 137
    }
  }, {
    name: '7474 C',
    rgb: {
      r: 0,
      g: 118,
      b: 129
    }
  }, {
    name: '7475 C',
    rgb: {
      r: 72,
      g: 122,
      b: 123
    }
  }, {
    name: '7476 C',
    rgb: {
      r: 13,
      g: 82,
      b: 87
    }
  }, {
    name: '7477 C',
    rgb: {
      r: 36,
      g: 76,
      b: 90
    }
  }, {
    name: '5523 C',
    rgb: {
      r: 182,
      g: 207,
      b: 208
    }
  }, {
    name: '5513 C',
    rgb: {
      r: 171,
      g: 199,
      b: 202
    }
  }, {
    name: '5503 C',
    rgb: {
      r: 148,
      g: 183,
      b: 187
    }
  }, {
    name: '5493 C',
    rgb: {
      r: 127,
      g: 169,
      b: 174
    }
  }, {
    name: '5483 C',
    rgb: {
      r: 79,
      g: 134,
      b: 142
    }
  }, {
    name: '5473 C',
    rgb: {
      r: 17,
      g: 94,
      b: 103
    }
  }, {
    name: '5463 C',
    rgb: {
      r: 7,
      g: 39,
      b: 45
    }
  }, {
    name: '7716 C',
    rgb: {
      r: 0,
      g: 150,
      b: 143
    }
  }, {
    name: '7717 C',
    rgb: {
      r: 0,
      g: 133,
      b: 125
    }
  }, {
    name: '7718 C',
    rgb: {
      r: 0,
      g: 118,
      b: 114
    }
  }, {
    name: '7719 C',
    rgb: {
      r: 0,
      g: 109,
      b: 104
    }
  }, {
    name: '7720 C',
    rgb: {
      r: 0,
      g: 99,
      b: 91
    }
  }, {
    name: '7721 C',
    rgb: {
      r: 0,
      g: 94,
      b: 93
    }
  }, {
    name: '7722 C',
    rgb: {
      r: 0,
      g: 81,
      b: 81
    }
  }, {
    name: '324 C',
    rgb: {
      r: 156,
      g: 219,
      b: 217
    }
  }, {
    name: '325 C',
    rgb: {
      r: 100,
      g: 204,
      b: 201
    }
  }, {
    name: '326 C',
    rgb: {
      r: 0,
      g: 178,
      b: 169
    }
  }, {
    name: '327 C',
    rgb: {
      r: 0,
      g: 134,
      b: 117
    }
  }, {
    name: '328 C',
    rgb: {
      r: 0,
      g: 115,
      b: 103
    }
  }, {
    name: '329 C',
    rgb: {
      r: 0,
      g: 104,
      b: 94
    }
  }, {
    name: '330 C',
    rgb: {
      r: 0,
      g: 83,
      b: 76
    }
  }, {
    name: '3242 C',
    rgb: {
      r: 113,
      g: 219,
      b: 212
    }
  }, {
    name: '3252 C',
    rgb: {
      r: 42,
      g: 210,
      b: 201
    }
  }, {
    name: '3262 C',
    rgb: {
      r: 0,
      g: 191,
      b: 179
    }
  }, {
    name: '3272 C',
    rgb: {
      r: 0,
      g: 164,
      b: 153
    }
  }, {
    name: '3282 C',
    rgb: {
      r: 0,
      g: 133,
      b: 120
    }
  }, {
    name: '3292 C',
    rgb: {
      r: 0,
      g: 89,
      b: 79
    }
  }, {
    name: '3302 C',
    rgb: {
      r: 0,
      g: 76,
      b: 69
    }
  }, {
    name: '3245 C',
    rgb: {
      r: 124,
      g: 224,
      b: 211
    }
  }, {
    name: '3255 C',
    rgb: {
      r: 44,
      g: 213,
      b: 196
    }
  }, {
    name: '3265 C',
    rgb: {
      r: 0,
      g: 199,
      b: 177
    }
  }, {
    name: '3275 C',
    rgb: {
      r: 0,
      g: 179,
      b: 152
    }
  }, {
    name: '3285 C',
    rgb: {
      r: 0,
      g: 150,
      b: 129
    }
  }, {
    name: '3295 C',
    rgb: {
      r: 0,
      g: 120,
      b: 100
    }
  }, {
    name: '3305 C',
    rgb: {
      r: 0,
      g: 78,
      b: 66
    }
  }, {
    name: '3248 C',
    rgb: {
      r: 109,
      g: 205,
      b: 184
    }
  }, {
    name: '3258 C',
    rgb: {
      r: 73,
      g: 197,
      b: 177
    }
  }, {
    name: '3268 C',
    rgb: {
      r: 0,
      g: 171,
      b: 142
    }
  }, {
    name: '3278 C',
    rgb: {
      r: 0,
      g: 155,
      b: 119
    }
  }, {
    name: '3288 C',
    rgb: {
      r: 0,
      g: 130,
      b: 100
    }
  }, {
    name: '3298 C',
    rgb: {
      r: 0,
      g: 106,
      b: 82
    }
  }, {
    name: '3308 C',
    rgb: {
      r: 3,
      g: 70,
      b: 56
    }
  }, {
    name: '566 C',
    rgb: {
      r: 185,
      g: 220,
      b: 210
    }
  }, {
    name: '565 C',
    rgb: {
      r: 161,
      g: 214,
      b: 202
    }
  }, {
    name: '564 C',
    rgb: {
      r: 134,
      g: 200,
      b: 188
    }
  }, {
    name: '563 C',
    rgb: {
      r: 107,
      g: 187,
      b: 174
    }
  }, {
    name: '562 C',
    rgb: {
      r: 0,
      g: 111,
      b: 98
    }
  }, {
    name: '561 C',
    rgb: {
      r: 0,
      g: 89,
      b: 76
    }
  }, {
    name: '560 C',
    rgb: {
      r: 29,
      g: 60,
      b: 52
    }
  }, {
    name: '573 C',
    rgb: {
      r: 181,
      g: 227,
      b: 216
    }
  }, {
    name: '572 C',
    rgb: {
      r: 165,
      g: 223,
      b: 211
    }
  }, {
    name: '571 C',
    rgb: {
      r: 152,
      g: 219,
      b: 206
    }
  }, {
    name: '570 C',
    rgb: {
      r: 107,
      g: 202,
      b: 186
    }
  }, {
    name: '569 C',
    rgb: {
      r: 0,
      g: 129,
      b: 109
    }
  }, {
    name: '568 C',
    rgb: {
      r: 0,
      g: 108,
      b: 91
    }
  }, {
    name: '567 C',
    rgb: {
      r: 23,
      g: 63,
      b: 53
    }
  }, {
    name: '559 C',
    rgb: {
      r: 173,
      g: 202,
      b: 184
    }
  }, {
    name: '558 C',
    rgb: {
      r: 154,
      g: 190,
      b: 170
    }
  }, {
    name: '557 C',
    rgb: {
      r: 133,
      g: 176,
      b: 154
    }
  }, {
    name: '556 C',
    rgb: {
      r: 111,
      g: 162,
      b: 135
    }
  }, {
    name: '555 C',
    rgb: {
      r: 40,
      g: 114,
      b: 79
    }
  }, {
    name: '554 C',
    rgb: {
      r: 32,
      g: 92,
      b: 64
    }
  }, {
    name: '553 C',
    rgb: {
      r: 40,
      g: 71,
      b: 52
    }
  }, {
    name: '5595 C',
    rgb: {
      r: 191,
      g: 206,
      b: 194
    }
  }, {
    name: '5585 C',
    rgb: {
      r: 167,
      g: 189,
      b: 177
    }
  }, {
    name: '5575 C',
    rgb: {
      r: 146,
      g: 172,
      b: 160
    }
  }, {
    name: '5565 C',
    rgb: {
      r: 127,
      g: 156,
      b: 144
    }
  }, {
    name: '5555 C',
    rgb: {
      r: 92,
      g: 127,
      b: 113
    }
  }, {
    name: '5545 C',
    rgb: {
      r: 67,
      g: 105,
      b: 91
    }
  }, {
    name: '5535 C',
    rgb: {
      r: 24,
      g: 48,
      b: 40
    }
  }, {
    name: '5665 C',
    rgb: {
      r: 186,
      g: 197,
      b: 185
    }
  }, {
    name: '5655 C',
    rgb: {
      r: 176,
      g: 189,
      b: 176
    }
  }, {
    name: '5645 C',
    rgb: {
      r: 163,
      g: 178,
      b: 164
    }
  }, {
    name: '5635 C',
    rgb: {
      r: 148,
      g: 165,
      b: 150
    }
  }, {
    name: '5625 C',
    rgb: {
      r: 112,
      g: 133,
      b: 115
    }
  }, {
    name: '5615 C',
    rgb: {
      r: 94,
      g: 116,
      b: 97
    }
  }, {
    name: '5605 C',
    rgb: {
      r: 34,
      g: 55,
      b: 43
    }
  }, {
    name: '5527 C',
    rgb: {
      r: 188,
      g: 201,
      b: 197
    }
  }, {
    name: '5517 C',
    rgb: {
      r: 177,
      g: 192,
      b: 188
    }
  }, {
    name: '5507 C',
    rgb: {
      r: 157,
      g: 176,
      b: 172
    }
  }, {
    name: '5497 C',
    rgb: {
      r: 130,
      g: 153,
      b: 149
    }
  }, {
    name: '5487 C',
    rgb: {
      r: 93,
      g: 121,
      b: 117
    }
  }, {
    name: '5477 C',
    rgb: {
      r: 62,
      g: 93,
      b: 88
    }
  }, {
    name: '5467 C',
    rgb: {
      r: 24,
      g: 51,
      b: 47
    }
  }, {
    name: '621 C',
    rgb: {
      r: 209,
      g: 224,
      b: 215
    }
  }, {
    name: '622 C',
    rgb: {
      r: 183,
      g: 205,
      b: 194
    }
  }, {
    name: '623 C',
    rgb: {
      r: 154,
      g: 185,
      b: 173
    }
  }, {
    name: '624 C',
    rgb: {
      r: 120,
      g: 159,
      b: 144
    }
  }, {
    name: '625 C',
    rgb: {
      r: 80,
      g: 127,
      b: 112
    }
  }, {
    name: '626 C',
    rgb: {
      r: 40,
      g: 92,
      b: 77
    }
  }, {
    name: '627 C',
    rgb: {
      r: 19,
      g: 50,
      b: 43
    }
  }, {
    name: '331 C',
    rgb: {
      r: 167,
      g: 230,
      b: 215
    }
  }, {
    name: '332 C',
    rgb: {
      r: 140,
      g: 226,
      b: 208
    }
  }, {
    name: '333 C',
    rgb: {
      r: 60,
      g: 219,
      b: 192
    }
  }, {
    name: '334 C',
    rgb: {
      r: 0,
      g: 151,
      b: 117
    }
  }, {
    name: '335 C',
    rgb: {
      r: 0,
      g: 123,
      b: 95
    }
  }, {
    name: '336 C',
    rgb: {
      r: 0,
      g: 102,
      b: 79
    }
  }, {
    name: '337 C',
    rgb: {
      r: 143,
      g: 214,
      b: 189
    }
  }, {
    name: '338 C',
    rgb: {
      r: 110,
      g: 206,
      b: 178
    }
  }, {
    name: '339 C',
    rgb: {
      r: 0,
      g: 179,
      b: 136
    }
  }, {
    name: '340 C',
    rgb: {
      r: 0,
      g: 150,
      b: 94
    }
  }, {
    name: '341 C',
    rgb: {
      r: 0,
      g: 122,
      b: 83
    }
  }, {
    name: '342 C',
    rgb: {
      r: 0,
      g: 103,
      b: 71
    }
  }, {
    name: '343 C',
    rgb: {
      r: 17,
      g: 87,
      b: 64
    }
  }, {
    name: '7723 C',
    rgb: {
      r: 80,
      g: 166,
      b: 132
    }
  }, {
    name: '7724 C',
    rgb: {
      r: 0,
      g: 150,
      b: 108
    }
  }, {
    name: '7725 C',
    rgb: {
      r: 0,
      g: 135,
      b: 85
    }
  }, {
    name: '7726 C',
    rgb: {
      r: 0,
      g: 123,
      b: 75
    }
  }, {
    name: '7727 C',
    rgb: {
      r: 0,
      g: 111,
      b: 68
    }
  }, {
    name: '7728 C',
    rgb: {
      r: 0,
      g: 104,
      b: 69
    }
  }, {
    name: '7729 C',
    rgb: {
      r: 0,
      g: 88,
      b: 68
    }
  }, {
    name: '3375 C',
    rgb: {
      r: 122,
      g: 225,
      b: 191
    }
  }, {
    name: '3385 C',
    rgb: {
      r: 71,
      g: 215,
      b: 172
    }
  }, {
    name: '3395 C',
    rgb: {
      r: 0,
      g: 195,
      b: 137
    }
  }, {
    name: '3405 C',
    rgb: {
      r: 0,
      g: 175,
      b: 102
    }
  }, {
    name: '3415 C',
    rgb: {
      r: 0,
      g: 119,
      b: 73
    }
  }, {
    name: '3425 C',
    rgb: {
      r: 0,
      g: 99,
      b: 65
    }
  }, {
    name: '3435 C',
    rgb: {
      r: 21,
      g: 71,
      b: 52
    }
  }, {
    name: '344 C',
    rgb: {
      r: 160,
      g: 218,
      b: 179
    }
  }, {
    name: '345 C',
    rgb: {
      r: 145,
      g: 214,
      b: 172
    }
  }, {
    name: '346 C',
    rgb: {
      r: 113,
      g: 204,
      b: 152
    }
  }, {
    name: '347 C',
    rgb: {
      r: 0,
      g: 154,
      b: 68
    }
  }, {
    name: '348 C',
    rgb: {
      r: 0,
      g: 132,
      b: 61
    }
  }, {
    name: '349 C',
    rgb: {
      r: 4,
      g: 106,
      b: 56
    }
  }, {
    name: '350 C',
    rgb: {
      r: 44,
      g: 82,
      b: 52
    }
  }, {
    name: '351 C',
    rgb: {
      r: 162,
      g: 228,
      b: 184
    }
  }, {
    name: '352 C',
    rgb: {
      r: 143,
      g: 226,
      b: 176
    }
  }, {
    name: '353 C',
    rgb: {
      r: 128,
      g: 224,
      b: 167
    }
  }, {
    name: '354 C',
    rgb: {
      r: 0,
      g: 177,
      b: 64
    }
  }, {
    name: '355 C',
    rgb: {
      r: 0,
      g: 150,
      b: 57
    }
  }, {
    name: '356 C',
    rgb: {
      r: 0,
      g: 122,
      b: 51
    }
  }, {
    name: '357 C',
    rgb: {
      r: 33,
      g: 87,
      b: 50
    }
  }, {
    name: '7478 C',
    rgb: {
      r: 155,
      g: 227,
      b: 191
    }
  }, {
    name: '7479 C',
    rgb: {
      r: 38,
      g: 208,
      b: 124
    }
  }, {
    name: '7480 C',
    rgb: {
      r: 0,
      g: 191,
      b: 111
    }
  }, {
    name: '7481 C',
    rgb: {
      r: 0,
      g: 183,
      b: 79
    }
  }, {
    name: '7482 C',
    rgb: {
      r: 0,
      g: 159,
      b: 77
    }
  }, {
    name: '7483 C',
    rgb: {
      r: 39,
      g: 93,
      b: 56
    }
  }, {
    name: '7484 C',
    rgb: {
      r: 0,
      g: 87,
      b: 63
    }
  }, {
    name: '7730 C',
    rgb: {
      r: 75,
      g: 149,
      b: 96
    }
  }, {
    name: '7731 C',
    rgb: {
      r: 34,
      g: 136,
      b: 72
    }
  }, {
    name: '7732 C',
    rgb: {
      r: 0,
      g: 122,
      b: 62
    }
  }, {
    name: '7733 C',
    rgb: {
      r: 0,
      g: 112,
      b: 65
    }
  }, {
    name: '7734 C',
    rgb: {
      r: 40,
      g: 97,
      b: 64
    }
  }, {
    name: '7735 C',
    rgb: {
      r: 54,
      g: 87,
      b: 59
    }
  }, {
    name: '7736 C',
    rgb: {
      r: 57,
      g: 85,
      b: 66
    }
  }, {
    name: '7737 C',
    rgb: {
      r: 107,
      g: 165,
      b: 57
    }
  }, {
    name: '7738 C',
    rgb: {
      r: 72,
      g: 162,
      b: 63
    }
  }, {
    name: '7739 C',
    rgb: {
      r: 49,
      g: 155,
      b: 66
    }
  }, {
    name: '7740 C',
    rgb: {
      r: 58,
      g: 145,
      b: 63
    }
  }, {
    name: '7741 C',
    rgb: {
      r: 68,
      g: 136,
      b: 62
    }
  }, {
    name: '7742 C',
    rgb: {
      r: 74,
      g: 119,
      b: 60
    }
  }, {
    name: '7743 C',
    rgb: {
      r: 68,
      g: 105,
      b: 61
    }
  }, {
    name: '358 C',
    rgb: {
      r: 173,
      g: 220,
      b: 145
    }
  }, {
    name: '359 C',
    rgb: {
      r: 161,
      g: 216,
      b: 132
    }
  }, {
    name: '360 C',
    rgb: {
      r: 108,
      g: 194,
      b: 74
    }
  }, {
    name: '361 C',
    rgb: {
      r: 67,
      g: 176,
      b: 42
    }
  }, {
    name: '362 C',
    rgb: {
      r: 80,
      g: 158,
      b: 47
    }
  }, {
    name: '363 C',
    rgb: {
      r: 76,
      g: 140,
      b: 43
    }
  }, {
    name: '364 C',
    rgb: {
      r: 74,
      g: 119,
      b: 41
    }
  }, {
    name: '7485 C',
    rgb: {
      r: 208,
      g: 222,
      b: 187
    }
  }, {
    name: '7486 C',
    rgb: {
      r: 188,
      g: 225,
      b: 148
    }
  }, {
    name: '7487 C',
    rgb: {
      r: 142,
      g: 221,
      b: 101
    }
  }, {
    name: '7488 C',
    rgb: {
      r: 120,
      g: 214,
      b: 75
    }
  }, {
    name: '7489 C',
    rgb: {
      r: 116,
      g: 170,
      b: 80
    }
  }, {
    name: '7490 C',
    rgb: {
      r: 113,
      g: 153,
      b: 73
    }
  }, {
    name: '7491 C',
    rgb: {
      r: 121,
      g: 134,
      b: 60
    }
  }, {
    name: '365 C',
    rgb: {
      r: 194,
      g: 225,
      b: 137
    }
  }, {
    name: '366 C',
    rgb: {
      r: 183,
      g: 221,
      b: 121
    }
  }, {
    name: '367 C',
    rgb: {
      r: 164,
      g: 214,
      b: 94
    }
  }, {
    name: '368 C',
    rgb: {
      r: 120,
      g: 190,
      b: 32
    }
  }, {
    name: '369 C',
    rgb: {
      r: 100,
      g: 167,
      b: 11
    }
  }, {
    name: '370 C',
    rgb: {
      r: 101,
      g: 141,
      b: 27
    }
  }, {
    name: '371 C',
    rgb: {
      r: 84,
      g: 98,
      b: 35
    }
  }, {
    name: '372 C',
    rgb: {
      r: 212,
      g: 235,
      b: 142
    }
  }, {
    name: '373 C',
    rgb: {
      r: 205,
      g: 234,
      b: 128
    }
  }, {
    name: '374 C',
    rgb: {
      r: 197,
      g: 232,
      b: 108
    }
  }, {
    name: '375 C',
    rgb: {
      r: 151,
      g: 215,
      b: 0
    }
  }, {
    name: '376 C',
    rgb: {
      r: 132,
      g: 189,
      b: 0
    }
  }, {
    name: '377 C',
    rgb: {
      r: 122,
      g: 154,
      b: 1
    }
  }, {
    name: '378 C',
    rgb: {
      r: 89,
      g: 98,
      b: 29
    }
  }, {
    name: '580 C',
    rgb: {
      r: 196,
      g: 214,
      b: 164
    }
  }, {
    name: '579 C',
    rgb: {
      r: 188,
      g: 209,
      b: 155
    }
  }, {
    name: '578 C',
    rgb: {
      r: 183,
      g: 206,
      b: 149
    }
  }, {
    name: '577 C',
    rgb: {
      r: 169,
      g: 196,
      b: 127
    }
  }, {
    name: '576 C',
    rgb: {
      r: 120,
      g: 157,
      b: 74
    }
  }, {
    name: '575 C',
    rgb: {
      r: 103,
      g: 130,
      b: 58
    }
  }, {
    name: '574 C',
    rgb: {
      r: 78,
      g: 91,
      b: 49
    }
  }, {
    name: '5807 C',
    rgb: {
      r: 208,
      g: 209,
      b: 171
    }
  }, {
    name: '5797 C',
    rgb: {
      r: 198,
      g: 200,
      b: 155
    }
  }, {
    name: '5787 C',
    rgb: {
      r: 186,
      g: 189,
      b: 139
    }
  }, {
    name: '5777 C',
    rgb: {
      r: 162,
      g: 165,
      b: 105
    }
  }, {
    name: '5767 C',
    rgb: {
      r: 138,
      g: 141,
      b: 74
    }
  }, {
    name: '5757 C',
    rgb: {
      r: 109,
      g: 113,
      b: 46
    }
  }, {
    name: '5747 C',
    rgb: {
      r: 61,
      g: 68,
      b: 30
    }
  }, {
    name: '5875 C',
    rgb: {
      r: 210,
      g: 206,
      b: 158
    }
  }, {
    name: '5865 C',
    rgb: {
      r: 203,
      g: 199,
      b: 147
    }
  }, {
    name: '5855 C',
    rgb: {
      r: 192,
      g: 187,
      b: 135
    }
  }, {
    name: '5845 C',
    rgb: {
      r: 175,
      g: 169,
      b: 110
    }
  }, {
    name: '5835 C',
    rgb: {
      r: 160,
      g: 153,
      b: 88
    }
  }, {
    name: '5825 C',
    rgb: {
      r: 137,
      g: 129,
      b: 61
    }
  }, {
    name: '5815 C',
    rgb: {
      r: 85,
      g: 80,
      b: 37
    }
  }, {
    name: '5803 C',
    rgb: {
      r: 195,
      g: 198,
      b: 168
    }
  }, {
    name: '5793 C',
    rgb: {
      r: 179,
      g: 185,
      b: 149
    }
  }, {
    name: '5783 C',
    rgb: {
      r: 163,
      g: 170,
      b: 131
    }
  }, {
    name: '5773 C',
    rgb: {
      r: 137,
      g: 144,
      b: 100
    }
  }, {
    name: '5763 C',
    rgb: {
      r: 115,
      g: 123,
      b: 76
    }
  }, {
    name: '5753 C',
    rgb: {
      r: 94,
      g: 103,
      b: 56
    }
  }, {
    name: '5743 C',
    rgb: {
      r: 62,
      g: 72,
      b: 39
    }
  }, {
    name: '7492 C',
    rgb: {
      r: 191,
      g: 204,
      b: 128
    }
  }, {
    name: '7493 C',
    rgb: {
      r: 187,
      g: 197,
      b: 146
    }
  }, {
    name: '7494 C',
    rgb: {
      r: 156,
      g: 175,
      b: 136
    }
  }, {
    name: '7495 C',
    rgb: {
      r: 143,
      g: 153,
      b: 62
    }
  }, {
    name: '7496 C',
    rgb: {
      r: 118,
      g: 136,
      b: 29
    }
  }, {
    name: '7497 C',
    rgb: {
      r: 122,
      g: 114,
      b: 86
    }
  }, {
    name: '7498 C',
    rgb: {
      r: 91,
      g: 98,
      b: 54
    }
  }, {
    name: '7744 C',
    rgb: {
      r: 186,
      g: 188,
      b: 22
    }
  }, {
    name: '7745 C',
    rgb: {
      r: 171,
      g: 173,
      b: 35
    }
  }, {
    name: '7746 C',
    rgb: {
      r: 153,
      g: 155,
      b: 48
    }
  }, {
    name: '7747 C',
    rgb: {
      r: 136,
      g: 141,
      b: 48
    }
  }, {
    name: '7748 C',
    rgb: {
      r: 124,
      g: 128,
      b: 52
    }
  }, {
    name: '7749 C',
    rgb: {
      r: 114,
      g: 115,
      b: 55
    }
  }, {
    name: '7750 C',
    rgb: {
      r: 101,
      g: 102,
      b: 53
    }
  }, {
    name: '379 C',
    rgb: {
      r: 226,
      g: 232,
      b: 104
    }
  }, {
    name: '380 C',
    rgb: {
      r: 219,
      g: 228,
      b: 66
    }
  }, {
    name: '381 C',
    rgb: {
      r: 206,
      g: 220,
      b: 0
    }
  }, {
    name: '382 C',
    rgb: {
      r: 196,
      g: 214,
      b: 0
    }
  }, {
    name: '383 C',
    rgb: {
      r: 168,
      g: 173,
      b: 0
    }
  }, {
    name: '384 C',
    rgb: {
      r: 148,
      g: 147,
      b: 0
    }
  }, {
    name: '385 C',
    rgb: {
      r: 120,
      g: 113,
      b: 33
    }
  }, {
    name: '386 C',
    rgb: {
      r: 233,
      g: 236,
      b: 107
    }
  }, {
    name: '387 C',
    rgb: {
      r: 227,
      g: 233,
      b: 53
    }
  }, {
    name: '388 C',
    rgb: {
      r: 224,
      g: 231,
      b: 33
    }
  }, {
    name: '389 C',
    rgb: {
      r: 208,
      g: 223,
      b: 0
    }
  }, {
    name: '390 C',
    rgb: {
      r: 181,
      g: 189,
      b: 0
    }
  }, {
    name: '391 C',
    rgb: {
      r: 154,
      g: 149,
      b: 0
    }
  }, {
    name: '392 C',
    rgb: {
      r: 130,
      g: 122,
      b: 4
    }
  }, {
    name: '587 C',
    rgb: {
      r: 227,
      g: 228,
      b: 141
    }
  }, {
    name: '586 C',
    rgb: {
      r: 224,
      g: 226,
      b: 124
    }
  }, {
    name: '585 C',
    rgb: {
      r: 219,
      g: 222,
      b: 112
    }
  }, {
    name: '584 C',
    rgb: {
      r: 210,
      g: 215,
      b: 85
    }
  }, {
    name: '583 C',
    rgb: {
      r: 183,
      g: 191,
      b: 16
    }
  }, {
    name: '582 C',
    rgb: {
      r: 142,
      g: 140,
      b: 19
    }
  }, {
    name: '581 C',
    rgb: {
      r: 98,
      g: 93,
      b: 32
    }
  }, {
    name: '393 C',
    rgb: {
      r: 240,
      g: 236,
      b: 116
    }
  }, {
    name: '394 C',
    rgb: {
      r: 237,
      g: 233,
      b: 57
    }
  }, {
    name: '395 C',
    rgb: {
      r: 236,
      g: 232,
      b: 26
    }
  }, {
    name: '396 C',
    rgb: {
      r: 225,
      g: 224,
      b: 0
    }
  }, {
    name: '397 C',
    rgb: {
      r: 191,
      g: 184,
      b: 0
    }
  }, {
    name: '398 C',
    rgb: {
      r: 173,
      g: 164,
      b: 0
    }
  }, {
    name: '399 C',
    rgb: {
      r: 160,
      g: 146,
      b: 0
    }
  }, {
    name: '3935 C',
    rgb: {
      r: 243,
      g: 234,
      b: 93
    }
  }, {
    name: '3945 C',
    rgb: {
      r: 243,
      g: 229,
      b: 0
    }
  }, {
    name: '3955 C',
    rgb: {
      r: 239,
      g: 223,
      b: 0
    }
  }, {
    name: '3965 C',
    rgb: {
      r: 238,
      g: 220,
      b: 0
    }
  }, {
    name: '3975 C',
    rgb: {
      r: 187,
      g: 166,
      b: 0
    }
  }, {
    name: '3985 C',
    rgb: {
      r: 154,
      g: 135,
      b: 0
    }
  }, {
    name: '3995 C',
    rgb: {
      r: 104,
      g: 92,
      b: 32
    }
  }, {
    name: '600 C',
    rgb: {
      r: 241,
      g: 235,
      b: 156
    }
  }, {
    name: '601 C',
    rgb: {
      r: 240,
      g: 233,
      b: 145
    }
  }, {
    name: '602 C',
    rgb: {
      r: 240,
      g: 232,
      b: 123
    }
  }, {
    name: '603 C',
    rgb: {
      r: 237,
      g: 224,
      b: 75
    }
  }, {
    name: '604 C',
    rgb: {
      r: 234,
      g: 218,
      b: 36
    }
  }, {
    name: '605 C',
    rgb: {
      r: 225,
      g: 205,
      b: 0
    }
  }, {
    name: '606 C',
    rgb: {
      r: 207,
      g: 181,
      b: 0
    }
  }, {
    name: '607 C',
    rgb: {
      r: 235,
      g: 228,
      b: 154
    }
  }, {
    name: '608 C',
    rgb: {
      r: 233,
      g: 225,
      b: 134
    }
  }, {
    name: '609 C',
    rgb: {
      r: 230,
      g: 222,
      b: 119
    }
  }, {
    name: '610 C',
    rgb: {
      r: 225,
      g: 213,
      b: 85
    }
  }, {
    name: '611 C',
    rgb: {
      r: 215,
      g: 200,
      b: 38
    }
  }, {
    name: '612 C',
    rgb: {
      r: 196,
      g: 176,
      b: 0
    }
  }, {
    name: '613 C',
    rgb: {
      r: 179,
      g: 155,
      b: 0
    }
  }, {
    name: '461 C',
    rgb: {
      r: 233,
      g: 223,
      b: 151
    }
  }, {
    name: '460 C',
    rgb: {
      r: 228,
      g: 215,
      b: 126
    }
  }, {
    name: '459 C',
    rgb: {
      r: 222,
      g: 205,
      b: 99
    }
  }, {
    name: '458 C',
    rgb: {
      r: 217,
      g: 199,
      b: 86
    }
  }, {
    name: '457 C',
    rgb: {
      r: 184,
      g: 157,
      b: 24
    }
  }, {
    name: '456 C',
    rgb: {
      r: 162,
      g: 142,
      b: 42
    }
  }, {
    name: '455 C',
    rgb: {
      r: 105,
      g: 91,
      b: 36
    }
  }, {
    name: '614 C',
    rgb: {
      r: 220,
      g: 213,
      b: 154
    }
  }, {
    name: '615 C',
    rgb: {
      r: 214,
      g: 207,
      b: 141
    }
  }, {
    name: '616 C',
    rgb: {
      r: 208,
      g: 200,
      b: 131
    }
  }, {
    name: '617 C',
    rgb: {
      r: 192,
      g: 181,
      b: 97
    }
  }, {
    name: '618 C',
    rgb: {
      r: 172,
      g: 159,
      b: 60
    }
  }, {
    name: '619 C',
    rgb: {
      r: 159,
      g: 145,
      b: 42
    }
  }, {
    name: '620 C',
    rgb: {
      r: 138,
      g: 123,
      b: 25
    }
  }, {
    name: '7751 C',
    rgb: {
      r: 202,
      g: 182,
      b: 75
    }
  }, {
    name: '7752 C',
    rgb: {
      r: 207,
      g: 176,
      b: 35
    }
  }, {
    name: '7753 C',
    rgb: {
      r: 193,
      g: 160,
      b: 30
    }
  }, {
    name: '7754 C',
    rgb: {
      r: 160,
      g: 134,
      b: 41
    }
  }, {
    name: '7755 C',
    rgb: {
      r: 137,
      g: 118,
      b: 48
    }
  }, {
    name: '7756 C',
    rgb: {
      r: 115,
      g: 102,
      b: 53
    }
  }, {
    name: '7757 C',
    rgb: {
      r: 103,
      g: 94,
      b: 51
    }
  }, {
    name: '7758 C',
    rgb: {
      r: 212,
      g: 195,
      b: 4
    }
  }, {
    name: '7759 C',
    rgb: {
      r: 196,
      g: 178,
      b: 0
    }
  }, {
    name: '7760 C',
    rgb: {
      r: 145,
      g: 133,
      b: 44
    }
  }, {
    name: '7761 C',
    rgb: {
      r: 116,
      g: 113,
      b: 54
    }
  }, {
    name: '7762 C',
    rgb: {
      r: 93,
      g: 100,
      b: 57
    }
  }, {
    name: '7763 C',
    rgb: {
      r: 88,
      g: 92,
      b: 59
    }
  }, {
    name: '7764 C',
    rgb: {
      r: 83,
      g: 84,
      b: 53
    }
  }, {
    name: '7765 C',
    rgb: {
      r: 187,
      g: 179,
      b: 35
    }
  }, {
    name: '7766 C',
    rgb: {
      r: 180,
      g: 169,
      b: 31
    }
  }, {
    name: '7767 C',
    rgb: {
      r: 170,
      g: 157,
      b: 46
    }
  }, {
    name: '7768 C',
    rgb: {
      r: 143,
      g: 126,
      b: 53
    }
  }, {
    name: '7769 C',
    rgb: {
      r: 113,
      g: 97,
      b: 53
    }
  }, {
    name: '7770 C',
    rgb: {
      r: 99,
      g: 89,
      b: 57
    }
  }, {
    name: '7771 C',
    rgb: {
      r: 78,
      g: 73,
      b: 52
    }
  }, {
    name: '4545 C',
    rgb: {
      r: 213,
      g: 203,
      b: 159
    }
  }, {
    name: '4535 C',
    rgb: {
      r: 207,
      g: 196,
      b: 147
    }
  }, {
    name: '4525 C',
    rgb: {
      r: 197,
      g: 183,
      b: 131
    }
  }, {
    name: '4515 C',
    rgb: {
      r: 179,
      g: 163,
      b: 105
    }
  }, {
    name: '4505 C',
    rgb: {
      r: 153,
      g: 133,
      b: 66
    }
  }, {
    name: '4495 C',
    rgb: {
      r: 140,
      g: 119,
      b: 50
    }
  }, {
    name: '4485 C',
    rgb: {
      r: 97,
      g: 79,
      b: 37
    }
  }, {
    name: '454 C',
    rgb: {
      r: 202,
      g: 199,
      b: 167
    }
  }, {
    name: '453 C',
    rgb: {
      r: 191,
      g: 187,
      b: 152
    }
  }, {
    name: '452 C',
    rgb: {
      r: 176,
      g: 170,
      b: 126
    }
  }, {
    name: '451 C',
    rgb: {
      r: 155,
      g: 148,
      b: 95
    }
  }, {
    name: '450 C',
    rgb: {
      r: 89,
      g: 74,
      b: 37
    }
  }, {
    name: '449 C',
    rgb: {
      r: 82,
      g: 71,
      b: 39
    }
  }, {
    name: '448 C',
    rgb: {
      r: 74,
      g: 65,
      b: 42
    }
  }, {
    name: '7499 C',
    rgb: {
      r: 241,
      g: 230,
      b: 178
    }
  }, {
    name: '7500 C',
    rgb: {
      r: 223,
      g: 209,
      b: 167
    }
  }, {
    name: '7501 C',
    rgb: {
      r: 217,
      g: 200,
      b: 158
    }
  }, {
    name: '7502 C',
    rgb: {
      r: 206,
      g: 184,
      b: 136
    }
  }, {
    name: '7503 C',
    rgb: {
      r: 168,
      g: 153,
      b: 104
    }
  }, {
    name: '7504 C',
    rgb: {
      r: 148,
      g: 121,
      b: 93
    }
  }, {
    name: '7505 C',
    rgb: {
      r: 129,
      g: 96,
      b: 64
    }
  }, {
    name: '468 C',
    rgb: {
      r: 221,
      g: 203,
      b: 164
    }
  }, {
    name: '467 C',
    rgb: {
      r: 211,
      g: 188,
      b: 141
    }
  }, {
    name: '466 C',
    rgb: {
      r: 198,
      g: 170,
      b: 118
    }
  }, {
    name: '465 C',
    rgb: {
      r: 185,
      g: 151,
      b: 91
    }
  }, {
    name: '464 C',
    rgb: {
      r: 139,
      g: 91,
      b: 41
    }
  }, {
    name: '463 C',
    rgb: {
      r: 116,
      g: 79,
      b: 40
    }
  }, {
    name: '462 C',
    rgb: {
      r: 92,
      g: 70,
      b: 43
    }
  }, {
    name: '7506 C',
    rgb: {
      r: 239,
      g: 219,
      b: 178
    }
  }, {
    name: '7507 C',
    rgb: {
      r: 252,
      g: 210,
      b: 153
    }
  }, {
    name: '7508 C',
    rgb: {
      r: 225,
      g: 184,
      b: 127
    }
  }, {
    name: '7509 C',
    rgb: {
      r: 214,
      g: 164,
      b: 97
    }
  }, {
    name: '7510 C',
    rgb: {
      r: 198,
      g: 137,
      b: 63
    }
  }, {
    name: '7511 C',
    rgb: {
      r: 183,
      g: 119,
      b: 41
    }
  }, {
    name: '7512 C',
    rgb: {
      r: 166,
      g: 99,
      b: 27
    }
  }, {
    name: '719 C',
    rgb: {
      r: 237,
      g: 200,
      b: 163
    }
  }, {
    name: '720 C',
    rgb: {
      r: 231,
      g: 183,
      b: 138
    }
  }, {
    name: '721 C',
    rgb: {
      r: 221,
      g: 164,
      b: 111
    }
  }, {
    name: '722 C',
    rgb: {
      r: 200,
      g: 130,
      b: 66
    }
  }, {
    name: '723 C',
    rgb: {
      r: 179,
      g: 105,
      b: 36
    }
  }, {
    name: '724 C',
    rgb: {
      r: 147,
      g: 77,
      b: 17
    }
  }, {
    name: '725 C',
    rgb: {
      r: 125,
      g: 63,
      b: 22
    }
  }, {
    name: '475 C',
    rgb: {
      r: 243,
      g: 207,
      b: 179
    }
  }, {
    name: '474 C',
    rgb: {
      r: 241,
      g: 198,
      b: 167
    }
  }, {
    name: '473 C',
    rgb: {
      r: 240,
      g: 191,
      b: 155
    }
  }, {
    name: '472 C',
    rgb: {
      r: 229,
      g: 158,
      b: 109
    }
  }, {
    name: '471 C',
    rgb: {
      r: 184,
      g: 97,
      b: 37
    }
  }, {
    name: '470 C',
    rgb: {
      r: 164,
      g: 90,
      b: 42
    }
  }, {
    name: '469 C',
    rgb: {
      r: 105,
      g: 63,
      b: 35
    }
  }, {
    name: '726 C',
    rgb: {
      r: 224,
      g: 192,
      b: 159
    }
  }, {
    name: '727 C',
    rgb: {
      r: 217,
      g: 180,
      b: 143
    }
  }, {
    name: '728 C',
    rgb: {
      r: 205,
      g: 160,
      b: 119
    }
  }, {
    name: '729 C',
    rgb: {
      r: 181,
      g: 129,
      b: 80
    }
  }, {
    name: '730 C',
    rgb: {
      r: 158,
      g: 101,
      b: 46
    }
  }, {
    name: '731 C',
    rgb: {
      r: 119,
      g: 66,
      b: 18
    }
  }, {
    name: '732 C',
    rgb: {
      r: 98,
      g: 52,
      b: 18
    }
  }, {
    name: '4685 C',
    rgb: {
      r: 224,
      g: 198,
      b: 173
    }
  }, {
    name: '4675 C',
    rgb: {
      r: 220,
      g: 191,
      b: 166
    }
  }, {
    name: '4665 C',
    rgb: {
      r: 205,
      g: 167,
      b: 136
    }
  }, {
    name: '4655 C',
    rgb: {
      r: 191,
      g: 148,
      b: 116
    }
  }, {
    name: '4645 C',
    rgb: {
      r: 173,
      g: 124,
      b: 89
    }
  }, {
    name: '4635 C',
    rgb: {
      r: 148,
      g: 96,
      b: 55
    }
  }, {
    name: '4625 C',
    rgb: {
      r: 79,
      g: 44,
      b: 29
    }
  }, {
    name: '7513 C',
    rgb: {
      r: 225,
      g: 183,
      b: 167
    }
  }, {
    name: '7514 C',
    rgb: {
      r: 213,
      g: 162,
      b: 134
    }
  }, {
    name: '7515 C',
    rgb: {
      r: 197,
      g: 139,
      b: 104
    }
  }, {
    name: '7516 C',
    rgb: {
      r: 153,
      g: 85,
      b: 43
    }
  }, {
    name: '7517 C',
    rgb: {
      r: 133,
      g: 67,
      b: 30
    }
  }, {
    name: '7518 C',
    rgb: {
      r: 109,
      g: 79,
      b: 71
    }
  }, {
    name: '7519 C',
    rgb: {
      r: 94,
      g: 75,
      b: 60
    }
  }, {
    name: '4755 C',
    rgb: {
      r: 215,
      g: 196,
      b: 183
    }
  }, {
    name: '4745 C',
    rgb: {
      r: 205,
      g: 181,
      b: 167
    }
  }, {
    name: '4735 C',
    rgb: {
      r: 192,
      g: 163,
      b: 146
    }
  }, {
    name: '4725 C',
    rgb: {
      r: 174,
      g: 138,
      b: 121
    }
  }, {
    name: '4715 C',
    rgb: {
      r: 149,
      g: 108,
      b: 88
    }
  }, {
    name: '4705 C',
    rgb: {
      r: 124,
      g: 77,
      b: 58
    }
  }, {
    name: '4695 C',
    rgb: {
      r: 91,
      g: 52,
      b: 39
    }
  }, {
    name: '482 C',
    rgb: {
      r: 219,
      g: 200,
      b: 182
    }
  }, {
    name: '481 C',
    rgb: {
      r: 211,
      g: 187,
      b: 168
    }
  }, {
    name: '480 C',
    rgb: {
      r: 198,
      g: 169,
      b: 146
    }
  }, {
    name: '479 C',
    rgb: {
      r: 170,
      g: 128,
      b: 102
    }
  }, {
    name: '478 C',
    rgb: {
      r: 112,
      g: 63,
      b: 42
    }
  }, {
    name: '477 C',
    rgb: {
      r: 98,
      g: 59,
      b: 42
    }
  }, {
    name: '476 C',
    rgb: {
      r: 78,
      g: 54,
      b: 41
    }
  }, {
    name: '7527 C',
    rgb: {
      r: 214,
      g: 210,
      b: 196
    }
  }, {
    name: '7528 C',
    rgb: {
      r: 197,
      g: 185,
      b: 172
    }
  }, {
    name: '7529 C',
    rgb: {
      r: 183,
      g: 169,
      b: 154
    }
  }, {
    name: '7530 C',
    rgb: {
      r: 163,
      g: 147,
      b: 130
    }
  }, {
    name: '7531 C',
    rgb: {
      r: 122,
      g: 104,
      b: 85
    }
  }, {
    name: '7532 C',
    rgb: {
      r: 99,
      g: 81,
      b: 61
    }
  }, {
    name: '7533 C',
    rgb: {
      r: 71,
      g: 55,
      b: 41
    }
  }, {
    name: '7534 C',
    rgb: {
      r: 209,
      g: 204,
      b: 189
    }
  }, {
    name: '7535 C',
    rgb: {
      r: 183,
      g: 176,
      b: 156
    }
  }, {
    name: '7536 C',
    rgb: {
      r: 166,
      g: 159,
      b: 136
    }
  }, {
    name: '7537 C',
    rgb: {
      r: 167,
      g: 172,
      b: 162
    }
  }, {
    name: '7538 C',
    rgb: {
      r: 148,
      g: 154,
      b: 144
    }
  }, {
    name: '7539 C',
    rgb: {
      r: 142,
      g: 144,
      b: 137
    }
  }, {
    name: '7540 C',
    rgb: {
      r: 75,
      g: 79,
      b: 84
    }
  }, {
    name: '427 C',
    rgb: {
      r: 208,
      g: 211,
      b: 212
    }
  }, {
    name: '428 C',
    rgb: {
      r: 193,
      g: 198,
      b: 200
    }
  }, {
    name: '429 C',
    rgb: {
      r: 162,
      g: 170,
      b: 173
    }
  }, {
    name: '430 C',
    rgb: {
      r: 124,
      g: 135,
      b: 142
    }
  }, {
    name: '431 C',
    rgb: {
      r: 91,
      g: 103,
      b: 112
    }
  }, {
    name: '432 C',
    rgb: {
      r: 51,
      g: 63,
      b: 72
    }
  }, {
    name: '433 C',
    rgb: {
      r: 29,
      g: 37,
      b: 45
    }
  }, {
    name: '420 C',
    rgb: {
      r: 199,
      g: 201,
      b: 199
    }
  }, {
    name: '421 C',
    rgb: {
      r: 178,
      g: 180,
      b: 178
    }
  }, {
    name: '422 C',
    rgb: {
      r: 158,
      g: 162,
      b: 162
    }
  }, {
    name: '423 C',
    rgb: {
      r: 137,
      g: 141,
      b: 141
    }
  }, {
    name: '424 C',
    rgb: {
      r: 112,
      g: 115,
      b: 114
    }
  }, {
    name: '425 C',
    rgb: {
      r: 84,
      g: 88,
      b: 90
    }
  }, {
    name: '426 C',
    rgb: {
      r: 37,
      g: 40,
      b: 42
    }
  }, {
    name: '441 C',
    rgb: {
      r: 190,
      g: 198,
      b: 196
    }
  }, {
    name: '442 C',
    rgb: {
      r: 162,
      g: 172,
      b: 171
    }
  }, {
    name: '443 C',
    rgb: {
      r: 145,
      g: 157,
      b: 157
    }
  }, {
    name: '444 C',
    rgb: {
      r: 113,
      g: 124,
      b: 125
    }
  }, {
    name: '445 C',
    rgb: {
      r: 80,
      g: 87,
      b: 89
    }
  }, {
    name: '446 C',
    rgb: {
      r: 63,
      g: 68,
      b: 68
    }
  }, {
    name: '447 C',
    rgb: {
      r: 55,
      g: 58,
      b: 54
    }
  }, {
    name: '413 C',
    rgb: {
      r: 186,
      g: 187,
      b: 177
    }
  }, {
    name: '414 C',
    rgb: {
      r: 168,
      g: 169,
      b: 158
    }
  }, {
    name: '415 C',
    rgb: {
      r: 145,
      g: 147,
      b: 136
    }
  }, {
    name: '416 C',
    rgb: {
      r: 126,
      g: 127,
      b: 116
    }
  }, {
    name: '417 C',
    rgb: {
      r: 101,
      g: 102,
      b: 92
    }
  }, {
    name: '418 C',
    rgb: {
      r: 81,
      g: 83,
      b: 74
    }
  }, {
    name: '419 C',
    rgb: {
      r: 33,
      g: 35,
      b: 34
    }
  }, {
    name: '400 C',
    rgb: {
      r: 196,
      g: 191,
      b: 182
    }
  }, {
    name: '401 C',
    rgb: {
      r: 175,
      g: 169,
      b: 160
    }
  }, {
    name: '402 C',
    rgb: {
      r: 157,
      g: 150,
      b: 141
    }
  }, {
    name: '403 C',
    rgb: {
      r: 140,
      g: 133,
      b: 123
    }
  }, {
    name: '404 C',
    rgb: {
      r: 119,
      g: 110,
      b: 100
    }
  }, {
    name: '405 C',
    rgb: {
      r: 105,
      g: 97,
      b: 88
    }
  }, {
    name: '406 C',
    rgb: {
      r: 196,
      g: 188,
      b: 183
    }
  }, {
    name: '407 C',
    rgb: {
      r: 178,
      g: 168,
      b: 162
    }
  }, {
    name: '408 C',
    rgb: {
      r: 151,
      g: 140,
      b: 135
    }
  }, {
    name: '409 C',
    rgb: {
      r: 133,
      g: 120,
      b: 116
    }
  }, {
    name: '410 C',
    rgb: {
      r: 116,
      g: 102,
      b: 97
    }
  }, {
    name: '411 C',
    rgb: {
      r: 94,
      g: 81,
      b: 77
    }
  }, {
    name: '412 C',
    rgb: {
      r: 56,
      g: 47,
      b: 45
    }
  }, {
    name: '434 C',
    rgb: {
      r: 208,
      g: 196,
      b: 197
    }
  }, {
    name: '435 C',
    rgb: {
      r: 193,
      g: 178,
      b: 182
    }
  }, {
    name: '436 C',
    rgb: {
      r: 171,
      g: 152,
      b: 157
    }
  }, {
    name: '437 C',
    rgb: {
      r: 123,
      g: 100,
      b: 105
    }
  }, {
    name: '438 C',
    rgb: {
      r: 88,
      g: 68,
      b: 70
    }
  }, {
    name: '439 C',
    rgb: {
      r: 69,
      g: 53,
      b: 54
    }
  }, {
    name: '440 C',
    rgb: {
      r: 56,
      g: 46,
      b: 44
    }
  }, {
    name: 'Warm Gray 1 C',
    rgb: {
      r: 215,
      g: 210,
      b: 203
    }
  }, {
    name: 'Warm Gray 2 C',
    rgb: {
      r: 203,
      g: 196,
      b: 188
    }
  }, {
    name: 'Warm Gray 3 C',
    rgb: {
      r: 191,
      g: 184,
      b: 175
    }
  }, {
    name: 'Warm Gray 4 C',
    rgb: {
      r: 182,
      g: 173,
      b: 165
    }
  }, {
    name: 'Warm Gray 5 C',
    rgb: {
      r: 172,
      g: 163,
      b: 154
    }
  }, {
    name: 'Warm Gray 6 C',
    rgb: {
      r: 165,
      g: 156,
      b: 148
    }
  }, {
    name: 'Warm Gray 7 C',
    rgb: {
      r: 150,
      g: 140,
      b: 131
    }
  }, {
    name: 'Warm Gray 8 C',
    rgb: {
      r: 140,
      g: 130,
      b: 121
    }
  }, {
    name: 'Warm Gray 9 C',
    rgb: {
      r: 131,
      g: 120,
      b: 111
    }
  }, {
    name: 'Warm Gray 10 C',
    rgb: {
      r: 121,
      g: 110,
      b: 101
    }
  }, {
    name: 'Warm Gray 11 C',
    rgb: {
      r: 110,
      g: 98,
      b: 89
    }
  }, {
    name: 'Cool Gray 1 C',
    rgb: {
      r: 217,
      g: 217,
      b: 214
    }
  }, {
    name: 'Cool Gray 2 C',
    rgb: {
      r: 208,
      g: 208,
      b: 206
    }
  }, {
    name: 'Cool Gray 3 C',
    rgb: {
      r: 200,
      g: 201,
      b: 199
    }
  }, {
    name: 'Cool Gray 4 C',
    rgb: {
      r: 187,
      g: 188,
      b: 188
    }
  }, {
    name: 'Cool Gray 5 C',
    rgb: {
      r: 177,
      g: 179,
      b: 179
    }
  }, {
    name: 'Cool Gray 6 C',
    rgb: {
      r: 167,
      g: 168,
      b: 170
    }
  }, {
    name: 'Cool Gray 7 C',
    rgb: {
      r: 151,
      g: 153,
      b: 155
    }
  }, {
    name: 'Cool Gray 8 C',
    rgb: {
      r: 136,
      g: 139,
      b: 141
    }
  }, {
    name: 'Cool Gray 9 C',
    rgb: {
      r: 117,
      g: 120,
      b: 123
    }
  }, {
    name: 'Cool Gray 10 C',
    rgb: {
      r: 99,
      g: 102,
      b: 106
    }
  }, {
    name: 'Cool Gray 11 C',
    rgb: {
      r: 83,
      g: 86,
      b: 90
    }
  }, {
    name: 'Black 2 C',
    rgb: {
      r: 51,
      g: 47,
      b: 33
    }
  }, {
    name: 'Black 3 C',
    rgb: {
      r: 33,
      g: 39,
      b: 33
    }
  }, {
    name: 'Black 4 C',
    rgb: {
      r: 49,
      g: 38,
      b: 29
    }
  }, {
    name: 'Black 5 C',
    rgb: {
      r: 62,
      g: 43,
      b: 46
    }
  }, {
    name: 'Black 6 C',
    rgb: {
      r: 16,
      g: 24,
      b: 32
    }
  }, {
    name: 'Black 7 C',
    rgb: {
      r: 61,
      g: 57,
      b: 53
    }
  }, {
    name: 'Black',
    rgb: {
      r: 0,
      g: 0,
      b: 0
    }
  }, {
    name: 'White',
    rgb: {
      r: 255,
      g: 255,
      b: 255
    }
  }],
  ral: [{
    ral: 1000,
    name: 'GreenBeige',
    LRV: 50,
    cmyk: {
      c: 0,
      m: 7,
      y: 32,
      k: 21
    },
    rgb: {
      r: 201,
      g: 187,
      b: 136
    },
    lab: {
      l: 76.022,
      a: -0.366,
      b: 27.636
    }
  }, {
    ral: 1001,
    name: 'Beige',
    LRV: 46,
    cmyk: {
      c: 0,
      m: 14,
      y: 36,
      k: 20
    },
    rgb: {
      r: 204,
      g: 176,
      b: 131
    },
    lab: {
      l: 73.595,
      a: 5.518,
      b: 26.95
    }
  }, {
    ral: 1002,
    name: 'SandYellow',
    LRV: 44,
    cmyk: {
      c: 0,
      m: 17,
      y: 47,
      k: 20
    },
    rgb: {
      r: 205,
      g: 170,
      b: 109
    },
    lab: {
      l: 71.934,
      a: 7.362,
      b: 36.744
    }
  }, {
    ral: 1003,
    name: 'SignalYellow',
    LRV: 48,
    cmyk: {
      c: 0,
      m: 30,
      y: 100,
      k: 5
    },
    rgb: {
      r: 242,
      g: 169,
      b: 0
    },
    lab: {
      l: 75.041,
      a: 19.801,
      b: 80.264
    }
  }, {
    ral: 1004,
    name: 'GoldenYellow',
    LRV: 41,
    cmyk: {
      c: 0,
      m: 28,
      y: 100,
      k: 13
    },
    rgb: {
      r: 221,
      g: 159,
      b: 0
    },
    lab: {
      l: 70.089,
      a: 16.1,
      b: 78.815
    }
  }, {
    ral: 1005,
    name: 'HoneyYellow',
    LRV: 32,
    cmyk: {
      c: 0,
      m: 27,
      y: 100,
      k: 23
    },
    rgb: {
      r: 197,
      g: 143,
      b: 0
    },
    lab: {
      l: 63.448,
      a: 13.382,
      b: 74.694
    }
  }, {
    ral: 1006,
    name: 'MaizeYellow',
    LRV: 36,
    cmyk: {
      c: 0,
      m: 34,
      y: 100,
      k: 14
    },
    rgb: {
      r: 219,
      g: 145,
      b: 0
    },
    lab: {
      l: 66.562,
      a: 22.472,
      b: 76.492
    }
  }, {
    ral: 1007,
    name: 'DaffodilYellow',
    LRV: 36,
    cmyk: {
      c: 0,
      m: 38,
      y: 100,
      k: 11
    },
    rgb: {
      r: 226,
      g: 141,
      b: 0
    },
    lab: {
      l: 66.5,
      a: 27.308,
      b: 80.402
    }
  }, {
    ral: 1011,
    name: 'BrownBeige',
    LRV: 25,
    cmyk: {
      c: 0,
      m: 25,
      y: 54,
      k: 33
    },
    rgb: {
      r: 171,
      g: 129,
      b: 79
    },
    lab: {
      l: 57.338,
      a: 12.518,
      b: 33.353
    }
  }, {
    ral: 1012,
    name: 'LemonYellow',
    LRV: 46,
    cmyk: {
      c: 0,
      m: 18,
      y: 83,
      k: 16
    },
    rgb: {
      r: 214,
      g: 176,
      b: 37
    },
    lab: {
      l: 73.615,
      a: 4.946,
      b: 68.938
    }
  }, {
    ral: 1013,
    name: 'OysterWhite',
    LRV: 70,
    cmyk: {
      c: 0,
      m: 3,
      y: 12,
      k: 12
    },
    rgb: {
      r: 225,
      g: 218,
      b: 199
    },
    lab: {
      l: 87.152,
      a: 0.27,
      b: 10.431
    }
  }, {
    ral: 1014,
    name: 'Ivory',
    LRV: 57,
    cmyk: {
      c: 0,
      m: 9,
      y: 29,
      k: 15
    },
    rgb: {
      r: 217,
      g: 197,
      b: 154
    },
    lab: {
      l: 80.411,
      a: 2.763,
      b: 24.175
    }
  }, {
    ral: 1015,
    name: 'LightIvory',
    LRV: 66,
    cmyk: {
      c: 0,
      m: 7,
      y: 20,
      k: 11
    },
    rgb: {
      r: 227,
      g: 211,
      b: 181
    },
    lab: {
      l: 85.219,
      a: 2.394,
      b: 16.821
    }
  }, {
    ral: 1016,
    name: 'SulfurYellow',
    LRV: 71,
    cmyk: {
      c: 0,
      m: 4,
      y: 77,
      k: 9
    },
    rgb: {
      r: 232,
      g: 222,
      b: 53
    },
    lab: {
      l: 87.29,
      a: -9.283,
      b: 76.694
    }
  }, {
    ral: 1017,
    name: 'SaffronYellow',
    LRV: 49,
    cmyk: {
      c: 0,
      m: 29,
      y: 67,
      k: 6
    },
    rgb: {
      r: 240,
      g: 170,
      b: 80
    },
    lab: {
      l: 75.183,
      a: 20.633,
      b: 55.581
    }
  }, {
    ral: 1018,
    name: 'ZincYellow',
    LRV: 63,
    cmyk: {
      c: 0,
      m: 16,
      y: 81,
      k: 5
    },
    rgb: {
      r: 242,
      g: 203,
      b: 46
    },
    lab: {
      l: 83.353,
      a: 3.462,
      b: 75.829
    }
  }, {
    ral: 1019,
    name: 'GreyBeige',
    LRV: 29,
    cmyk: {
      c: 0,
      m: 12,
      y: 25,
      k: 36
    },
    rgb: {
      r: 162,
      g: 143,
      b: 122
    },
    lab: {
      l: 60.643,
      a: 4.702,
      b: 13.952
    }
  }, {
    ral: 1020,
    name: 'OliveYellow',
    LRV: 28,
    cmyk: {
      c: 0,
      m: 9,
      y: 36,
      k: 38
    },
    rgb: {
      r: 157,
      g: 143,
      b: 101
    },
    lab: {
      l: 59.883,
      a: 0.56,
      b: 24.683
    }
  }, {
    ral: 1021,
    name: 'RapeYellow',
    LRV: 53,
    cmyk: {
      c: 0,
      m: 23,
      y: 100,
      k: 7
    },
    rgb: {
      r: 238,
      g: 183,
      b: 0
    },
    lab: {
      l: 77.828,
      a: 10.664,
      b: 94.6
    }
  }, {
    ral: 1023,
    name: 'TrafficYellow',
    LRV: 53,
    cmyk: {
      c: 0,
      m: 23,
      y: 100,
      k: 6
    },
    rgb: {
      r: 239,
      g: 183,
      b: 0
    },
    lab: {
      l: 77.72,
      a: 11.334,
      b: 93.913
    }
  }, {
    ral: 1024,
    name: 'OchreYellow',
    LRV: 31,
    cmyk: {
      c: 0,
      m: 20,
      y: 59,
      k: 29
    },
    rgb: {
      r: 181,
      g: 144,
      b: 75
    },
    lab: {
      l: 62.261,
      a: 8.491,
      b: 41.488
    }
  }, {
    ral: 1026,
    name: 'LuminousYellow',
    LRV: 99,
    cmyk: {
      c: 0,
      m: 0,
      y: 100,
      k: 0
    },
    rgb: {
      r: 255,
      g: 255,
      b: 0
    },
    lab: {
      l: 99.618,
      a: -17.229,
      b: 116.966
    }
  }, {
    ral: 1027,
    name: 'Curry',
    LRV: 23,
    cmyk: {
      c: 0,
      m: 21,
      y: 93,
      k: 36
    },
    rgb: {
      r: 162,
      g: 128,
      b: 12
    },
    lab: {
      l: 55.557,
      a: 6.493,
      b: 58.255
    }
  }, {
    ral: 1028,
    name: 'MelonYellow',
    LRV: 46,
    cmyk: {
      c: 0,
      m: 39,
      y: 100,
      k: 0
    },
    rgb: {
      r: 255,
      g: 156,
      b: 0
    },
    lab: {
      l: 73.671,
      a: 31.654,
      b: 95.458
    }
  }, {
    ral: 1032,
    name: 'BroomYellow',
    LRV: 42,
    cmyk: {
      c: 0,
      m: 25,
      y: 100,
      k: 14
    },
    rgb: {
      r: 219,
      g: 164,
      b: 0
    },
    lab: {
      l: 71.135,
      a: 12.766,
      b: 74.772
    }
  }, {
    ral: 1033,
    name: 'DahliaYellow',
    LRV: 43,
    cmyk: {
      c: 0,
      m: 36,
      y: 89,
      k: 5
    },
    rgb: {
      r: 243,
      g: 155,
      b: 27
    },
    lab: {
      l: 71.74,
      a: 27.78,
      b: 71.677
    }
  }, {
    ral: 1034,
    name: 'PastelYellow',
    LRV: 42,
    cmyk: {
      c: 0,
      m: 32,
      y: 65,
      k: 10
    },
    rgb: {
      r: 230,
      g: 157,
      b: 81
    },
    lab: {
      l: 70.94,
      a: 22.91,
      b: 49.962
    }
  }, {
    ral: 1035,
    name: 'PearlBeige',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 8,
      y: 21,
      k: 44
    },
    rgb: {
      r: 142,
      g: 131,
      b: 112
    },
    lab: {
      l: 55.258,
      a: 1.866,
      b: 11.775
    }
  }, {
    ral: 1036,
    name: 'PearlGold',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 19,
      y: 50,
      k: 51
    },
    rgb: {
      r: 125,
      g: 101,
      b: 63
    },
    lab: {
      l: 44.425,
      a: 6.462,
      b: 25.001
    }
  }, {
    ral: 1037,
    name: 'SunYellow',
    LRV: 39,
    cmyk: {
      c: 0,
      m: 37,
      y: 100,
      k: 8
    },
    rgb: {
      r: 234,
      g: 147,
      b: 0
    },
    lab: {
      l: 68.889,
      a: 27.62,
      b: 74.504
    }
  }, {
    ral: 2000,
    name: 'YellowOrange',
    LRV: 26,
    cmyk: {
      c: 0,
      m: 48,
      y: 100,
      k: 16
    },
    rgb: {
      r: 213,
      g: 111,
      b: 0
    },
    lab: {
      l: 58.201,
      a: 37.297,
      b: 68.683
    }
  }, {
    ral: 2001,
    name: 'RedOrange',
    LRV: 15,
    cmyk: {
      c: 0,
      m: 60,
      y: 85,
      k: 29
    },
    rgb: {
      r: 182,
      g: 72,
      b: 28
    },
    lab: {
      l: 45.824,
      a: 44.129,
      b: 47.554
    }
  }, {
    ral: 2002,
    name: 'Vermilion',
    LRV: 14,
    cmyk: {
      c: 0,
      m: 70,
      y: 81,
      k: 26
    },
    rgb: {
      r: 188,
      g: 56,
      b: 35
    },
    lab: {
      l: 44.441,
      a: 52.797,
      b: 43.768
    }
  }, {
    ral: 2003,
    name: 'PastelOrange',
    LRV: 33,
    cmyk: {
      c: 0,
      m: 50,
      y: 83,
      k: 5
    },
    rgb: {
      r: 241,
      g: 120,
      b: 41
    },
    lab: {
      l: 64.235,
      a: 44.142,
      b: 61.832
    }
  }, {
    ral: 2004,
    name: 'PureOrange',
    LRV: 22,
    cmyk: {
      c: 0,
      m: 63,
      y: 97,
      k: 13
    },
    rgb: {
      r: 222,
      g: 83,
      b: 6
    },
    lab: {
      l: 54.448,
      a: 53.586,
      b: 63.716
    }
  }, {
    ral: 2005,
    name: 'LuminousOrange',
    LRV: 44,
    cmyk: {
      c: 0,
      m: 71,
      y: 93,
      k: 0
    },
    rgb: {
      r: 255,
      g: 75,
      b: 17
    },
    lab: {
      l: 72.274,
      a: 87.783,
      b: 82.315
    }
  }, {
    ral: 2007,
    name: 'LuminousBrightOrange',
    LRV: 74,
    cmyk: {
      c: 0,
      m: 28,
      y: 100,
      k: 0
    },
    rgb: {
      r: 255,
      g: 183,
      b: 0
    },
    lab: {
      l: 88.914,
      a: 52.782,
      b: 97.982
    }
  }, {
    ral: 2008,
    name: 'BrightRedOrange',
    LRV: 28,
    cmyk: {
      c: 0,
      m: 54,
      y: 85,
      k: 9
    },
    rgb: {
      r: 232,
      g: 107,
      b: 34
    },
    lab: {
      l: 60.334,
      a: 46.913,
      b: 60.652
    }
  }, {
    ral: 2009,
    name: 'TrafficOrange',
    LRV: 22,
    cmyk: {
      c: 0,
      m: 62,
      y: 95,
      k: 15
    },
    rgb: {
      r: 218,
      g: 83,
      b: 10
    },
    lab: {
      l: 53.766,
      a: 51.886,
      b: 62.145
    }
  }, {
    ral: 2010,
    name: 'SignalOrange',
    LRV: 21,
    cmyk: {
      c: 0,
      m: 54,
      y: 80,
      k: 20
    },
    rgb: {
      r: 204,
      g: 93,
      b: 41
    },
    lab: {
      l: 53.28,
      a: 42.985,
      b: 49.867
    }
  }, {
    ral: 2011,
    name: 'DeepOrange',
    LRV: 27,
    cmyk: {
      c: 0,
      m: 50,
      y: 93,
      k: 13
    },
    rgb: {
      r: 221,
      g: 110,
      b: 15
    },
    lab: {
      l: 59.241,
      a: 40.856,
      b: 64.504
    }
  }, {
    ral: 2012,
    name: 'SalmonOrange',
    LRV: 24,
    cmyk: {
      c: 0,
      m: 52,
      y: 63,
      k: 18
    },
    rgb: {
      r: 209,
      g: 101,
      b: 78
    },
    lab: {
      l: 56.085,
      a: 42.492,
      b: 34.021
    }
  }, {
    ral: 2013,
    name: 'PearlOrange',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 57,
      y: 73,
      k: 44
    },
    rgb: {
      r: 143,
      g: 62,
      b: 38
    },
    lab: {
      l: 37.341,
      a: 33.898,
      b: 32.139
    }
  }, {
    ral: 3000,
    name: 'FlameRed',
    LRV: 10,
    cmyk: {
      c: 0,
      m: 76,
      y: 80,
      k: 36
    },
    rgb: {
      r: 164,
      g: 40,
      b: 33
    },
    lab: {
      l: 37.687,
      a: 50.439,
      b: 36.563
    }
  }, {
    ral: 3001,
    name: 'SignalRed',
    LRV: 8,
    cmyk: {
      c: 0,
      m: 77,
      y: 77,
      k: 40
    },
    rgb: {
      r: 152,
      g: 35,
      b: 35
    },
    lab: {
      l: 34.702,
      a: 48.478,
      b: 31.204
    }
  }, {
    ral: 3002,
    name: 'CarmineRed',
    LRV: 8,
    cmyk: {
      c: 0,
      m: 78,
      y: 78,
      k: 40
    },
    rgb: {
      r: 152,
      g: 34,
      b: 34
    },
    lab: {
      l: 34.458,
      a: 48.832,
      b: 31.869
    }
  }, {
    ral: 3003,
    name: 'RubyRed',
    LRV: 6,
    cmyk: {
      c: 0,
      m: 81,
      y: 74,
      k: 48
    },
    rgb: {
      r: 132,
      g: 25,
      b: 34
    },
    lab: {
      l: 29.149,
      a: 45.067,
      b: 24.389
    }
  }, {
    ral: 3004,
    name: 'PurpleRed',
    LRV: 4,
    cmyk: {
      c: 0,
      m: 74,
      y: 67,
      k: 59
    },
    rgb: {
      r: 105,
      g: 27,
      b: 35
    },
    lab: {
      l: 23.903,
      a: 35.433,
      b: 16.085
    }
  }, {
    ral: 3005,
    name: 'WineRed',
    LRV: 3,
    cmyk: {
      c: 0,
      m: 73,
      y: 65,
      k: 65
    },
    rgb: {
      r: 88,
      g: 24,
      b: 31
    },
    lab: {
      l: 19.699,
      a: 30.019,
      b: 12.525
    }
  }, {
    ral: 3007,
    name: 'BlackRed',
    LRV: 2,
    cmyk: {
      c: 0,
      m: 48,
      y: 44,
      k: 76
    },
    rgb: {
      r: 61,
      g: 32,
      b: 34
    },
    lab: {
      l: 16.437,
      a: 14.617,
      b: 5.268
    }
  }, {
    ral: 3009,
    name: 'OxideRed',
    LRV: 5,
    cmyk: {
      c: 0,
      m: 53,
      y: 60,
      k: 60
    },
    rgb: {
      r: 102,
      g: 48,
      b: 41
    },
    lab: {
      l: 27.272,
      a: 24.588,
      b: 16.512
    }
  }, {
    ral: 3011,
    name: 'BrownRed',
    LRV: 5,
    cmyk: {
      c: 0,
      m: 70,
      y: 70,
      k: 53
    },
    rgb: {
      r: 119,
      g: 36,
      b: 36
    },
    lab: {
      l: 27.966,
      a: 36.64,
      b: 21.316
    }
  }, {
    ral: 3012,
    name: 'BeigeRed',
    LRV: 30,
    cmyk: {
      c: 0,
      m: 31,
      y: 44,
      k: 24
    },
    rgb: {
      r: 194,
      g: 133,
      b: 109
    },
    lab: {
      l: 61.394,
      a: 22.436,
      b: 22.979
    }
  }, {
    ral: 3013,
    name: 'TomatoRed',
    LRV: 9,
    cmyk: {
      c: 0,
      m: 69,
      y: 75,
      k: 42
    },
    rgb: {
      r: 149,
      g: 46,
      b: 37
    },
    lab: {
      l: 35.45,
      a: 43.402,
      b: 30.523
    }
  }, {
    ral: 3014,
    name: 'AntiquePink',
    LRV: 26,
    cmyk: {
      c: 0,
      m: 43,
      y: 42,
      k: 21
    },
    rgb: {
      r: 201,
      g: 115,
      b: 117
    },
    lab: {
      l: 58.26,
      a: 34.939,
      b: 14.085
    }
  }, {
    ral: 3015,
    name: 'LightPink',
    LRV: 43,
    cmyk: {
      c: 0,
      m: 26,
      y: 23,
      k: 16
    },
    rgb: {
      r: 215,
      g: 160,
      b: 166
    },
    lab: {
      l: 71.232,
      a: 21.595,
      b: 4.983
    }
  }, {
    ral: 3016,
    name: 'CoralRed',
    LRV: 12,
    cmyk: {
      c: 0,
      m: 63,
      y: 71,
      k: 36
    },
    rgb: {
      r: 164,
      g: 60,
      b: 48
    },
    lab: {
      l: 40.678,
      a: 42.925,
      b: 30.919
    }
  }, {
    ral: 3017,
    name: 'Rose',
    LRV: 20,
    cmyk: {
      c: 0,
      m: 58,
      y: 53,
      k: 22
    },
    rgb: {
      r: 200,
      g: 84,
      b: 93
    },
    lab: {
      l: 51.708,
      a: 47.655,
      b: 19.335
    }
  }, {
    ral: 3018,
    name: 'StrawberryRed',
    LRV: 16,
    cmyk: {
      c: 0,
      m: 68,
      y: 62,
      k: 23
    },
    rgb: {
      r: 196,
      g: 62,
      b: 74
    },
    lab: {
      l: 47.141,
      a: 54.458,
      b: 24.604
    }
  }, {
    ral: 3020,
    name: 'TrafficRed',
    LRV: 12,
    cmyk: {
      c: 0,
      m: 84,
      y: 90,
      k: 28
    },
    rgb: {
      r: 184,
      g: 29,
      b: 19
    },
    lab: {
      l: 40.511,
      a: 59.32,
      b: 47.967
    }
  }, {
    ral: 3022,
    name: 'SalmonPink',
    LRV: 24,
    cmyk: {
      c: 0,
      m: 49,
      y: 58,
      k: 20
    },
    rgb: {
      r: 204,
      g: 105,
      b: 85
    },
    lab: {
      l: 56.056,
      a: 38.9,
      b: 29.704
    }
  }, {
    ral: 3024,
    name: 'LuminousRed',
    LRV: 30,
    cmyk: {
      c: 0,
      m: 84,
      y: 86,
      k: 0
    },
    rgb: {
      r: 255,
      g: 42,
      b: 36
    },
    lab: {
      l: 61.253,
      a: 83.212,
      b: 65.195
    }
  }, {
    ral: 3026,
    name: 'LuminousBrightRed',
    LRV: 32,
    cmyk: {
      c: 0,
      m: 85,
      y: 87,
      k: 0
    },
    rgb: {
      r: 255,
      g: 38,
      b: 32
    },
    lab: {
      l: 63.701,
      a: 87.132,
      b: 70.01
    }
  }, {
    ral: 3027,
    name: 'RaspberryRed',
    LRV: 10,
    cmyk: {
      c: 0,
      m: 78,
      y: 64,
      k: 34
    },
    rgb: {
      r: 169,
      g: 38,
      b: 61
    },
    lab: {
      l: 38.686,
      a: 53.68,
      b: 20.868
    }
  }, {
    ral: 3028,
    name: 'PureRed',
    LRV: 15,
    cmyk: {
      c: 0,
      m: 79,
      y: 81,
      k: 21
    },
    rgb: {
      r: 201,
      g: 43,
      b: 38
    },
    lab: {
      l: 45.358,
      a: 60.958,
      b: 44.231
    }
  }, {
    ral: 3031,
    name: 'OrientRed',
    LRV: 11,
    cmyk: {
      c: 0,
      m: 69,
      y: 66,
      k: 36
    },
    rgb: {
      r: 164,
      g: 51,
      b: 56
    },
    lab: {
      l: 39.32,
      a: 47.086,
      b: 24.708
    }
  }, {
    ral: 3032,
    name: 'PearlrubyRed',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 75,
      y: 67,
      k: 57
    },
    rgb: {
      r: 110,
      g: 28,
      b: 36
    },
    lab: {
      l: 25.034,
      a: 36.705,
      b: 17.139
    }
  }, {
    ral: 3033,
    name: 'PearlPink',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 65,
      y: 72,
      k: 36
    },
    rgb: {
      r: 162,
      g: 57,
      b: 46
    },
    lab: {
      l: 39.808,
      a: 43.686,
      b: 30.991
    }
  }, {
    ral: 4001,
    name: 'RedLilac',
    LRV: 15,
    cmyk: {
      c: 0,
      m: 27,
      y: 0,
      k: 49
    },
    rgb: {
      r: 131,
      g: 96,
      b: 131
    },
    lab: {
      l: 45.333,
      a: 19.568,
      b: -14.009
    }
  }, {
    ral: 4002,
    name: 'Redviolet',
    LRV: 9,
    cmyk: {
      c: 0,
      m: 57,
      y: 46,
      k: 45
    },
    rgb: {
      r: 140,
      g: 60,
      b: 75
    },
    lab: {
      l: 36.8,
      a: 35.858,
      b: 8.343
    }
  }, {
    ral: 4003,
    name: 'Heatherviolet',
    LRV: 22,
    cmyk: {
      c: 0,
      m: 51,
      y: 29,
      k: 23
    },
    rgb: {
      r: 196,
      g: 96,
      b: 140
    },
    lab: {
      l: 54.247,
      a: 44.659,
      b: -5.015
    }
  }, {
    ral: 4004,
    name: 'Claretviolet',
    LRV: 4,
    cmyk: {
      c: 0,
      m: 71,
      y: 43,
      k: 61
    },
    rgb: {
      r: 100,
      g: 29,
      b: 57
    },
    lab: {
      l: 23.577,
      a: 34.298,
      b: 0.517
    }
  }, {
    ral: 4005,
    name: 'BlueLilac',
    LRV: 16,
    cmyk: {
      c: 20,
      m: 33,
      y: 0,
      k: 40
    },
    rgb: {
      r: 123,
      g: 103,
      b: 154
    },
    lab: {
      l: 47.024,
      a: 16.762,
      b: -25.226
    }
  }, {
    ral: 4006,
    name: 'Trafficpurple',
    LRV: 10,
    cmyk: {
      c: 0,
      m: 67,
      y: 21,
      k: 43
    },
    rgb: {
      r: 145,
      g: 48,
      b: 115
    },
    lab: {
      l: 36.964,
      a: 46.56,
      b: -16.759
    }
  }, {
    ral: 4007,
    name: 'Purpleviolet',
    LRV: 3,
    cmyk: {
      c: 0,
      m: 49,
      y: 15,
      k: 72
    },
    rgb: {
      r: 71,
      g: 36,
      b: 60
    },
    lab: {
      l: 19.721,
      a: 20.17,
      b: -7.946
    }
  }, {
    ral: 4008,
    name: 'Signalviolet',
    LRV: 12,
    cmyk: {
      c: 0,
      m: 44,
      y: 3,
      k: 47
    },
    rgb: {
      r: 135,
      g: 75,
      b: 131
    },
    lab: {
      l: 40.761,
      a: 32.526,
      b: -20.561
    }
  }, {
    ral: 4009,
    name: 'Pastelviolet',
    LRV: 26,
    cmyk: {
      c: 0,
      m: 15,
      y: 7,
      k: 38
    },
    rgb: {
      r: 157,
      g: 133,
      b: 146
    },
    lab: {
      l: 58.22,
      a: 11.056,
      b: -3.283
    }
  }, {
    ral: 4010,
    name: 'Telemagenta',
    LRV: 16,
    cmyk: {
      c: 0,
      m: 67,
      y: 36,
      k: 27
    },
    rgb: {
      r: 187,
      g: 62,
      b: 119
    },
    lab: {
      l: 46.538,
      a: 54.36,
      b: -4.083
    }
  }, {
    ral: 4011,
    name: 'Pearlviolet',
    LRV: 0,
    cmyk: {
      c: 16,
      m: 27,
      y: 0,
      k: 47
    },
    rgb: {
      r: 113,
      g: 98,
      b: 135
    },
    lab: {
      l: 44.108,
      a: 12.383,
      b: -18.407
    }
  }, {
    ral: 4012,
    name: 'PearlBlackberry',
    LRV: 0,
    cmyk: {
      c: 14,
      m: 16,
      y: 0,
      k: 50
    },
    rgb: {
      r: 109,
      g: 107,
      b: 127
    },
    lab: {
      l: 45.891,
      a: 4.098,
      b: -11.086
    }
  }, {
    ral: 5000,
    name: 'VioletBlue',
    LRV: 7,
    cmyk: {
      c: 50,
      m: 30,
      y: 0,
      k: 56
    },
    rgb: {
      r: 56,
      g: 78,
      b: 111
    },
    lab: {
      l: 32.585,
      a: -1.282,
      b: -21.686
    }
  }, {
    ral: 5001,
    name: 'GreenBlue',
    LRV: 6,
    cmyk: {
      c: 71,
      m: 24,
      y: 0,
      k: 61
    },
    rgb: {
      r: 29,
      g: 76,
      b: 100
    },
    lab: {
      l: 29.866,
      a: -9.761,
      b: -19.22
    }
  }, {
    ral: 5002,
    name: 'UltramarineBlue',
    LRV: 4,
    cmyk: {
      c: 76,
      m: 56,
      y: 0,
      k: 52
    },
    rgb: {
      r: 30,
      g: 54,
      b: 123
    },
    lab: {
      l: 24.179,
      a: 11.008,
      b: -42.748
    }
  }, {
    ral: 5003,
    name: 'SapphireBlue',
    LRV: 4,
    cmyk: {
      c: 55,
      m: 34,
      y: 0,
      k: 67
    },
    rgb: {
      r: 38,
      g: 56,
      b: 85
    },
    lab: {
      l: 22.956,
      a: 0.076,
      b: -20.213
    }
  }, {
    ral: 5004,
    name: 'BlackBlue',
    LRV: 1,
    cmyk: {
      c: 35,
      m: 25,
      y: 0,
      k: 84
    },
    rgb: {
      r: 26,
      g: 30,
      b: 40
    },
    lab: {
      l: 11.174,
      a: 0.654,
      b: -7.457
    }
  }, {
    ral: 5005,
    name: 'SignalBlue',
    LRV: 7,
    cmyk: {
      c: 100,
      m: 40,
      y: 0,
      k: 47
    },
    rgb: {
      r: 0,
      g: 81,
      b: 135
    },
    lab: {
      l: 32.448,
      a: -6.68,
      b: -37.201
    }
  }, {
    ral: 5007,
    name: 'BrilliantBlue',
    LRV: 13,
    cmyk: {
      c: 53,
      m: 24,
      y: 0,
      k: 45
    },
    rgb: {
      r: 66,
      g: 106,
      b: 140
    },
    lab: {
      l: 42.929,
      a: -6.8,
      b: -23.609
    }
  }, {
    ral: 5008,
    name: 'GreyBlue',
    LRV: 4,
    cmyk: {
      c: 34,
      m: 15,
      y: 0,
      k: 73
    },
    rgb: {
      r: 45,
      g: 58,
      b: 68
    },
    lab: {
      l: 23.463,
      a: -3.174,
      b: -8.172
    }
  }, {
    ral: 5009,
    name: 'AzureBlue',
    LRV: 10,
    cmyk: {
      c: 62,
      m: 22,
      y: 0,
      k: 53
    },
    rgb: {
      r: 45,
      g: 94,
      b: 120
    },
    lab: {
      l: 37.421,
      a: -10.799,
      b: -19.905
    }
  }, {
    ral: 5010,
    name: 'GentianBlue',
    LRV: 7,
    cmyk: {
      c: 100,
      m: 37,
      y: 0,
      k: 51
    },
    rgb: {
      r: 0,
      g: 78,
      b: 124
    },
    lab: {
      l: 30.95,
      a: -7.433,
      b: -32.954
    }
  }, {
    ral: 5011,
    name: 'SteelBlue',
    LRV: 2,
    cmyk: {
      c: 51,
      m: 30,
      y: 0,
      k: 76
    },
    rgb: {
      r: 30,
      g: 43,
      b: 61
    },
    lab: {
      l: 16.969,
      a: -1.198,
      b: -13.154
    }
  }, {
    ral: 5012,
    name: 'LightBlue',
    LRV: 21,
    cmyk: {
      c: 75,
      m: 25,
      y: 0,
      k: 29
    },
    rgb: {
      r: 46,
      g: 136,
      b: 182
    },
    lab: {
      l: 53.135,
      a: -15.219,
      b: -32.486
    }
  }, {
    ral: 5013,
    name: 'CobaltBlue',
    LRV: 3,
    cmyk: {
      c: 59,
      m: 42,
      y: 0,
      k: 67
    },
    rgb: {
      r: 34,
      g: 48,
      b: 83
    },
    lab: {
      l: 20.044,
      a: 2.964,
      b: -23.406
    }
  }, {
    ral: 5014,
    name: 'PigeonBlue',
    LRV: 19,
    cmyk: {
      c: 31,
      m: 17,
      y: 0,
      k: 41
    },
    rgb: {
      r: 104,
      g: 124,
      b: 150
    },
    lab: {
      l: 51.233,
      a: -2.817,
      b: -16.741
    }
  }, {
    ral: 5015,
    name: 'SkyBlue',
    LRV: 17,
    cmyk: {
      c: 94,
      m: 30,
      y: 0,
      k: 31
    },
    rgb: {
      r: 11,
      g: 123,
      b: 176
    },
    lab: {
      l: 48.193,
      a: -13.907,
      b: -36.485
    }
  }, {
    ral: 5017,
    name: 'TrafficBlue',
    LRV: 8,
    cmyk: {
      c: 100,
      m: 36,
      y: 0,
      k: 45
    },
    rgb: {
      r: 0,
      g: 90,
      b: 140
    },
    lab: {
      l: 34.824,
      a: -13.495,
      b: -36.357
    }
  }, {
    ral: 5018,
    name: 'TurquoiseBlue',
    LRV: 20,
    cmyk: {
      c: 81,
      m: 1,
      y: 0,
      k: 45
    },
    rgb: {
      r: 27,
      g: 139,
      b: 140
    },
    lab: {
      l: 52.285,
      a: -30.312,
      b: -9.335
    }
  }, {
    ral: 5019,
    name: 'CapriBlue',
    LRV: 9,
    cmyk: {
      c: 89,
      m: 30,
      y: 0,
      k: 48
    },
    rgb: {
      r: 15,
      g: 93,
      b: 132
    },
    lab: {
      l: 36.615,
      a: -11.411,
      b: -28.473
    }
  }, {
    ral: 5020,
    name: 'OceanBlue',
    LRV: 4,
    cmyk: {
      c: 100,
      m: 13,
      y: 0,
      k: 71
    },
    rgb: {
      r: 0,
      g: 65,
      b: 75
    },
    lab: {
      l: 23.75,
      a: -20.682,
      b: -12.512
    }
  }, {
    ral: 5021,
    name: 'WaterBlue',
    LRV: 13,
    cmyk: {
      c: 100,
      m: 2,
      y: 0,
      k: 53
    },
    rgb: {
      r: 0,
      g: 117,
      b: 119
    },
    lab: {
      l: 43.325,
      a: -33.797,
      b: -10.417
    }
  }, {
    ral: 5022,
    name: 'NightBlue',
    LRV: 3,
    cmyk: {
      c: 52,
      m: 51,
      y: 0,
      k: 65
    },
    rgb: {
      r: 43,
      g: 44,
      b: 90
    },
    lab: {
      l: 19.872,
      a: 10.632,
      b: -28.485
    }
  }, {
    ral: 5023,
    name: 'DistantBlue',
    LRV: 13,
    cmyk: {
      c: 48,
      m: 26,
      y: 0,
      k: 45
    },
    rgb: {
      r: 74,
      g: 104,
      b: 141
    },
    lab: {
      l: 43.013,
      a: -3.442,
      b: -23.737
    }
  }, {
    ral: 5024,
    name: 'PastelBlue',
    LRV: 26,
    cmyk: {
      c: 40,
      m: 15,
      y: 0,
      k: 33
    },
    rgb: {
      r: 103,
      g: 146,
      b: 172
    },
    lab: {
      l: 58.295,
      a: -10.309,
      b: -18.647
    }
  }, {
    ral: 5025,
    name: 'PearlGentianBlue',
    LRV: 0,
    cmyk: {
      c: 65,
      m: 15,
      y: 0,
      k: 51
    },
    rgb: {
      r: 44,
      g: 105,
      b: 124
    },
    lab: {
      l: 41.102,
      a: -15.762,
      b: -16.748
    }
  }, {
    ral: 5026,
    name: 'PearlnightBlue',
    LRV: 0,
    cmyk: {
      c: 67,
      m: 43,
      y: 0,
      k: 68
    },
    rgb: {
      r: 27,
      g: 47,
      b: 82
    },
    lab: {
      l: 19.227,
      a: 1.728,
      b: -24.359
    }
  }, {
    ral: 6000,
    name: 'PatinaGreen',
    LRV: 14,
    cmyk: {
      c: 49,
      m: 0,
      y: 17,
      k: 55
    },
    rgb: {
      r: 59,
      g: 116,
      b: 96
    },
    lab: {
      l: 44.529,
      a: -23.651,
      b: 5.316
    }
  }, {
    ral: 6001,
    name: 'EmeraldGreen',
    LRV: 11,
    cmyk: {
      c: 53,
      m: 0,
      y: 50,
      k: 59
    },
    rgb: {
      r: 49,
      g: 104,
      b: 52
    },
    lab: {
      l: 39.247,
      a: -28.094,
      b: 23.342
    }
  }, {
    ral: 6002,
    name: 'LeafGreen',
    LRV: 8,
    cmyk: {
      c: 50,
      m: 0,
      y: 57,
      k: 65
    },
    rgb: {
      r: 45,
      g: 90,
      b: 39
    },
    lab: {
      l: 34.079,
      a: -24.697,
      b: 23.999
    }
  }, {
    ral: 6003,
    name: 'OliveGreen',
    LRV: 8,
    cmyk: {
      c: 6,
      m: 0,
      y: 29,
      k: 67
    },
    rgb: {
      r: 78,
      g: 83,
      b: 59
    },
    lab: {
      l: 34.335,
      a: -5.296,
      b: 13.147
    }
  }, {
    ral: 6004,
    name: 'BlueGreen',
    LRV: 5,
    cmyk: {
      c: 88,
      m: 0,
      y: 3,
      k: 73
    },
    rgb: {
      r: 8,
      g: 68,
      b: 66
    },
    lab: {
      l: 25.484,
      a: -19.095,
      b: -4.31
    }
  }, {
    ral: 6005,
    name: 'MossGreen',
    LRV: 4,
    cmyk: {
      c: 74,
      m: 0,
      y: 24,
      k: 74
    },
    rgb: {
      r: 17,
      g: 66,
      b: 50
    },
    lab: {
      l: 24.439,
      a: -20.569,
      b: 4.665
    }
  }, {
    ral: 6006,
    name: 'Greyolive',
    LRV: 4,
    cmyk: {
      c: 0,
      m: 3,
      y: 22,
      k: 77
    },
    rgb: {
      r: 59,
      g: 57,
      b: 46
    },
    lab: {
      l: 24.036,
      a: -1.163,
      b: 7.105
    }
  }, {
    ral: 6007,
    name: 'BottleGreen',
    LRV: 3,
    cmyk: {
      c: 16,
      m: 0,
      y: 32,
      k: 80
    },
    rgb: {
      r: 42,
      g: 50,
      b: 34
    },
    lab: {
      l: 19.792,
      a: -6.46,
      b: 9.562
    }
  }, {
    ral: 6008,
    name: 'BrownGreen',
    LRV: 3,
    cmyk: {
      c: 0,
      m: 4,
      y: 22,
      k: 79
    },
    rgb: {
      r: 54,
      g: 52,
      b: 42
    },
    lab: {
      l: 21.675,
      a: -0.827,
      b: 6.489
    }
  }, {
    ral: 6009,
    name: 'FirGreen',
    LRV: 3,
    cmyk: {
      c: 28,
      m: 0,
      y: 22,
      k: 79
    },
    rgb: {
      r: 39,
      g: 54,
      b: 42
    },
    lab: {
      l: 20.78,
      a: -8.546,
      b: 5.213
    }
  }, {
    ral: 6010,
    name: 'GrassGreen',
    LRV: 13,
    cmyk: {
      c: 35,
      m: 0,
      y: 50,
      k: 56
    },
    rgb: {
      r: 72,
      g: 111,
      b: 56
    },
    lab: {
      l: 42.993,
      a: -22.872,
      b: 26.093
    }
  }, {
    ral: 6011,
    name: 'ResedaGreen',
    LRV: 18,
    cmyk: {
      c: 16,
      m: 0,
      y: 30,
      k: 51
    },
    rgb: {
      r: 105,
      g: 125,
      b: 88
    },
    lab: {
      l: 49.931,
      a: -12.896,
      b: 17.344
    }
  }, {
    ral: 6012,
    name: 'BlackGreen',
    LRV: 4,
    cmyk: {
      c: 21,
      m: 0,
      y: 5,
      k: 76
    },
    rgb: {
      r: 48,
      g: 61,
      b: 58
    },
    lab: {
      l: 24.554,
      a: -6.234,
      b: -0.13
    }
  }, {
    ral: 6013,
    name: 'ReedGreen',
    LRV: 18,
    cmyk: {
      c: 0,
      m: 3,
      y: 26,
      k: 52
    },
    rgb: {
      r: 122,
      g: 118,
      b: 90
    },
    lab: {
      l: 49.493,
      a: -2.158,
      b: 16.371
    }
  }, {
    ral: 6014,
    name: 'Yellowolive',
    LRV: 5,
    cmyk: {
      c: 0,
      m: 7,
      y: 24,
      k: 73
    },
    rgb: {
      r: 70,
      g: 65,
      b: 53
    },
    lab: {
      l: 27.639,
      a: 0.59,
      b: 7.89
    }
  }, {
    ral: 6015,
    name: 'Blackolive',
    LRV: 5,
    cmyk: {
      c: 2,
      m: 0,
      y: 11,
      k: 76
    },
    rgb: {
      r: 60,
      g: 61,
      b: 54
    },
    lab: {
      l: 25.484,
      a: -1.59,
      b: 4.15
    }
  }, {
    ral: 6016,
    name: 'TurquoiseGreen',
    LRV: 10,
    cmyk: {
      c: 100,
      m: 0,
      y: 28,
      k: 58
    },
    rgb: {
      r: 0,
      g: 106,
      b: 76
    },
    lab: {
      l: 38.439,
      a: -39.355,
      b: 8.026
    }
  }, {
    ral: 6017,
    name: 'MayGreen',
    LRV: 18,
    cmyk: {
      c: 35,
      m: 0,
      y: 51,
      k: 50
    },
    rgb: {
      r: 83,
      g: 128,
      b: 63
    },
    lab: {
      l: 49.029,
      a: -25.488,
      b: 29.753
    }
  }, {
    ral: 6018,
    name: 'YellowGreen',
    LRV: 26,
    cmyk: {
      c: 42,
      m: 0,
      y: 63,
      k: 40
    },
    rgb: {
      r: 89,
      g: 154,
      b: 57
    },
    lab: {
      l: 57.587,
      a: -35.153,
      b: 42.334
    }
  }, {
    ral: 6019,
    name: 'PastelGreen',
    LRV: 57,
    cmyk: {
      c: 11,
      m: 0,
      y: 17,
      k: 19
    },
    rgb: {
      r: 183,
      g: 206,
      b: 172
    },
    lab: {
      l: 80.385,
      a: -13.069,
      b: 14.476
    }
  }, {
    ral: 6020,
    name: 'ChromeGreen',
    LRV: 5,
    cmyk: {
      c: 18,
      m: 0,
      y: 29,
      k: 74
    },
    rgb: {
      r: 54,
      g: 66,
      b: 47
    },
    lab: {
      l: 26.338,
      a: -8.365,
      b: 10.002
    }
  }, {
    ral: 6021,
    name: 'PaleGreen',
    LRV: 30,
    cmyk: {
      c: 12,
      m: 0,
      y: 23,
      k: 40
    },
    rgb: {
      r: 135,
      g: 154,
      b: 119
    },
    lab: {
      l: 61.305,
      a: -11.717,
      b: 16.056
    }
  }, {
    ral: 6022,
    name: 'Brownolive',
    LRV: 3,
    cmyk: {
      c: 0,
      m: 11,
      y: 32,
      k: 78
    },
    rgb: {
      r: 57,
      g: 51,
      b: 39
    },
    lab: {
      l: 21.685,
      a: 1.103,
      b: 8.802
    }
  }, {
    ral: 6024,
    name: 'TrafficGreen',
    LRV: 17,
    cmyk: {
      c: 100,
      m: 0,
      y: 39,
      k: 48
    },
    rgb: {
      r: 0,
      g: 132,
      b: 80
    },
    lab: {
      l: 47.925,
      a: -44.563,
      b: 18.534
    }
  }, {
    ral: 6025,
    name: 'FernGreen',
    LRV: 14,
    cmyk: {
      c: 18,
      m: 0,
      y: 46,
      k: 57
    },
    rgb: {
      r: 90,
      g: 110,
      b: 59
    },
    lab: {
      l: 43.932,
      a: -15.048,
      b: 26.076
    }
  }, {
    ral: 6026,
    name: 'OpalGreen',
    LRV: 8,
    cmyk: {
      c: 100,
      m: 0,
      y: 18,
      k: 63
    },
    rgb: {
      r: 0,
      g: 95,
      b: 78
    },
    lab: {
      l: 34.35,
      a: -36.57,
      b: 0.829
    }
  }, {
    ral: 6027,
    name: 'LightGreen',
    LRV: 43,
    cmyk: {
      c: 31,
      m: 0,
      y: 3,
      k: 27
    },
    rgb: {
      r: 128,
      g: 186,
      b: 181
    },
    lab: {
      l: 71.56,
      a: -20.503,
      b: -3.86
    }
  }, {
    ral: 6028,
    name: 'PineGreen',
    LRV: 7,
    cmyk: {
      c: 43,
      m: 0,
      y: 21,
      k: 67
    },
    rgb: {
      r: 48,
      g: 84,
      b: 66
    },
    lab: {
      l: 32.5,
      a: -17.091,
      b: 6.069
    }
  }, {
    ral: 6029,
    name: 'MintGreen',
    LRV: 11,
    cmyk: {
      c: 100,
      m: 0,
      y: 46,
      k: 56
    },
    rgb: {
      r: 0,
      g: 112,
      b: 60
    },
    lab: {
      l: 39.92,
      a: -47.213,
      b: 19.273
    }
  }, {
    ral: 6032,
    name: 'SignalGreen',
    LRV: 16,
    cmyk: {
      c: 78,
      m: 0,
      y: 37,
      k: 50
    },
    rgb: {
      r: 28,
      g: 128,
      b: 81
    },
    lab: {
      l: 47.236,
      a: -37.788,
      b: 16.942
    }
  }, {
    ral: 6033,
    name: 'Mintturquoise',
    LRV: 20,
    cmyk: {
      c: 47,
      m: 0,
      y: 6,
      k: 47
    },
    rgb: {
      r: 72,
      g: 135,
      b: 127
    },
    lab: {
      l: 51.934,
      a: -22.925,
      b: -2.331
    }
  }, {
    ral: 6034,
    name: 'Pastelturquoise',
    LRV: 37,
    cmyk: {
      c: 28,
      m: 0,
      y: 1,
      k: 32
    },
    rgb: {
      r: 124,
      g: 173,
      b: 172
    },
    lab: {
      l: 67.128,
      a: -16.7,
      b: -5.213
    }
  }, {
    ral: 6035,
    name: 'PearlGreen',
    LRV: 0,
    cmyk: {
      c: 75,
      m: 0,
      y: 53,
      k: 70
    },
    rgb: {
      r: 19,
      g: 77,
      b: 36
    },
    lab: {
      l: 28.366,
      a: -27.124,
      b: 18.409
    }
  }, {
    ral: 6036,
    name: 'PearlopalGreen',
    LRV: 0,
    cmyk: {
      c: 92,
      m: 0,
      y: 15,
      k: 65
    },
    rgb: {
      r: 7,
      g: 88,
      b: 75
    },
    lab: {
      l: 32.729,
      a: -25.854,
      b: 0.881
    }
  }, {
    ral: 6037,
    name: 'PureGreen',
    LRV: 19,
    cmyk: {
      c: 100,
      m: 0,
      y: 72,
      k: 45
    },
    rgb: {
      r: 0,
      g: 140,
      b: 39
    },
    lab: {
      l: 50.209,
      a: -53.031,
      b: 41.386
    }
  }, {
    ral: 6038,
    name: 'LuminousGreen',
    LRV: 31,
    cmyk: {
      c: 100,
      m: 0,
      y: 90,
      k: 29
    },
    rgb: {
      r: 0,
      g: 182,
      b: 18
    },
    lab: {
      l: 62.308,
      a: -84.293,
      b: 57.548
    }
  }, {
    ral: 7000,
    name: 'SquirrelGrey',
    LRV: 24,
    cmyk: {
      c: 13,
      m: 4,
      y: 0,
      k: 44
    },
    rgb: {
      r: 123,
      g: 136,
      b: 142
    },
    lab: {
      l: 55.673,
      a: -3.552,
      b: -4.905
    }
  }, {
    ral: 7001,
    name: 'SilverGrey',
    LRV: 30,
    cmyk: {
      c: 10,
      m: 4,
      y: 0,
      k: 38
    },
    rgb: {
      r: 142,
      g: 150,
      b: 157
    },
    lab: {
      l: 61.648,
      a: -2.346,
      b: -4.456
    }
  }, {
    ral: 7002,
    name: 'OliveGrey',
    LRV: 19,
    cmyk: {
      c: 0,
      m: 6,
      y: 22,
      k: 50
    },
    rgb: {
      r: 127,
      g: 120,
      b: 99
    },
    lab: {
      l: 50.775,
      a: -0.044,
      b: 12.64
    }
  }, {
    ral: 7003,
    name: 'MossGrey',
    LRV: 18,
    cmyk: {
      c: 0,
      m: 1,
      y: 13,
      k: 53
    },
    rgb: {
      r: 120,
      g: 119,
      b: 105
    },
    lab: {
      l: 49.694,
      a: -1.244,
      b: 7.793
    }
  }, {
    ral: 7004,
    name: 'SignalGrey',
    LRV: 33,
    cmyk: {
      c: 0,
      m: 0,
      y: 0,
      k: 39
    },
    rgb: {
      r: 155,
      g: 155,
      b: 155
    },
    lab: {
      l: 63.832,
      a: 0.185,
      b: -0.439
    }
  }, {
    ral: 7005,
    name: 'MouseGrey',
    LRV: 15,
    cmyk: {
      c: 3,
      m: 0,
      y: 3,
      k: 57
    },
    rgb: {
      r: 107,
      g: 110,
      b: 107
    },
    lab: {
      l: 46.213,
      a: -1.581,
      b: 1.174
    }
  }, {
    ral: 7006,
    name: 'BeigeGrey',
    LRV: 15,
    cmyk: {
      c: 0,
      m: 9,
      y: 20,
      k: 54
    },
    rgb: {
      r: 117,
      g: 106,
      b: 94
    },
    lab: {
      l: 45.607,
      a: 2.498,
      b: 8.713
    }
  }, {
    ral: 7008,
    name: 'KhakiGrey',
    LRV: 12,
    cmyk: {
      c: 0,
      m: 17,
      y: 47,
      k: 55
    },
    rgb: {
      r: 114,
      g: 95,
      b: 60
    },
    lab: {
      l: 41.485,
      a: 4.118,
      b: 22.658
    }
  }, {
    ral: 7009,
    name: 'GreenGrey',
    LRV: 11,
    cmyk: {
      c: 4,
      m: 0,
      y: 8,
      k: 62
    },
    rgb: {
      r: 92,
      g: 96,
      b: 88
    },
    lab: {
      l: 40.2,
      a: -2.864,
      b: 4.187
    }
  }, {
    ral: 7010,
    name: 'TarpaulinGrey',
    LRV: 10,
    cmyk: {
      c: 4,
      m: 0,
      y: 7,
      k: 64
    },
    rgb: {
      r: 88,
      g: 92,
      b: 86
    },
    lab: {
      l: 38.442,
      a: -2.331,
      b: 2.593
    }
  }, {
    ral: 7011,
    name: 'IronGrey',
    LRV: 10,
    cmyk: {
      c: 11,
      m: 4,
      y: 0,
      k: 64
    },
    rgb: {
      r: 83,
      g: 89,
      b: 93
    },
    lab: {
      l: 37.44,
      a: -2.068,
      b: -3.02
    }
  }, {
    ral: 7012,
    name: 'BasaltGrey',
    LRV: 11,
    cmyk: {
      c: 6,
      m: 1,
      y: 0,
      k: 63
    },
    rgb: {
      r: 88,
      g: 93,
      b: 94
    },
    lab: {
      l: 39.159,
      a: -2.027,
      b: -1.452
    }
  }, {
    ral: 7013,
    name: 'BrownGrey',
    LRV: 8,
    cmyk: {
      c: 0,
      m: 7,
      y: 21,
      k: 66
    },
    rgb: {
      r: 86,
      g: 80,
      b: 68
    },
    lab: {
      l: 34.343,
      a: 0.836,
      b: 8.009
    }
  }, {
    ral: 7015,
    name: 'SlateGrey',
    LRV: 9,
    cmyk: {
      c: 10,
      m: 7,
      y: 0,
      k: 65
    },
    rgb: {
      r: 80,
      g: 83,
      b: 89
    },
    lab: {
      l: 35.155,
      a: -0.229,
      b: -3.737
    }
  }, {
    ral: 7016,
    name: 'AnthraciteGrey',
    LRV: 5,
    cmyk: {
      c: 15,
      m: 6,
      y: 0,
      k: 74
    },
    rgb: {
      r: 56,
      g: 62,
      b: 66
    },
    lab: {
      l: 25.926,
      a: -1.853,
      b: -3.407
    }
  }, {
    ral: 7021,
    name: 'BlackGrey',
    LRV: 3,
    cmyk: {
      c: 8,
      m: 4,
      y: 0,
      k: 80
    },
    rgb: {
      r: 48,
      g: 50,
      b: 52
    },
    lab: {
      l: 20.639,
      a: -0.806,
      b: -1.325
    }
  }, {
    ral: 7022,
    name: 'UmbraGrey',
    LRV: 7,
    cmyk: {
      c: 0,
      m: 3,
      y: 11,
      k: 70
    },
    rgb: {
      r: 76,
      g: 74,
      b: 68
    },
    lab: {
      l: 31.372,
      a: -0.001,
      b: 3.652
    }
  }, {
    ral: 7023,
    name: 'ConcreteGrey',
    LRV: 21,
    cmyk: {
      c: 1,
      m: 0,
      y: 8,
      k: 50
    },
    rgb: {
      r: 127,
      g: 128,
      b: 118
    },
    lab: {
      l: 53.265,
      a: -1.634,
      b: 5.038
    }
  }, {
    ral: 7024,
    name: 'GraphiteGrey',
    LRV: 7,
    cmyk: {
      c: 11,
      m: 8,
      y: 0,
      k: 69
    },
    rgb: {
      r: 70,
      g: 73,
      b: 79
    },
    lab: {
      l: 30.964,
      a: -0.314,
      b: -3.685
    }
  }, {
    ral: 7026,
    name: 'GraniteGrey',
    LRV: 5,
    cmyk: {
      c: 19,
      m: 3,
      y: 0,
      k: 73
    },
    rgb: {
      r: 56,
      g: 67,
      b: 69
    },
    lab: {
      l: 27.434,
      a: -4.013,
      b: -3.107
    }
  }, {
    ral: 7030,
    name: 'StoneGrey',
    LRV: 27,
    cmyk: {
      c: 0,
      m: 2,
      y: 8,
      k: 43
    },
    rgb: {
      r: 145,
      g: 142,
      b: 133
    },
    lab: {
      l: 59.041,
      a: -0.114,
      b: 5.3
    }
  }, {
    ral: 7031,
    name: 'BlueGrey',
    LRV: 13,
    cmyk: {
      c: 15,
      m: 5,
      y: 0,
      k: 57
    },
    rgb: {
      r: 93,
      g: 104,
      b: 109
    },
    lab: {
      l: 43.16,
      a: -3.593,
      b: -4.523
    }
  }, {
    ral: 7032,
    name: 'PebbleGrey',
    LRV: 44,
    cmyk: {
      c: 0,
      m: 2,
      y: 11,
      k: 29
    },
    rgb: {
      r: 180,
      g: 176,
      b: 161
    },
    lab: {
      l: 71.941,
      a: -0.909,
      b: 8.469
    }
  }, {
    ral: 7033,
    name: 'CementGrey',
    LRV: 22,
    cmyk: {
      c: 3,
      m: 0,
      y: 11,
      k: 49
    },
    rgb: {
      r: 126,
      g: 130,
      b: 116
    },
    lab: {
      l: 53.842,
      a: -3.737,
      b: 7.189
    }
  }, {
    ral: 7034,
    name: 'YellowGrey',
    LRV: 25,
    cmyk: {
      c: 0,
      m: 6,
      y: 23,
      k: 44
    },
    rgb: {
      r: 144,
      g: 136,
      b: 111
    },
    lab: {
      l: 56.857,
      a: 0.031,
      b: 14.835
    }
  }, {
    ral: 7035,
    name: 'LightGrey',
    LRV: 57,
    cmyk: {
      c: 1,
      m: 0,
      y: 2,
      k: 22
    },
    rgb: {
      r: 197,
      g: 199,
      b: 196
    },
    lab: {
      l: 80.047,
      a: -1.207,
      b: 1.387
    }
  }, {
    ral: 7036,
    name: 'PlatinumGrey',
    LRV: 30,
    cmyk: {
      c: 0,
      m: 3,
      y: 3,
      k: 41
    },
    rgb: {
      r: 151,
      g: 147,
      b: 146
    },
    lab: {
      l: 61.233,
      a: 1.346,
      b: 1.022
    }
  }, {
    ral: 7037,
    name: 'DustyGrey',
    LRV: 20,
    cmyk: {
      c: 1,
      m: 0,
      y: 1,
      k: 52
    },
    rgb: {
      r: 122,
      g: 123,
      b: 122
    },
    lab: {
      l: 51.431,
      a: -0.642,
      b: 0.533
    }
  }, {
    ral: 7038,
    name: 'AgateGrey',
    LRV: 43,
    cmyk: {
      c: 1,
      m: 0,
      y: 5,
      k: 31
    },
    rgb: {
      r: 175,
      g: 177,
      b: 169
    },
    lab: {
      l: 71.73,
      a: -1.62,
      b: 3.82
    }
  }, {
    ral: 7039,
    name: 'QuartzGrey',
    LRV: 13,
    cmyk: {
      c: 0,
      m: 4,
      y: 11,
      k: 58
    },
    rgb: {
      r: 106,
      g: 102,
      b: 94
    },
    lab: {
      l: 43.496,
      a: 0.373,
      b: 5.56
    }
  }, {
    ral: 7040,
    name: 'WindowGrey',
    LRV: 34,
    cmyk: {
      c: 6,
      m: 2,
      y: 0,
      k: 37
    },
    rgb: {
      r: 152,
      g: 158,
      b: 161
    },
    lab: {
      l: 64.7,
      a: -1.517,
      b: -2.498
    }
  }, {
    ral: 7042,
    name: 'TrafficGreyA',
    LRV: 28,
    cmyk: {
      c: 3,
      m: 0,
      y: 1,
      k: 43
    },
    rgb: {
      r: 142,
      g: 146,
      b: 145
    },
    lab: {
      l: 60.149,
      a: -1.676,
      b: 0.035
    }
  }, {
    ral: 7043,
    name: 'TrafficGreyB',
    LRV: 8,
    cmyk: {
      c: 4,
      m: 0,
      y: 2,
      k: 68
    },
    rgb: {
      r: 79,
      g: 82,
      b: 80
    },
    lab: {
      l: 34.565,
      a: -1.532,
      b: 0.596
    }
  }, {
    ral: 7044,
    name: 'SilkGrey',
    LRV: 45,
    cmyk: {
      c: 0,
      m: 2,
      y: 8,
      k: 29
    },
    rgb: {
      r: 182,
      g: 179,
      b: 168
    },
    lab: {
      l: 72.904,
      a: -0.082,
      b: 5.939
    }
  }, {
    ral: 7045,
    name: 'TeleGrey1',
    LRV: 29,
    cmyk: {
      c: 5,
      m: 2,
      y: 0,
      k: 42
    },
    rgb: {
      r: 142,
      g: 146,
      b: 149
    },
    lab: {
      l: 60.348,
      a: -1.428,
      b: -1.836
    }
  }, {
    ral: 7046,
    name: 'TeleGrey2',
    LRV: 23,
    cmyk: {
      c: 8,
      m: 3,
      y: 0,
      k: 46
    },
    rgb: {
      r: 127,
      g: 134,
      b: 138
    },
    lab: {
      l: 55.438,
      a: -1.833,
      b: -3.188
    }
  }, {
    ral: 7047,
    name: 'TeleGrey4',
    LRV: 58,
    cmyk: {
      c: 0,
      m: 0,
      y: 0,
      k: 22
    },
    rgb: {
      r: 200,
      g: 200,
      b: 199
    },
    lab: {
      l: 80.668,
      a: -0.266,
      b: 0.82
    }
  }, {
    ral: 7048,
    name: 'PearlmouseGrey',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 4,
      y: 10,
      k: 50
    },
    rgb: {
      r: 128,
      g: 123,
      b: 115
    },
    lab: {
      l: 51.991,
      a: 0.679,
      b: 5.105
    }
  }, {
    ral: 8000,
    name: 'GreenBrown',
    LRV: 16,
    cmyk: {
      c: 0,
      m: 21,
      y: 54,
      k: 47
    },
    rgb: {
      r: 134,
      g: 106,
      b: 62
    },
    lab: {
      l: 46.778,
      a: 7.583,
      b: 28.693
    }
  }, {
    ral: 8001,
    name: 'OchreBrown',
    LRV: 16,
    cmyk: {
      c: 0,
      m: 35,
      y: 72,
      k: 40
    },
    rgb: {
      r: 153,
      g: 99,
      b: 43
    },
    lab: {
      l: 47.08,
      a: 18.952,
      b: 39.867
    }
  }, {
    ral: 8002,
    name: 'SignalBrown',
    LRV: 10,
    cmyk: {
      c: 0,
      m: 35,
      y: 48,
      k: 53
    },
    rgb: {
      r: 119,
      g: 77,
      b: 62
    },
    lab: {
      l: 37.391,
      a: 16.881,
      b: 16.707
    }
  }, {
    ral: 8003,
    name: 'ClayBrown',
    LRV: 10,
    cmyk: {
      c: 0,
      m: 40,
      y: 69,
      k: 51
    },
    rgb: {
      r: 124,
      g: 75,
      b: 39
    },
    lab: {
      l: 37.148,
      a: 18.589,
      b: 30.287
    }
  }, {
    ral: 8004,
    name: 'CopperBrown',
    LRV: 11,
    cmyk: {
      c: 0,
      m: 47,
      y: 64,
      k: 46
    },
    rgb: {
      r: 138,
      g: 73,
      b: 49
    },
    lab: {
      l: 38.964,
      a: 26.631,
      b: 27.038
    }
  }, {
    ral: 8007,
    name: 'FawnBrown',
    LRV: 8,
    cmyk: {
      c: 0,
      m: 36,
      y: 61,
      k: 57
    },
    rgb: {
      r: 109,
      g: 70,
      b: 43
    },
    lab: {
      l: 33.824,
      a: 15.336,
      b: 23.6
    }
  }, {
    ral: 8008,
    name: 'OliveBrown',
    LRV: 9,
    cmyk: {
      c: 0,
      m: 33,
      y: 67,
      k: 56
    },
    rgb: {
      r: 111,
      g: 74,
      b: 37
    },
    lab: {
      l: 35.151,
      a: 13.225,
      b: 28.492
    }
  }, {
    ral: 8011,
    name: 'NutBrown',
    LRV: 5,
    cmyk: {
      c: 0,
      m: 36,
      y: 56,
      k: 65
    },
    rgb: {
      r: 88,
      g: 56,
      b: 39
    },
    lab: {
      l: 27.125,
      a: 13.264,
      b: 17.081
    }
  }, {
    ral: 8012,
    name: 'RedBrown',
    LRV: 5,
    cmyk: {
      c: 0,
      m: 49,
      y: 57,
      k: 61
    },
    rgb: {
      r: 100,
      g: 51,
      b: 43
    },
    lab: {
      l: 27.74,
      a: 22.005,
      b: 15.201
    }
  }, {
    ral: 8014,
    name: 'SepiaBrown',
    LRV: 4,
    cmyk: {
      c: 0,
      m: 26,
      y: 47,
      k: 72
    },
    rgb: {
      r: 72,
      g: 53,
      b: 38
    },
    lab: {
      l: 24.029,
      a: 7.289,
      b: 12.866
    }
  }, {
    ral: 8015,
    name: 'ChestnutBrown',
    LRV: 5,
    cmyk: {
      c: 0,
      m: 49,
      y: 58,
      k: 64
    },
    rgb: {
      r: 93,
      g: 47,
      b: 39
    },
    lab: {
      l: 25.491,
      a: 20.675,
      b: 15.127
    }
  }, {
    ral: 8016,
    name: 'MahoganyBrown',
    LRV: 3,
    cmyk: {
      c: 0,
      m: 43,
      y: 57,
      k: 71
    },
    rgb: {
      r: 75,
      g: 43,
      b: 32
    },
    lab: {
      l: 21.4,
      a: 14.371,
      b: 13.84
    }
  }, {
    ral: 8017,
    name: 'ChocolateBrown',
    LRV: 3,
    cmyk: {
      c: 0,
      m: 30,
      y: 39,
      k: 74
    },
    rgb: {
      r: 67,
      g: 47,
      b: 41
    },
    lab: {
      l: 21.544,
      a: 8.972,
      b: 7.368
    }
  }, {
    ral: 8019,
    name: 'GreyBrown',
    LRV: 4,
    cmyk: {
      c: 0,
      m: 11,
      y: 13,
      k: 76
    },
    rgb: {
      r: 61,
      g: 54,
      b: 53
    },
    lab: {
      l: 23.321,
      a: 2.993,
      b: 1.467
    }
  }, {
    ral: 8022,
    name: 'BlackBrown',
    LRV: 1,
    cmyk: {
      c: 0,
      m: 12,
      y: 4,
      k: 90
    },
    rgb: {
      r: 26,
      g: 23,
      b: 25
    },
    lab: {
      l: 8.139,
      a: 1.932,
      b: -0.585
    }
  }, {
    ral: 8023,
    name: 'OrangeBrown',
    LRV: 15,
    cmyk: {
      c: 0,
      m: 46,
      y: 74,
      k: 37
    },
    rgb: {
      r: 160,
      g: 87,
      b: 41
    },
    lab: {
      l: 45.42,
      a: 28.236,
      b: 39.65
    }
  }, {
    ral: 8024,
    name: 'BeigeBrown',
    LRV: 10,
    cmyk: {
      c: 0,
      m: 32,
      y: 53,
      k: 54
    },
    rgb: {
      r: 118,
      g: 80,
      b: 56
    },
    lab: {
      l: 38.036,
      a: 14.136,
      b: 20.822
    }
  }, {
    ral: 8025,
    name: 'PaleBrown',
    LRV: 11,
    cmyk: {
      c: 0,
      m: 23,
      y: 38,
      k: 55
    },
    rgb: {
      r: 115,
      g: 88,
      b: 71
    },
    lab: {
      l: 39.85,
      a: 9.63,
      b: 14.49
    }
  }, {
    ral: 8028,
    name: 'TerraBrown',
    LRV: 5,
    cmyk: {
      c: 0,
      m: 27,
      y: 47,
      k: 69
    },
    rgb: {
      r: 79,
      g: 58,
      b: 42
    },
    lab: {
      l: 26.58,
      a: 7.884,
      b: 13.812
    }
  }, {
    ral: 8029,
    name: 'Pearlcopper',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 49,
      y: 61,
      k: 51
    },
    rgb: {
      r: 125,
      g: 64,
      b: 49
    },
    lab: {
      l: 34.763,
      a: 26.058,
      b: 21.392
    }
  }, {
    ral: 9001,
    name: 'Cream',
    LRV: 75,
    cmyk: {
      c: 0,
      m: 3,
      y: 9,
      k: 9
    },
    rgb: {
      r: 231,
      g: 225,
      b: 210
    },
    lab: {
      l: 89.616,
      a: 0.594,
      b: 8.06
    }
  }, {
    ral: 9002,
    name: 'GreyWhite',
    LRV: 66,
    cmyk: {
      c: 0,
      m: 0,
      y: 5,
      k: 16
    },
    rgb: {
      r: 214,
      g: 213,
      b: 203
    },
    lab: {
      l: 85.07,
      a: -1.04,
      b: 5.18
    }
  }, {
    ral: 9003,
    name: 'SignalWhite',
    LRV: 83,
    cmyk: {
      c: 0,
      m: 0,
      y: 2,
      k: 7
    },
    rgb: {
      r: 236,
      g: 236,
      b: 231
    },
    lab: {
      l: 93.223,
      a: -0.644,
      b: 2.45
    }
  }, {
    ral: 9004,
    name: 'SignalBlack',
    LRV: 2,
    cmyk: {
      c: 2,
      m: 2,
      y: 0,
      k: 83
    },
    rgb: {
      r: 43,
      g: 43,
      b: 44
    },
    lab: {
      l: 17.464,
      a: 0.429,
      b: -0.837
    }
  }, {
    ral: 9005,
    name: 'JetBlack',
    LRV: 0,
    cmyk: {
      c: 12,
      m: 12,
      y: 0,
      k: 94
    },
    rgb: {
      r: 14,
      g: 14,
      b: 16
    },
    lab: {
      l: 4.041,
      a: 0.091,
      b: -0.873
    }
  }, {
    ral: 9006,
    name: 'WhiteAluminium',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 0,
      y: 1,
      k: 37
    },
    rgb: {
      r: 161,
      g: 161,
      b: 160
    },
    lab: {
      l: 66.321,
      a: -0.347,
      b: 0.545
    }
  }, {
    ral: 9007,
    name: 'GreyAluminium',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 1,
      y: 4,
      k: 47
    },
    rgb: {
      r: 134,
      g: 133,
      b: 129
    },
    lab: {
      l: 55.547,
      a: -0.061,
      b: 2.142
    }
  }, {
    ral: 9010,
    name: 'PureWhite',
    LRV: 84,
    cmyk: {
      c: 0,
      m: 1,
      y: 6,
      k: 6
    },
    rgb: {
      r: 240,
      g: 237,
      b: 225
    },
    lab: {
      l: 93.613,
      a: -0.425,
      b: 6.008
    }
  }, {
    ral: 9011,
    name: 'GraphiteBlack',
    LRV: 2,
    cmyk: {
      c: 9,
      m: 5,
      y: 0,
      k: 83
    },
    rgb: {
      r: 39,
      g: 41,
      b: 43
    },
    lab: {
      l: 16.572,
      a: -0.383,
      b: -1.735
    }
  }, {
    ral: 9016,
    name: 'TrafficWhite',
    LRV: 87,
    cmyk: {
      c: 0,
      m: 0,
      y: 3,
      k: 5
    },
    rgb: {
      r: 240,
      g: 241,
      b: 234
    },
    lab: {
      l: 94.843,
      a: -0.921,
      b: 3.28
    }
  }, {
    ral: 9017,
    name: 'TrafficBlack',
    LRV: 2,
    cmyk: {
      c: 0,
      m: 2,
      y: 0,
      k: 84
    },
    rgb: {
      r: 42,
      g: 41,
      b: 42
    },
    lab: {
      l: 16.521,
      a: 0.709,
      b: -0.582
    }
  }, {
    ral: 9018,
    name: 'PapyrusWhite',
    LRV: 59,
    cmyk: {
      c: 2,
      m: 0,
      y: 3,
      k: 20
    },
    rgb: {
      r: 199,
      g: 203,
      b: 196
    },
    lab: {
      l: 81.343,
      a: -2.293,
      b: 2.956
    }
  }, {
    ral: 9022,
    name: 'PearlLightGrey',
    LRV: 0,
    cmyk: {
      c: 0,
      m: 0,
      y: 2,
      k: 48
    },
    rgb: {
      r: 133,
      g: 133,
      b: 131
    },
    lab: {
      l: 55.474,
      a: -0.381,
      b: 1.165
    }
  }, {
    ral: 9023,
    name: 'PearlDarkGrey',
    LRV: 0,
    cmyk: {
      c: 2,
      m: 0,
      y: 0,
      k: 52
    },
    rgb: {
      r: 121,
      g: 123,
      b: 123
    },
    lab: {
      l: 51.274,
      a: -0.7,
      b: -0.279
    }
  }]
};
const {
  pantone,
  ral
} = colorLibrary;
exports.ral = ral;
exports.pantone = pantone;